function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Legend"
}, React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Bold",
  fontSize: 13,
  transform: "translate(0 544.953)"
}, "Population"), React.createElement("linearGradient", {
  id: "SVGID_1_",
  x1: 16,
  x2: 101.2,
  y1: -3560.3,
  y2: -3560.3,
  gradientTransform: "matrix(1 0 0 -1 0 -2992)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#5a67ae"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), React.createElement("path", {
  fill: "url(#SVGID_1_)",
  d: "M16 564.9h85.2v6.8H16z"
}), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(0 573.094)"
}, "91"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(104.393 573.094)"
}, "4.9 million"));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Texas_1_",
  fill: "#5a67ae",
  stroke: "#3a4a9f",
  strokeMiterlimit: 10
}, React.createElement("path", {
  d: "M285.9 422.6l30.8.4-.2-22.6-30.5.3z"
}), React.createElement("path", {
  d: "M285.9 422.6l30.8.4-.2-22.6-30.5.3z"
}), React.createElement("path", {
  d: "M314.8 491.1l1.2 4.3-.6 1.3.4 2.8-.9 1.4.2 2.1 1.4.3 1.6 2.1-.4 1.5 2.9 1.8-.3 1.3 2.6 1.9 1.1 2.6.1 2.1 1.4 1.1.4 3.3 1.3 4.2 7-5.1 2.5-5.4-.1-23.8-16.6-.2-1.6-2.2z"
}), React.createElement("path", {
  d: "M314.8 491.1l1.2 4.3-.6 1.3.4 2.8-.9 1.4.2 2.1 1.4.3 1.6 2.1-.4 1.5 2.9 1.8-.3 1.3 2.6 1.9 1.1 2.7.1 2 1.4 1.1.4 3.3 1.3 4.2 7-5.1 2.5-5.4-.1-23.8-16.6-.2-1.6-2.2z"
}), React.createElement("path", {
  d: "M336.7 179.9l.1 23 22.9.3.3-23.2z"
}), React.createElement("path", {
  d: "M336.7 179.9l.1 23 22.9.3.3-23.2z"
}), React.createElement("path", {
  d: "M156.7 202.8h20.6v-22.4h-20.2z"
}), React.createElement("path", {
  d: "M156.7 202.8h20.6v-22.4h-20.2z"
}), React.createElement("path", {
  d: "M481.9 215.3l7.7 5.9 5.7.1 4 2.3 1.4-.7 1 1.7 1.3-1.5.1-23.1-1 2.7h-21.5z"
}), React.createElement("path", {
  d: "M481.9 215.2l7.7 6 5.7.1 4 2.3 1.4-.7 1 1.7 1.3-1.5.1-23.1-1 2.7h-21.5z"
}), React.createElement("path", {
  d: "M381.9 200.6l22.8.6.7-23-23.4-.2z"
}), React.createElement("path", {
  d: "M381.9 200.6l22.8.6.7-23-23.4-.2z"
}), React.createElement("path", {
  d: "M145.2 270.5h23.2v-22.4h-11.6l-.1 4.4-11.4.1z"
}), React.createElement("path", {
  d: "M145.2 270.5h23.2v-22.4h-11.6l-.1 4.4-11.4.1z"
}), React.createElement("path", {
  d: "M360.6 399.3l9.5 11.6 20.2-17-5.7-6.6.8-1.2-10.7-.1-1.2.7-.9-3.9z"
}), React.createElement("path", {
  d: "M360.6 399.3l9.5 11.6 20.2-17-5.7-6.6.8-1.2-10.7-.1-1.2.7-.9-3.9z"
}), React.createElement("path", {
  d: "M376.2 323.1l2.6.7 1.5-.9 1.7 1.1.1 1.3 2.1 1.7.9 3.8 1.5 1.2 2.6.8.3-.9 7.5-2.6 2.1 1.3.7-.5 2.9 1.2 4.8 3 7.9-2.8-5.1-14.1-15.5-6.9-8.9-1.8-5.9 6.1z"
}), React.createElement("path", {
  d: "M376.2 323.1l2.6.7 1.5-.9 1.7 1.1.1 1.3 2.1 1.7.9 3.8 1.5 1.2 2.6.8.3-.9 7.5-2.6 2.1 1.3.7-.5 2.9 1.2 4.8 3 7.9-2.8-5.1-14.1-15.5-6.9-8.9-1.8-5.9 6.1z"
}), React.createElement("path", {
  d: "M380.3 523.2l-2.1 8 6.3.7v4.2l14.6 2.4.8-1.7 2.7.4 1.3-2.2-1.2-11.2-18.2.1z"
}), React.createElement("path", {
  d: "M380.3 523.2l-2.1 8 6.3.7v4.2l14.6 2.4.8-1.7 2.7.4 1.3-2.2-1.2-11.2-18.2.1z"
}), React.createElement("path", {
  d: "M336.7 156.9V137l-1.7-.5-2.2 1.2-2.3-.7-4.2-.2-.9-6.4-2.2-3.6-2.6-.3-2.4-2.6-.8.9-.2 3.5-1.5.3-1.8-1.4-.1 29.7z"
}), React.createElement("path", {
  d: "M336.7 156.9V137l-1.7-.5-2.2 1.2-2.3-.7-4.2-.2-.9-6.4-2.2-3.6-2.6-.3-2.4-2.6-.8.9-.2 3.5-1.5.3-1.8-1.4-.1 29.7z"
}), React.createElement("path", {
  d: "M359.9 156.8v-13l-2.8 1.1-3.2-3.8-2.2-1.2-1.6-.4-1.9 1.6-3.3-.1-2.9-1.4-1.2.7-4.1-3.3v19.9z"
}), React.createElement("path", {
  d: "M359.9 156.8v-13l-2.8 1.1-3.2-3.8-2.2-1.2-1.6-.4-1.9 1.6-3.3-.1-2.9-1.4-1.2.7-4.1-3.3v19.9z"
}), React.createElement("path", {
  d: "M267.3 85.3h23.6V61.9h-23.7z"
}), React.createElement("path", {
  d: "M267.3 85.3h23.6V61.9h-23.7z"
}), React.createElement("path", {
  d: "M437.9 392.6l14.5 14.2 15.1-9.2 5.1-5.8-1.2-.1-.7-2.3-2.6-1.3.5-.8-2.3-4.1-.7.3-2.2-2.3 1.4-1-1.2-.9.5-1.4-.7-2.4-2.5-1.8-2.6-.5-5.8 6-1.8 5.3z"
}), React.createElement("path", {
  d: "M437.9 392.6l14.5 14.2 15.1-9.2 5.1-5.8-1.2-.1-.7-2.3-2.6-1.3.5-.8-2.3-4.1-.7.2-2.2-2.2 1.4-1-1.2-.9.5-1.4-.7-2.4-2.5-1.8-2.6-.5-5.8 6-1.8 5.3z"
}), React.createElement("path", {
  d: "M288.4 450.3l1.6 1.2 1.3 3.7 2.6.6-.3 2 1.7 1.4-.1 2.3.9.8.4 2.7 1.7 1.6 2.7 1.5 1.9 2.6 1.6.5 2.3 2.1 2-.6.6 1.8 1-.6 2 2.5-.8 3.2 2.1.8-1 7-1.5 1.1 1.9.7-.1 1.6 1.9.3 3.6-2.6 1.6 2.2 23.5.3-.2-39-25.7 1.3-.2-8.6-35.8.3 2.3 1.5 3.2 1z"
}), React.createElement("path", {
  d: "M288.4 450.3l1.6 1.2 1.3 3.7 2.6.6-.3 2 1.7 1.4-.1 2.3.9.8.4 2.7 1.7 1.6 2.7 1.5 1.9 2.6 1.6.5 2.3 2.1 2-.6.6 1.8 1-.6 2 2.5-.8 3.2 2.1.8-1 7-1.5 1.1 1.9.7-.1 1.6 1.9.3 3.6-2.6 1.6 2.2 23.5.3-.2-39-25.7 1.3-.2-8.6-35.8.3 2.3 1.5 3.2 1z"
}), React.createElement("path", {
  d: "M431.2 346.6l1.2 1.1 5.2-.3 1.1 5.1 1.6-1.1h3l9.9-1.6 5.6 2.2.8-.8-2-3.4 1.4-.3-.2-3 3.1-1.2.3-3-3-2.3.2-2-2.2-.7-3.2 1.3-1.1-1.1-2.6.4-6 2.3-6.4 1.5-1.9 2.1-2.5 1.4v1.5z"
}), React.createElement("path", {
  d: "M431.2 346.6l1.2 1.1 5.2-.3 1.1 5.1 1.6-1.1h3l9.9-1.6 5.6 2.2.8-.8-2-3.4 1.4-.3-.2-3 3.1-1.2.3-3-3-2.3.2-2-2.2-.7-3.2 1.3-1.1-1.1-2.6.4-6 2.3-6.4 1.5-1.9 2.1-2.5 1.4v1.5z"
}), React.createElement("path", {
  d: "M132.8 270.5l2.1 1 1.4-.5 1.2 2.2v4.3l.7 3.1 1.8 1.6 2.3-.4 2.6.9 3.2-.6.7 1.9 2.8 1 5.1.2.6-1 5.2 1.8 4.7 4.3 2.5-1.4.1-18.4z"
}), React.createElement("path", {
  d: "M132.8 270.5l2.1 1 1.4-.5 1.2 2.2v4.3l.7 3.1 1.8 1.6 2.3-.4 2.6.9 3.2-.6.7 1.9 2.8 1 5.1.2.6-1 5.2 1.8 4.7 4.3 2.5-1.4.1-18.4z"
}), React.createElement("path", {
  d: "M459.6 351.2l1.2 1 1 4.5-1.6 1.4.2 1.7 1.5 1-1.3 2 .9 1.5 2.3.3.7 3.8h2.7l6.4-3-5.9-19 5.3 4.1 1.6-.3-.1-7.9-12.4.8-3.3 1.4.2 3-1.4.3z"
}), React.createElement("path", {
  d: "M459.6 351.2l1.2 1 1 4.5-1.6 1.4.2 1.7 1.5 1-1.3 2 .9 1.5 2.3.3.7 3.8h2.7l6.4-3-5.9-19 5.3 4.1 1.6-.3-.1-7.9-12.4.8-3.3 1.4.2 3-1.4.3z"
}), React.createElement("path", {
  d: "M472 310.8l1.4 12 10.1 6.1 10.5.2 1.4-18-3 .1.7-1.2-2.4-2.9v-6.2l-8 6.6-.5 1.5h-5.6l-1.2 1.1z"
}), React.createElement("path", {
  d: "M472 310.8l1.4 12 10.1 6.1 10.5.2 1.4-18-3 .1.7-1.2-2.4-2.9v-6.2l-8 6.6-.5 1.5h-5.6l-1.2 1.1z"
}), React.createElement("path", {
  d: "M408.8 411.8l.6.8 2.6-.9 2 1.7 1.2 2.8-1 8.3 1 2.8 2.4-.1.6 1 1.8-.7 3 2.5 2.5.5 1.5-.9-.6-2.9-1.2-1 3.4-2.5 5.7-1.7 2.7-1.6-.4-2.9-1.2-.9-.6-3.7-1.2-2.1-2.3-1.2-1.8-5.2-4.6-2.1-1.7-2z"
}), React.createElement("path", {
  d: "M408.8 411.8l.6.8 2.6-.9 2 1.7 1.2 2.8-1 8.3 1 2.8 2.4-.1.6 1 1.8-.7 3 2.5 2.5.5 1.5-.9-.6-2.9-1.2-1 3.4-2.5 5.7-1.7 2.7-1.6-.4-2.9-1.2-.9-.6-3.7-1.2-2.1-2.3-1.2-1.8-5.2-4.6-2.1-1.7-2z"
}), React.createElement("path", {
  d: "M462.6 209.1v25l27.5.1-4.6-5.1-1.8-1.4V217l-1.8-1.7-1 .4-1.9-1.6-4.1-1.7-2.5.2-3-2.3-.6-1.1z"
}), React.createElement("path", {
  d: "M462.6 209.1v25l27.5.1-4.6-5.1-1.8-1.4V217l-1.8-1.8-1 .5-1.9-1.6-4.1-1.7-2.5.2-3-2.3-.6-1.1z"
}), React.createElement("path", {
  d: "M213.8 365.7l2.2 1 5.9-.3 1.5-2.1.1 2.4 3.7-1.3.3 1.9 1.4.2 1.8 2.3.5 2.4 2.2-.3.6.9-.5 2.8.9.7 1.2-3 1 3.4-.9 1.4 3.8 1.1 1 1.9 4 .9 2.3 4.7 2.5.9 2.8 2 .4 1.4 3.6 1.9 2.1-.7.2-3.7 1.4-.5.5-4-.1-43.9h-46.3z"
}), React.createElement("path", {
  d: "M213.8 365.7l2.2 1 5.9-.3 1.5-2.1.1 2.4 3.7-1.3.3 1.9 1.4.2 1.8 2.3.5 2.4 2.2-.3.6.9-.5 2.8.9.7 1.2-3 1 3.4-.9 1.4 3.8 1.1 1 1.9 4 .9 2.3 4.7 2.5.9 2.8 2 .4 1.4 3.6 1.9 2.1-.7.2-3.7 1.4-.5.5-4-.1-43.9h-46.3z"
}), React.createElement("path", {
  d: "M286 373.7v27l30.5-.3.1-26.9z"
}), React.createElement("path", {
  d: "M286 373.7v27l30.5-.3.1-26.9z"
}), React.createElement("path", {
  d: "M189.4 270.5l.8 29 22.9.3.1-29.3z"
}), React.createElement("path", {
  d: "M189.4 270.5l.8 29 22.9.3.1-29.3z"
}), React.createElement("path", {
  d: "M503 223.1l.6 1 2-.4 2.3 1.3 2.9-.2 6.8-2.8 2.7-3.6 2.5.4-.2-11.8-.6-1.3-18.9.1z"
}), React.createElement("path", {
  d: "M503 223.1l.6 1 2-.4 2.3 1.3 2.9-.2 6.8-2.8 2.7-3.6 2.5.4-.2-11.8-.6-1.3-18.9.1z"
}), React.createElement("path", {
  d: "M528.9 300.9l-4.2 2.4 4.9 24.7 20.8.1-1-2.6 1.6-4-1.4-1.6-1.6.1-.1-3.1-1-2.3-1.3-.3-.5-3.4-1-1.9.6-1.5-1.9-2 .5-1.1-2.6-2.7-1.4 1.2-.9-1-3 .7-1.6 1.2-.3-1.6z"
}), React.createElement("path", {
  d: "M528.9 300.9l-4.2 2.4 4.9 24.7 20.8.1-1-2.6 1.6-4-1.4-1.6-1.6.1-.1-3.1-1-2.3-1.3-.3-.5-3.4-1-1.9.6-1.5-1.9-2 .5-1.1-2.6-2.7-1.4 1.2-.9-1-3 .7-1.6 1.2-.3-1.6z"
}), React.createElement("path", {
  d: "M495.4 311.1l.6-2 2.7-.4.9 1v2.3l1.4.9 11.4-11.1 4.2-5.4-1.4-5.3-1-.4-.2-3.8-2.6-.9.2-1.9-20.9 16.8v6.2l2.4 2.9-.7 1.2z"
}), React.createElement("path", {
  d: "M495.4 311.1l.6-2 2.7-.4.9 1v2.3l1.4.9 11.4-11.1 4.2-5.4-1.4-5.3-1-.4-.2-3.8-2.6-.9.2-1.9-20.9 16.8v6.2l2.4 2.9-.7 1.2z"
}), React.createElement("path", {
  d: "M391.1 353.5l2.7-2.2 6.8-7.2 5.4-10.6-3.3-2.2-2.9-1.2-.7.5-2.1-1.3-7.5 2.6-.3.9-2.6-.8-1.5-1.2-.9-3.8-2.1-1.7-.1-1.3-1.7-1.1-1.5.9-2.6-.7-2.9 6.3.9 1.6-3.4 5.7z"
}), React.createElement("path", {
  d: "M391.1 353.5l2.7-2.2 6.8-7.2 5.4-10.6-3.3-2.2-2.9-1.2-.7.5-2.1-1.3-7.5 2.6-.3.9-2.6-.8-1.5-1.2-.9-3.8-2.1-1.7-.1-1.3-1.7-1.1-1.5.9-2.6-.7-2.9 6.3.9 1.6-3.4 5.7z"
}), React.createElement("path", {
  d: "M235.4 276.8l25.1.3.2 22.4 25.1-.1.2-25.2-5.4-.1v-5.7l-25.8-.2-1.6-.4-.2 7.3-17.6.3z"
}), React.createElement("path", {
  d: "M235.4 276.8l25.1.3.2 22.4 25.1-.1.2-25.2-5.4-.1v-5.7l-25.8-.2-1.6-.4-.2 7.3-17.6.3z"
}), React.createElement("path", {
  d: "M504.2 198.9l1 .1 2.6-2 4.3-.2 3.6 3.6 1.9 1.2.5-19.9-3.5-1.7-1.1.6-7.9-.7-1.4.4z"
}), React.createElement("path", {
  d: "M504.2 198.9l1 .1 2.6-2 4.3-.2 3.6 3.6 1.9 1.2.5-19.9-3.5-1.7-1.1.6-7.9-.7-1.4.4z"
}), React.createElement("path", {
  d: "M314 202.9h22.8l-.1-23-22.7-.1z"
}), React.createElement("path", {
  d: "M314 202.9h22.8l-.1-23-22.7-.1z"
}), React.createElement("path", {
  d: "M177.3 202.8H200v-22.5l-22.7.1z"
}), React.createElement("path", {
  d: "M177.3 202.8H200v-22.5l-22.7.1z"
}), React.createElement("path", {
  d: "M189.3 360.8l5.5 2.1 3.5 2.3 2.9.3.5-.8 4.5.9 3.6-1.2 2 1.4 2-.1.1-25.6.8-1.6 3.6-1.8-3.6-3.4.6-2.5 1.2.7.8-3.2 1.5-1.5-.7-1.9.4-1.6-2.4-1.7-18.8-.2v3h-9v15.9l-9.8.1V352z"
}), React.createElement("path", {
  d: "M189.3 360.8l5.5 2.1 3.5 2.3 2.9.3.5-.8 4.5.9 3.6-1.2 2 1.4 2-.1.1-25.6.8-1.6 3.6-1.8-3.6-3.4.6-2.5 1.2.7.8-3.2 1.5-1.5-.7-1.9.4-1.6-2.4-1.7-18.8-.2v3h-9v15.9l-9.8.1V352z"
}), React.createElement("path", {
  d: "M284.2 248.3l22.8.1.1-22.8-22.6-.1z"
}), React.createElement("path", {
  d: "M284.2 248.3l22.8.1.1-22.8-22.6-.1z"
}), React.createElement("path", {
  d: "M398.1 223.8l22.4.4.3-22.7-22.4-.5z"
}), React.createElement("path", {
  d: "M398.1 223.8l22.4.4.3-22.7-22.4-.5z"
}), React.createElement("path", {
  d: "M203.4 108.5v23.1l23.1.1v-23.2z"
}), React.createElement("path", {
  d: "M203.4 108.5v23.1l23.1.1v-23.2z"
}), React.createElement("path", {
  d: "M248.8 340.1l37-.1v-21.3l-37 .2z"
}), React.createElement("path", {
  d: "M248.8 340.1l37-.1v-21.3l-37 .2z"
}), React.createElement("path", {
  d: "M284.6 202.8h6.8l-.1-22.9h-23.1v22.7z"
}), React.createElement("path", {
  d: "M284.6 202.8h6.8l-.1-22.9h-23.1v22.7z"
}), React.createElement("path", {
  d: "M254.8 268.2l.1-20.1h-19.4l-.1 27.3 17.6-.3.2-7.3z"
}), React.createElement("path", {
  d: "M254.8 268.2l.1-20.1h-19.4l-.1 27.3 17.6-.3.2-7.3z"
}), React.createElement("path", {
  d: "M353.2 225.9v-22.8l-22.8-.2v23z"
}), React.createElement("path", {
  d: "M353.2 225.9v-22.8l-22.8-.2v23z"
}), React.createElement("path", {
  d: "M327.3 525.8l.1 1.1 1.6.5 1.6 2.4-.8 2.5.7.7 2.4-.1 1.3 1 1.6-.4 1.2 1.5.7-1.1 1.5 1.9 3-.8 1.7 1.9h1.5l3.3 4 1.1.7 2.9-1.1 11.7-25.7-27.7-.1-2.5 5.4-7 5.1z"
}), React.createElement("path", {
  d: "M327.3 525.8l.1 1.1 1.6.5 1.6 2.4-.8 2.5.7.7 2.4-.1 1.3 1 1.6-.4 1.2 1.5.7-1.1 1.5 1.9 3-.8 1.7 1.9h1.5l3.3 4 1.1.7 2.9-1.1 11.7-25.7-27.7-.1-2.5 5.4-7 5.1z"
}), React.createElement("path", {
  d: "M380.8 240.5l3.5 7.6 10.3-6.2.7.2v-6l-7.4.1z"
}), React.createElement("path", {
  d: "M380.8 240.5l3.5 7.6 10.3-6.2.7.2v-6l-7.4.1z"
}), React.createElement("path", {
  d: "M490.1 234.2l.1 3.1-1.9 3.3 1.2 1.5-.7 2.9.8.6 20.8-.2-.1-20.6-2.4.2-2.3-1.3-2 .4-.6-1-1.3 1.5-1-1.7-1.4.7-4-2.3-5.7-.1-5.9-4.2v10.7l1.8 1.4z"
}), React.createElement("path", {
  d: "M490.1 234.2l.1 3.1-1.9 3.3 1.2 1.5-.7 2.9.8.6 20.8-.2-.1-20.6-2.4.2-2.3-1.3-2 .4-.6-1-1.3 1.5-1-1.7-1.4.7-4-2.3-5.7-.1-5.9-4.2v10.7l1.8 1.4z"
}), React.createElement("path", {
  d: "M196.2 38.3h23.6V14.2l-23.6-.1z"
}), React.createElement("path", {
  d: "M196.2 38.3h23.6V14.2l-23.6-.1z"
}), React.createElement("path", {
  d: "M531.1 253.9v2.6l1.4 1.1 2.4 5.3.4 4.8.7 2.7 13.5 1.7 4.7 2.6 3.8-2.1 2.7 1.3.7-1.5-.1-3 1.2-1.5-1.9-2.4.7-1.3-2.3-2.5-1-3.2-1.4-1.4-1.8-.4-2-3.1z"
}), React.createElement("path", {
  d: "M531.1 253.9v2.6l1.4 1.1 2.4 5.3.4 4.8.7 2.7 13.5 1.7 4.7 2.6 3.8-2.1 2.7 1.3.7-1.5-.1-3 1.2-1.5-1.9-2.4.7-1.3-2.3-2.5-1-3.2-1.4-1.4-1.8-.4-2-3.1z"
}), React.createElement("path", {
  d: "M307.9 202.9h22.6v23h-22.6z"
}), React.createElement("path", {
  d: "M307.9 202.9h22.6v23h-22.6z"
}), React.createElement("path", {
  d: "M262 225.4l.2-22.8-16.8-.4-5.9.4v22.7z"
}), React.createElement("path", {
  d: "M262 225.4l.2-22.8-16.8-.4-5.9.4v22.7z"
}), React.createElement("path", {
  d: "M248.8 318.9l37-.2v-19.3l-37 .3z"
}), React.createElement("path", {
  d: "M248.8 318.9l37-.2v-19.3l-37 .3z"
}), React.createElement("path", {
  d: "M336.2 307.9h22.7l1.4-1-1.4-.5-.6-2.9.9-1.1-2-1.9 1.3-2.1-2-.5-1 1.5-1.1-1.9 1.8-2.1-2.7-1.6.3-1.7-2.8-2.6 1.2-.3.6-1.8-2.5.4-.5-2.3-2.6.6.7-3.1-1.9.1-1.7 1.5.2-1.8-3.5-.1-.6-1.5-2.8.3-2.7-1.4.1-1-1.2.8-1-1.1-2.1 1.5-.1 27.6z"
}), React.createElement("path", {
  d: "M336.2 307.9h22.7l1.4-1-1.4-.5-.6-2.9.9-1.1-2-1.9 1.3-2.1-2-.5-1 1.5-1.1-1.9 1.8-2.1-2.7-1.6.3-1.7-2.8-2.6 1.2-.3.6-1.8-2.5.4-.5-2.3-2.6.6.7-3.1-1.9.1-1.7 1.5.2-1.8-3.5-.1-.6-1.5-2.8.3-2.7-1.4.1-1-1.2.8-1-1.1-2.1 1.5-.1 27.6z"
}), React.createElement("path", {
  d: "M383.5 452l.7.8 2.9.1.1 2.1-.4 2.7 5.1 1.2.7 1.7 1.7.9 1.2-1.3.9 1.7 2.7.5 8.6-1.3-1 1.1 4.5-1.3 1.7 2.8 2.4-2.6.9-1.6-5.4-8.4-2.5-3.1-1.2.9-3.6.1.2-1.2-2.1-.6-.2-1.2-2 1.3-.9-.7-1.2 1.8-10.9-2.4-3.8 3.1z"
}), React.createElement("path", {
  d: "M383.5 452l.7.8 2.9.1.1 2.1-.4 2.7 5.1 1.2.7 1.7 1.7.9 1.2-1.3.9 1.7 2.7.5 8.6-1.3-1 1.1 4.5-1.3 1.7 2.8 2.4-2.6.9-1.6-5.4-8.4-2.5-3.1-1.2.9-3.6.1.2-1.2-2.1-.6-.2-1.2-2 1.3-.9-.7-1.2 1.8-10.9-2.4-3.8 3.1z"
}), React.createElement("path", {
  d: "M502.5 337.2l14.1-7.2-1.1-1.2 1.7-1.5-4.9-.9-1.1-.9-2.7-.1.9-1.4-2.1-3.8-2.2 1.1-.2-1.7-1.1-.1-.4-2.5.6-2-4.4-3v-2.3l-.9-1-2.7.4-.6 2-1.4 18 2.3 5.1 3.1 1.4 1.4 1.4-.9 1.5z"
}), React.createElement("path", {
  d: "M502.5 337.2l14.1-7.2-1.1-1.2 1.7-1.5-4.9-.9-1.1-.9-2.7-.1.9-1.4-2.1-3.8-2.2 1.1-.2-1.7-1.1-.1-.4-2.5.6-2-4.4-3v-2.3l-.9-1-2.7.4-.6 2-1.4 18 2.3 5.1 3.1 1.4 1.4 1.4-.9 1.5z"
}), React.createElement("path", {
  d: "M536 270.4l3.9 3.3.5 3.2-.9 4.2.6 1.2-1.1 3.2.7 2.8-1.1 2.1.6 2 2.8 2.3 1.7.2 1.4 2.1 2.7 1.8 3.6-.8.4-1-.4-.5.8-4.9-.8-2.8 1.1-3.5-.9-2.4 2.6-2.8v-5.4l-4.7-2.6z"
}), React.createElement("path", {
  d: "M536 270.4l3.9 3.3.5 3.2-.9 4.2.6 1.2-1.1 3.2.7 2.8-1.1 2.1.6 2 2.8 2.3 1.7.2 1.4 2.1 2.7 1.8 3.6-.8.4-1-.4-.5.8-4.9-.8-2.8 1.1-3.5-.9-2.4 2.6-2.8v-5.4l-4.7-2.6z"
}), React.createElement("path", {
  d: "M557.4 295.8l13.6-.9.1-2.8-3.9-4.1.8-2.8-.2-1.6-1.4-.7.6-1.4-2.5-1.6 1.6-2.3-3.2-.6-2.2-3.1-2.7-1.3-3.8 2.1v5.4l-2.6 2.8.9 2.4-1.1 3.5.8 2.8-.8 4.9.4.5z"
}), React.createElement("path", {
  d: "M557.4 295.8l13.6-.9.1-2.8-3.9-4.1.8-2.8-.2-1.6-1.4-.7.6-1.4-2.5-1.6 1.6-2.3-3.2-.6-2.2-3.1-2.7-1.3-3.8 2.1v5.4l-2.6 2.8.9 2.4-1.1 3.5.8 2.8-.8 4.9.4.5z"
}), React.createElement("path", {
  d: "M510.4 233.4v27.1l23.3.1-1.2-3-1.4-1.1v-2.6l-3.9.1v-5.6l.9-4.1v-2.1l2.2-3.7 1.6-4.4.1-1.9-2.9-.7-1 .7-.9 1.8-1.6-.6z"
}), React.createElement("path", {
  d: "M510.4 233.4v27.1l23.3.1-1.2-3-1.4-1.1v-2.6l-3.9.1v-5.6l.9-4.1v-2.1l2.2-3.7 1.6-4.4.1-1.9-2.9-.7-1 .7-.9 1.8-1.6-.6z"
}), React.createElement("path", {
  d: "M286 274.2l17.1.2.3-26.1h-22.8v25.8z"
}), React.createElement("path", {
  d: "M286 274.2l17.1.2.3-26.1h-22.8v25.8z"
}), React.createElement("path", {
  d: "M443.2 210.4h9.7l.1-8.8h-9.7z"
}), React.createElement("path", {
  d: "M443.2 210.4h9.7l.1-8.8h-9.7z"
}), React.createElement("path", {
  d: "M429.7 298.5l3.6 5.8-1.1 1 .7 2.3 1.3 1.5 1.2-.5.1 2.2 2.4 2.4-.1 2 1.3 1-.3 1.4 2.3 1.8 4.8-2.4 3.1-6.1 2.2-3 4.2-2.6-.8-2.2.7-2.3-1.6-1.7-.8-4.4-1.4-3.7.5-5.4z"
}), React.createElement("path", {
  d: "M429.7 298.5l3.6 5.8-1.1 1 .7 2.3 1.3 1.5 1.2-.5.1 2.2 2.4 2.4-.1 2 1.3 1-.3 1.4 2.3 1.8 4.8-2.4 3.1-6.1 2.2-3 4.2-2.6-.8-2.2.7-2.3-1.6-1.7-.8-4.4-1.4-3.7.5-5.4z"
}), React.createElement("path", {
  d: "M243.3 61.5v.4h23.9V38.2h-23.8z"
}), React.createElement("path", {
  d: "M243.3 61.5v.4h23.9V38.2h-23.8z"
}), React.createElement("path", {
  d: "M410.8 451.1l.8.6 9-6.9-2.9-1.2-.9-2.3 14.6-2.3-3-4.9 3.3.8-.1-2.3-1 .8-3.6-3.8-1.5.9-2.5-.5-3-2.5-1.8.7-.6-1-2.4.1-9.5 8.2-7.2 11.1.9.7 2-1.3.2 1.2 2.1.6-.2 1.2 3.6-.1 1.2-.9z"
}), React.createElement("path", {
  d: "M410.8 451.1l.8.6 9-6.9-2.9-1.2-.9-2.3 14.6-2.3-3-4.9 3.3.8-.1-2.3-1 .8-3.6-3.8-1.5.9-2.5-.5-3-2.5-1.8.7-.6-1-2.4.1-9.5 8.2-7.2 11.1.9.7 2-1.3.2 1.2 2.1.6-.2 1.2 3.6-.1 1.2-.9z"
}), React.createElement("path", {
  d: "M134 315.8l25.1-30.9-1.8-.7-.6 1-5.1-.2-2.8-1-.7-1.9-3.2.6-2.6-.9-2.3.4-1.8-1.6-.7-3.1v-4.3l-1.2-2.2-1.4.5-2.1-1-.6-2.7-1.9-.6-1-1.6-2.7.3-1.9-1.5-.7-3.9-1.2-2.2-2 1.1-2.9-6.2-1.2-.6h-2l-3.4 45.9z"
}), React.createElement("path", {
  d: "M134 315.8l25.1-30.9-1.8-.7-.6 1-5.1-.2-2.8-1-.7-1.9-3.2.6-2.6-.9-2.3.4-1.8-1.6-.7-3.1v-4.3l-1.2-2.2-1.4.5-2.1-1-.6-2.7-1.9-.6-1-1.6-2.7.3-1.9-1.5-.7-3.9-1.2-2.2-2 1.1-2.9-6.2-1.2-.6h-2l-3.4 45.9z"
}), React.createElement("path", {
  d: "M496.2 180.8l2.3.6 7.1-1.5 7.9.7 1.1-.6 3.5 1.7 1.5 2.3 1.2-.5v-19.7l-1.1-3-1.3 1.5-.9-1.9-1.2 1.5-2.7-2-.5-1.6-1.3-.4-.7-2.4-3.5-.1-.5-2-1 1.1-1.5-1.3-.5-1.7h-1.2l-2.8-1.3-2.2 2.6-.5 1.9h-1.3z"
}), React.createElement("path", {
  d: "M496.2 180.8l2.3.6 7.1-1.5 7.9.7 1.1-.6 3.5 1.7 1.5 2.3 1.2-.5v-19.7l-1.1-3-1.3 1.5-.9-1.9-1.2 1.5-2.7-2-.5-1.6-1.3-.4-.7-2.4-3.5-.1-.5-2-1 1.1-1.5-1.3-.5-1.7h-1.2l-2.8-1.3-2.2 2.6-.5 1.9h-1.3z"
}), React.createElement("path", {
  d: "M290.3 373.7l18-.2v-14.1l-3.9-.1.1-8.3h-10l-2.2-.5-.2 3-.8-.1-.5 6.5-1.4 2.7.9 2.4-1 1 .5 2.6-1.7.7 2 1.7z"
}), React.createElement("path", {
  d: "M290.3 373.7l18-.2v-14.1l-3.9-.1.1-8.3h-10l-2.2-.5-.2 3-.8-.1-.5 6.5-1.4 2.7.9 2.4-1 1 .5 2.6-1.7.7 2 1.7z"
}), React.createElement("path", {
  d: "M213.1 299.8l22 .1.3-29.3-22.2-.1z"
}), React.createElement("path", {
  d: "M213.1 299.8l22 .1.3-29.3-22.2-.1z"
}), React.createElement("path", {
  d: "M195.9 108.6l23.7-.1.2-23.2H196z"
}), React.createElement("path", {
  d: "M195.9 108.6l23.7-.1.2-23.2H196z"
}), React.createElement("path", {
  d: "M468.8 209.2l.6 1.1 3 2.3 2.5-.2 4.1 1.7 1.9 1.6 1-.4-1.4-13.6h-12.1l-1.9 5.4z"
}), React.createElement("path", {
  d: "M468.8 209.2l.6 1.1 3 2.3 2.5-.2 4.1 1.7 1.9 1.6 1-.5-1.4-13.5h-12.1l-1.9 5.4z"
}), React.createElement("path", {
  d: "M77.7 330.5l.5 4.4 1.9.9-.3 1.2 2.1 2.4.5 1.4 2.5 2 .8 2.9-.4 2.2.4 3.1-.8 1.2 1.4 4.7-.4 1.1 5.1 8.3 1 4.5 3.4 3.6 2.9 1.8 2.7 2.7 3.2.3 2.4 1.7-.3 1.2 2.4 3.3 2.4.9 3.8 3.1 9 1.9 1 .6-.4-58.1h-4.4l-47.2-11 .3 1 2.4.6 1.6 3.3z"
}), React.createElement("path", {
  d: "M77.7 330.5l.5 4.4 1.9.9-.3 1.2 2.1 2.4.5 1.4 2.5 2 .8 2.9-.4 2.2.4 3.1-.8 1.2 1.4 4.7-.4 1.1 5.1 8.3 1 4.5 3.4 3.6 2.9 1.8 2.7 2.7 3.2.3 2.4 1.7-.3 1.2 2.4 3.3 2.4.9 3.8 3.1 9 1.9 1 .6-.4-58.1h-4.4l-47.2-11 .3 1 2.4.6 1.6 3.3z"
}), React.createElement("path", {
  d: "M219.8 85.3V61.8h-23.6l-.2 23.5z"
}), React.createElement("path", {
  d: "M219.8 85.3V61.8h-23.6l-.2 23.5z"
}), React.createElement("path", {
  d: "M501 312.9l3 2.1-.6 2 .4 2.5 1.1.1.2 1.7 2.2-1.1 2.1 3.8-.9 1.4 2.7.1 1.1.9 4.9.9-1.7 1.5.8.9 13.7.1-5.3-26.5 4.2-2.4-2.3-1.3-5.4-1-4.6-2.2-4.2 5.4z"
}), React.createElement("path", {
  d: "M501 312.9l3 2.1-.6 2 .4 2.5 1.1.1.2 1.7 2.2-1.1 2.1 3.8-.9 1.4 2.7.1 1.1.9 4.9.9-1.7 1.5.8.9 13.7.1-5.3-26.5 4.2-2.4-2.3-1.3-5.4-1-4.6-2.2-4.2 5.4z"
}), React.createElement("path", {
  d: "M134 315.8l44.5 36.2v-11.6l9.8-.1v-15.9h9v-3l16.2.2-1.8-2.5-.3-2.5-1.9-6.2-1.4-.9.7-1.1-5.1-3.9-1.8-.5-2 .6-2.7-.4-2.7-1.9-3.4-.1-2.2-1.8-2.6-.9-1.7-2v-3.3l-1.2-1.7-2.8-2-2.6-.5-4.3-2.8-6.5 3.1-4.7-4.3-3.4-1.1z"
}), React.createElement("path", {
  d: "M134 315.8l44.5 36.2v-11.6l9.8-.1v-15.9h9v-3l16.2.2-1.8-2.5-.3-2.5-1.9-6.2-1.4-.9.7-1.1-5.1-3.9-1.8-.5-2 .6-2.7-.4-2.7-1.9-3.4-.1-2.2-1.8-2.6-.9-1.7-2v-3.3l-1.2-1.7-2.8-2-2.6-.5-4.3-2.8-6.5 3.1-4.7-4.3-3.4-1.1z"
}), React.createElement("path", {
  d: "M157.6 131.6h22.7v-23l-22.6-.1z"
}), React.createElement("path", {
  d: "M157.6 131.6h22.7v-23l-22.6-.1z"
}), React.createElement("path", {
  d: "M375.5 223.6l22.6.2.3-22.8-22.4-.5z"
}), React.createElement("path", {
  d: "M375.5 223.6l22.6.2.3-22.8-22.4-.5z"
}), React.createElement("path", {
  d: "M552.8 253.6l-1.2-1v-20.3l-13.3 3.2-1.7-1.9-2.4.3-2.2-1.7-.1 1.9-1.6 4.4-2.2 3.7v2.1l-.9 4.1v5.6z"
}), React.createElement("path", {
  d: "M552.8 253.6l-1.2-1v-20.3l-13.3 3.2-1.7-1.9-2.4.3-2.2-1.7-.1 1.9-1.6 4.4-2.2 3.7v2.1l-.9 4.1v5.6z"
}), React.createElement("path", {
  d: "M357.6 226l17.8.1.6-25.6-16.3-.2v2.9l-6.5-.1v22.8z"
}), React.createElement("path", {
  d: "M357.6 226l17.8.1.6-25.6-16.3-.2v2.9l-6.5-.1v22.8z"
}), React.createElement("path", {
  d: "M548.4 342.5l1 1.9-1 2.2 1.8 2.4-.8 1.5 2.7 1.1v1.7l3.3.8 1.1 1.1 2.6.5 5.1-1.8 1.5-1.8 1-.4-1.5-1.2 1.8-2.6-1.3-3.8.6-1.7z"
}), React.createElement("path", {
  d: "M548.4 342.5l1 1.9-1 2.2 1.8 2.4-.8 1.5 2.7 1.1v1.7l3.3.8 1.1 1.1 2.6.5 5.1-1.8 1.5-1.8 1-.4-1.5-1.2 1.8-2.6-1.3-3.8.6-1.7z"
}), React.createElement("path", {
  d: "M157.7 85.3H196l.2-23.9-38.5.3z"
}), React.createElement("path", {
  d: "M157.7 85.3H196l.2-23.9-38.5.3z"
}), React.createElement("path", {
  d: "M243.4 38.2h23.5l.1-24h-23.6z"
}), React.createElement("path", {
  d: "M243.4 38.2h23.5l.1-24h-23.6z"
}), React.createElement("path", {
  d: "M411.4 475.5l1 .3 3.2-6.3 4.6-6.5-2.1 1.2-4.5 6.3z"
}), React.createElement("path", {
  d: "M381 472.8l2.3.8 2.1 3.1 22.6-.2 3.5-6.5-5.1-2.1-1-5.1-9-.9-.9-1.7-1.2 1.3-1.7-.9-.7-1.7-5.1-1.2.4-2.7-5.9 5.5z"
}), React.createElement("path", {
  d: "M411.4 475.5l1 .3 3.2-6.3 4.6-6.5-2.1 1.2-4.5 6.3z"
}), React.createElement("path", {
  d: "M381 472.8l2.3.8 2.1 3.1 22.6-.2 3.5-6.5-5.1-2.1-1-5.1-9-.9-.9-1.7-1.2 1.3-1.7-.9-.7-1.7-5.1-1.2.4-2.7-5.9 5.5z"
}), React.createElement("path", {
  d: "M261.8 248.2l22.4.1.3-22.8-22.5-.1z"
}), React.createElement("path", {
  d: "M261.8 248.2l22.4.1.3-22.8-22.5-.1z"
}), React.createElement("path", {
  d: "M557.8 342.4h8.5l.1-2.4-1.6-.5-.9-2.7.9-2.5 1.9-2.1-1.5-4.4.2-2.2 2.2-1.2-.2-2.2 2.2-1.9 1.1-1.9-.3-2 2.6-4.1-.2-4 1.4-.8-.2-1.4-1.6-.6.5-1.8 2.1-1.3-.8-2.3-1.6-1.1 1.1-1-.6-3.6-2.1.5-13.6.9 2 10.8z"
}), React.createElement("path", {
  d: "M557.8 342.4h8.5l.1-2.4-1.6-.5-.9-2.7.9-2.5 1.9-2.1-1.5-4.4.2-2.2 2.2-1.2-.2-2.2 2.2-1.9 1.1-1.9-.3-2 2.6-4.1-.2-4 1.4-.8-.2-1.4-1.6-.6.5-1.8 2.1-1.3-.8-2.3-1.6-1.1 1.1-1-.6-3.6-2.1.5-13.6.9 2 10.8z"
}), React.createElement("path", {
  d: "M434.5 262.1l9.7 1 19.4-11.2-.6-3.8-1.6.6-.6-1 .7-2.9-2.8-.4.5-2.9-1.7.6-1.8-2.5-2.2-.2-.2-2-4.1-1.8-22.5 13.2z"
}), React.createElement("path", {
  d: "M434.5 262.1l9.7 1 19.4-11.2-.6-3.8-1.6.6-.6-1 .7-2.9-2.8-.4.5-2.9-1.7.6-1.8-2.5-2.2-.2-.2-2-4.1-1.8-22.5 13.2z"
}), React.createElement("path", {
  d: "M515.6 276.9l1.8 2.2.8-.3 5.3 2 5.7.8.8 1.9 1.5-.6 2.3 4.6 2.4.9.5 1.5 2.5 2.5-.6-2 1.1-2.1-.7-2.8 1.1-3.2-.6-1.2.9-4.2-.5-3.2-3.9-3.3-.7-2.7-.4-4.8-1.2-2.3-21.2-.1-1.7 3.3 2.2 1-1.8.5v3l1.9 5.9z"
}), React.createElement("path", {
  d: "M515.6 276.9l1.8 2.2.8-.3 5.3 2 5.7.8.8 1.9 1.5-.6 2.3 4.6 2.4.9.5 1.5 2.5 2.5-.6-2 1.1-2.1-.7-2.8 1.1-3.2-.6-1.2.9-4.2-.5-3.2-3.9-3.3-.7-2.7-.4-4.8-1.2-2.3-21.2-.1-1.7 3.3 2.2 1-1.8.5v3l1.9 5.9z"
}), React.createElement("path", {
  d: "M245.3 131.7V157l22.9-.1v-25.3z"
}), React.createElement("path", {
  d: "M245.3 131.7V157l22.9-.1v-25.3z"
}), React.createElement("path", {
  d: "M522 205.7l.6 1.3h2.3l.1-20.4-1.8-2.3-1.7.2-.7-1-1.2.5-1.5-2.3-.5 19.9 2.2 2.9z"
}), React.createElement("path", {
  d: "M522 205.7l.6 1.3h2.3l.1-20.4-1.8-2.3-1.7.2-.7-1-1.2.5-1.5-2.3-.5 19.9 2.2 2.9z"
}), React.createElement("path", {
  d: "M196.2 38.3v23.5h23.6V38.3z"
}), React.createElement("path", {
  d: "M196.2 38.3v23.5h23.6V38.3z"
}), React.createElement("path", {
  d: "M474.5 342.3l.1 7.9 1.8.1 4-.7 2.1-1.8h1.4l1.8-1.7 2.2 1.4 1.1 2 2.1-.6.7 1.1 2.6.9 1.7 2 2.1.1 7.3-6.7-3-9.1-2.6 1.3.9-1.5-1.4-1.4-3.1-1.4-2.4-5.3h-10.4l-10.1-6.1z"
}), React.createElement("path", {
  d: "M474.5 342.3l.1 7.9 1.8.1 4-.7 2.1-1.8h1.4l1.8-1.7 2.2 1.4 1.1 2 2.1-.6.7 1.1 2.6.9 1.7 2 2.1.1 7.3-6.7-3-9.1-2.6 1.3.9-1.5-1.4-1.4-3.1-1.4-2.4-5.3h-10.4l-10.1-6.1z"
}), React.createElement("path", {
  d: "M382 178h18.9l.1-25.4-3.4.9-1.2-.2v-2.6l-3.2-2-1.1.2-2 2.6-1.3.2-3.1 4-1.7.4-4.6-2.1-.1 24z"
}), React.createElement("path", {
  d: "M382 178h18.9l.1-25.4-3.4.9-1.2-.2v-2.6l-3.2-2-1.1.2-2 2.6-1.3.2-3.1 4-1.7.4-4.6-2.1-.1 24z"
}), React.createElement("path", {
  d: "M254.9 248.1l6.9.1.2-22.8-22.5-.1-.4 22.8z"
}), React.createElement("path", {
  d: "M254.9 248.1l6.9.1.2-22.8-22.5-.1-.4 22.8z"
}), React.createElement("path", {
  d: "M335 279.1l-.1 1 2.7 1.4 2.8-.3.6 1.5 3.5.1-.2 1.8 1.7-1.5 1.9-.1-.7 3.1 2.6-.6.5 2.3 2.5-.4-.6 1.8-1.2.3 2.8 2.6 12.9-9.2-9.8-16.1-11.7 1.9-.9 3.9z"
}), React.createElement("path", {
  d: "M335 279.1l-.1 1 2.7 1.4 2.8-.3.6 1.5 3.5.1-.2 1.8 1.7-1.5 1.9-.1-.7 3.1 2.6-.6.5 2.3 2.5-.4-.6 1.8-1.2.3 2.8 2.6 12.9-9.2-9.8-16.1-11.7 1.9-.9 3.9z"
}), React.createElement("path", {
  d: "M408.4 316.5l1.9.9 5.1 14.1 23.4-13.9.3-1.4-1.3-1 .1-2-2.4-2.4-.1-2.2-1.2.5-1.3-1.5-.7-2.3 1.1-1-3.6-6.1-18.8 11.3z"
}), React.createElement("path", {
  d: "M408.4 316.5l1.9.9 5.1 14.1 23.4-13.9.3-1.4-1.3-1 .1-2-2.4-2.4-.1-2.2-1.2.5-1.3-1.5-.7-2.3 1.1-1-3.6-6.1-18.8 11.3z"
}), React.createElement("path", {
  d: "M213.2 270.5l-.1-22.4h-22.3v22.4z"
}), React.createElement("path", {
  d: "M213.2 270.5l-.1-22.4h-22.3v22.4z"
}), React.createElement("path", {
  d: "M313.5 318.7l-.1-11.8h-5.2v-7.4l-22.4-.1v19.3z"
}), React.createElement("path", {
  d: "M313.5 318.7l-.1-11.8h-5.2v-7.4l-22.4-.1v19.3z"
}), React.createElement("path", {
  d: "M343.2 400.5l-.1-30.2-5.3 6.5-2.5-.1.1-3-18.8-.2-.1 26.9z"
}), React.createElement("path", {
  d: "M343.2 400.5l-.1-30.2-5.3 6.5-2.5-.1.1-3-18.8-.2-.1 26.9z"
}), React.createElement("path", {
  d: "M343.3 452l20.5-.1-.1-29.3h-20.3z"
}), React.createElement("path", {
  d: "M343.3 452l20.5-.1-.1-29.3h-20.3z"
}), React.createElement("path", {
  d: "M395.7 273.8l8.2 13.7 3.3 3.9 23.7-14.2-10.3-17.6z"
}), React.createElement("path", {
  d: "M395.7 273.8l8.2 13.7 3.3 3.9 23.7-14.2-10.3-17.6z"
}), React.createElement("path", {
  d: "M313.4 306.9h17.2l.1-26.6-4.9-.3-1.7-.8-3.2 3.7-5.9-3.1.5 1.3-3.3 1.1-1.1-3-2.8-.5-.1 28.2z"
}), React.createElement("path", {
  d: "M313.4 306.9h17.2l.1-26.6-4.9-.3-1.7-.8-3.2 3.7-5.9-3.1.5 1.3-3.3 1.1-1.1-3-2.8-.5-.1 28.2z"
}), React.createElement("path", {
  d: "M262.5 408l2.5 2.5.9 3.2 1.1.1.5 3.1 1.2 1.1.3 3.9 2.4 1.1-.1 1.5 2.1 1.2-.5 1.6 1 2 2.3.7-1.4 1 1.4 2.4-.6 1.5 2.6 4.2-.2 1.9 1.6 1.9 1.5.2.5 1.9h4.3l.1-44.3-24.3.1.9 4.9z"
}), React.createElement("path", {
  d: "M262.5 408l2.5 2.5.9 3.2 1.1.1.5 3.1 1.2 1.1.3 3.9 2.4 1.1-.1 1.5 2.1 1.2-.5 1.6 1 2 2.3.7-1.4 1 1.4 2.4-.6 1.5 2.6 4.2-.2 1.9 1.6 1.9 1.5.2.5 1.9h4.3l.1-44.3-24.3.1.9 4.9z"
}), React.createElement("path", {
  d: "M480.3 417.5h.8l6.4-3.8-2.6-.2-1-2-2.2-1.7-.2-1.7-1.4-1.3-3.9-.2-.8-3.6.7-.7-3.4-2.7.1-4.8-1.3-1.3-4 4.1-15.1 9.2-.6 16.1 5.1-2.8-1.2 2.8 3.6 1.4 5-1.9 2.1 2.5-6.8 2.9-8.3 5.2 16.4-8.8 1.6-4.3 6.1-2.3 4.7-.1-10.4 5.5 5.7-2z"
}), React.createElement("path", {
  d: "M480.3 417.5h.8l6.4-3.8-2.6-.2-1-2-2.2-1.7-.2-1.7-1.4-1.3-3.9-.2-.8-3.6.7-.7-3.4-2.7.1-4.8-1.3-1.3-4 4.1-15.1 9.2-.6 16.1 5.1-2.8-1.2 2.8 3.6 1.4 5-1.9 2.1 2.5-6.8 2.9-8.3 5.2 16.4-8.8 1.6-4.3 6.1-2.3 4.7-.1-10.4 5.5 5.7-2z"
}), React.createElement("path", {
  d: "M313.4 306.9v22.5l22.8.1v-21.6h-5.6v-1z"
}), React.createElement("path", {
  d: "M313.4 306.9v22.5l22.8.1v-21.6h-5.6v-1z"
}), React.createElement("path", {
  d: "M194.1 248.1h22.6l.3-22.7-22.9.1z"
}), React.createElement("path", {
  d: "M194.1 248.1h22.6l.3-22.7-22.9.1z"
}), React.createElement("path", {
  d: "M522.8 211.5l8.5 5.1 5.4.1 3.8-1.6.9-1.4h1.5l.9 2.4 2 .5 1.4-2.5 1.9.2.4 2.6 2.1-.2v-9.8l-29 .1z"
}), React.createElement("path", {
  d: "M522.8 211.5l8.5 5.1 5.4.1 3.8-1.6.9-1.4h1.5l.9 2.4 2 .5 1.4-2.5 1.9.2.4 2.6 2.1-.2v-9.8l-29 .1z"
}), React.createElement("path", {
  d: "M458.6 312.9l13.4-2.1 3.4-.7 1.2-1.1h5.6l.5-1.5-.9.2-1.9-3.1 2.1-2.6-1.3-2.4-2.6.2-1.8-.7-9.2.1-3.2 1.2-5.5 3.8-3 1.1 1.5 1.3-.3 1.8z"
}), React.createElement("path", {
  d: "M458.6 312.9l13.4-2.1 3.4-.7 1.2-1.1h5.6l.5-1.5-.9.2-1.9-3.1 2.1-2.6-1.3-2.4-2.6.2-1.8-.7-9.2.1-3.2 1.2-5.5 3.8-3 1.1 1.5 1.3-.3 1.8z"
}), React.createElement("path", {
  d: "M200 202.8l22.7-.1V180l-22.7.3z"
}), React.createElement("path", {
  d: "M200 202.8l22.7-.1V180l-22.7.3z"
}), React.createElement("path", {
  d: "M200 180.3l22.7-.3-.3-22.9-22.8.3z"
}), React.createElement("path", {
  d: "M200 180.3l22.7-.3-.3-22.9-22.8.3z"
}), React.createElement("path", {
  d: "M132.8 270.5h12.4l.1-17.9h-28.6l1.2.6 2.9 6.2 2-1.1 1.2 2.2.7 3.9 1.9 1.5 2.7-.3 1 1.6 1.9.6z"
}), React.createElement("path", {
  d: "M132.8 270.5h12.4l.1-17.9h-28.6l1.2.6 2.9 6.2 2-1.1 1.2 2.2.7 3.9 1.9 1.5 2.7-.3 1 1.6 1.9.6z"
}), React.createElement("path", {
  d: "M336.2 329.5l24.2-.2 2.7.8v-3.7l-2.1-.3-.1-1.7-1.6-3.9 1.4-.1-.4-1.3 1.7-2.3-2.3-.3-.2-1.6 2.4-2.6H360l-.3-1.6-1.3-.6.5-2.2h-22.7z"
}), React.createElement("path", {
  d: "M336.2 329.5l24.2-.2 2.7.8v-3.7l-2.1-.3-.1-1.7-1.6-3.9 1.4-.1-.4-1.3 1.7-2.3-2.3-.3-.2-1.6 2.4-2.6H360l-.3-1.6-1.3-.6.5-2.2h-22.7z"
}), React.createElement("path", {
  d: "M363.8 451.9l19.7.1-.9-2.9 4.2-3.4-12.3-23.9 3.7-1.3-4.1-4.8-10.3 8.7z"
}), React.createElement("path", {
  d: "M363.8 451.9l19.7.1-.9-2.9 4.2-3.4-12.3-23.9 3.7-1.3-4.1-4.8-10.3 8.7z"
}), React.createElement("path", {
  d: "M267.2 38.2l23.7.1V14.2H267l-.1 24z"
}), React.createElement("path", {
  d: "M267.2 38.2l23.7.1V14.2H267l-.1 24z"
}), React.createElement("path", {
  d: "M430.9 277.2l8.9 15.4 12.2-7-.2-.8 3.8-2-11.4-19.7-9.7-1-9.3 5.5z"
}), React.createElement("path", {
  d: "M430.9 277.2l8.9 15.4 12.2-7-.2-.8 3.8-2-11.4-19.7-9.7-1-9.3 5.5z"
}), React.createElement("path", {
  d: "M502.5 337.2l5.9 17.9h1.3l.9 1.8-.8 1.8.8 1.9 23.5-.3-.1-11.3h-6.6l-6-19.1-5.1-.2.3.3z"
}), React.createElement("path", {
  d: "M502.5 337.2l5.9 17.9h1.3l.9 1.8-.8 1.8.8 1.9 23.5-.3-.1-11.3h-6.6l-6-19.1-5.1-.2.3.3z"
}), React.createElement("path", {
  d: "M452 285.6l-.5 5.4 1.4 3.7.8 4.4 1.6 1.7-.7 2.3.8 2.2 3-1.1 5.5-3.8 3.2-1.2 9.2-.1-.4-2.3 1.9-1.2-.8-2.4 1-1.1v-2l2.9-2.4-.1-2.1-1.3-.9-.9-4-1.6-.2.3-2.4-.5-2.4 1.6-.2-.6-1.5.8-1.7-1.1-1.9-1.4 2.9-.8-1.1-23.5 12.6z"
}), React.createElement("path", {
  d: "M452 285.6l-.5 5.4 1.4 3.7.8 4.4 1.6 1.7-.7 2.3.8 2.2 3-1.1 5.5-3.8 3.2-1.2 9.2-.1-.4-2.3 1.9-1.2-.8-2.4 1-1.1v-2l2.9-2.4-.1-2.1-1.3-.9-.9-4-1.6-.2.3-2.4-.5-2.4 1.6-.2-.6-1.5.8-1.7-1.1-1.9-1.4 2.9-.8-1.1-23.5 12.6z"
}), React.createElement("path", {
  d: "M421.1 352.1l.3 1 7.5-4.3 4.6-4.1v-1.5l2.5-1.4 1.9-2.1-2.4-1.2-2 .1-1.3-2.4-2.3-2.6-2.1-1-2.1-5.2-1.9-.9-8.4 5-7.9 2.8 6 3.3 5.1 4z"
}), React.createElement("path", {
  d: "M421.1 352.1l.3 1 7.5-4.3 4.6-4.1v-1.5l2.5-1.4 1.9-2.1-2.4-1.2-2 .1-1.3-2.4-2.3-2.6-2.1-1-2.1-5.2-1.9-.9-8.4 5-7.9 2.8 6 3.3 5.1 4z"
}), React.createElement("path", {
  d: "M411.7 385.7l13.2 16.1 16.5-13.6-10.1-12.2-1.8.1-.4-2-1.4-.9-11.7.3-2.7 2.4v3.6z"
}), React.createElement("path", {
  d: "M411.7 385.7l13.2 16.1 16.5-13.6-10.1-12.2-1.8.1-.4-2-1.4-.9-11.8.3-2.6 2.4v3.6z"
}), React.createElement("path", {
  d: "M359.2 302.4l23.1-.3.2-1.7-12-20.2-3.9 2.4.1.3-12.9 9.2-.3 1.7 2.7 1.6-1.8 2.1 1.1 1.9 1-1.5 2 .5-1.3 2.1z"
}), React.createElement("path", {
  d: "M359.2 302.4l23.1-.3.2-1.7-12-20.2-3.9 2.4.1.3-12.9 9.2-.3 1.7 2.7 1.6-1.8 2.1 1.1 1.9 1-1.5 2 .5-1.3 2.1z"
}), React.createElement("path", {
  d: "M199.6 157.4l-.2-25.8h-23v25.8z"
}), React.createElement("path", {
  d: "M199.6 157.4l-.2-25.8h-23v25.8z"
}), React.createElement("path", {
  d: "M496.2 180.8l-.1-26.1-5.5.5-1-1.1-3.7.4-.6-2.6-1.7-.7-1.3 1.8-1.8.1-1.2 1.1-2.7-.3-.5 2.4-1.6-.8-1.7 1.2-.5.5-.1 19.3 1.4.1 2.9-1.8 3.4 1.2 1.7-.8 3.5.6 1.6 1.5 1.4-.5 5.3 3.4z"
}), React.createElement("path", {
  d: "M496.2 180.8l-.1-26.1-5.5.5-1-1.1-3.7.4-.6-2.6-1.7-.7-1.3 1.8-1.8.1-1.2 1.1-2.7-.3-.5 2.4-1.6-.8-1.7 1.2-.5.5-.1 19.3 1.4.1 2.9-1.8 3.4 1.2 1.7-.8 3.5.6 1.6 1.5 1.4-.5 5.3 3.4z"
}), React.createElement("path", {
  d: "M317.4 444.7l.2 8.6 25.7-1.3.1-29.4-26.1.4z"
}), React.createElement("path", {
  d: "M317.4 444.7l.2 8.6 25.7-1.3.1-29.4-26.1.3z"
}), React.createElement("path", {
  d: "M291.3 179.9l22.7-.1-.1-17.6-.8-1.7-2.7-1.7-2 .6-1.5-1.4-2.7-.7-.2 1.4-2.1-.1-.4-1.1-3.3.3-.1-1H291z"
}), React.createElement("path", {
  d: "M291.3 179.9l22.7-.1-.1-17.6-.8-1.7-2.7-1.7-2 .6-1.5-1.4-2.7-.7-.2 1.4-2.1-.1-.4-1.1-3.3.3-.1-1H291z"
}), React.createElement("path", {
  d: "M405.9 490.5h1.1l5.4-14.7-1-.3-3.7 7.2z"
}), React.createElement("path", {
  d: "M375.9 491.3h3.1v2.6l1.6-1.2 4.8-.5 1.9-1.4 5.9-.8-3.2-6.4 4.3 5.8 4.5-2 2.7-3.1-1.2 5.5 3.8-1.5 3.9-11.8-22.6.2-2.1-3.1-2.3-.8h-5.2z"
}), React.createElement("path", {
  d: "M405.9 490.5h1.1l5.4-14.7-1-.3-3.7 7.2z"
}), React.createElement("path", {
  d: "M375.9 491.3h3.1v2.6l1.6-1.2 4.8-.5 1.9-1.4 5.9-.8-3.2-6.4 4.3 5.8 4.5-2 2.7-3.1-1.2 5.5 3.8-1.5 3.9-11.8-22.6.2-2.1-3.1-2.3-.8h-5.2z"
}), React.createElement("path", {
  d: "M261.7 400.8l24.3-.1v-27h-25.8l.1 10.3-.5 4-1.4.5-.2 3.7-2.1.7 1.3 2.7-.5.7z"
}), React.createElement("path", {
  d: "M261.7 400.8l24.3-.1v-27h-25.8l.1 10.3-.5 4-1.4.5-.2 3.7-2.1.7 1.3 2.7-.5.7z"
}), React.createElement("path", {
  d: "M268.2 179.9h23.1l-.3-23.1-22.8.1z"
}), React.createElement("path", {
  d: "M268.2 179.9h23.1l-.3-23.1-22.8.1z"
}), React.createElement("path", {
  d: "M301.6 340l19.8.2-.1-10.8h-7.9l.1-10.7h-27.7V340z"
}), React.createElement("path", {
  d: "M301.6 340l19.8.2-.1-10.8h-7.9l.1-10.7h-27.7V340z"
}), React.createElement("path", {
  d: "M308.3 359.4l14.1.2 4.5.4 11.4 5.7-.2-18-16.6.2-.1-7.7-19.8-.2-.1 11h3l-.1 8.3z"
}), React.createElement("path", {
  d: "M308.3 359.4l14.1.2 4.5.4 11.4 5.7-.2-18-16.6.2-.1-7.7-19.8-.2-.1 11h3l-.1 8.3z"
}), React.createElement("path", {
  d: "M245.4 202.2l22.8.4v-22.7h-22.8z"
}), React.createElement("path", {
  d: "M245.4 202.2l22.8.4v-22.7h-22.8z"
}), React.createElement("path", {
  d: "M409.3 523.8l-3.3-15.1-.4-6.5 1.4-11.7h-.8l-1.1 7.5-.1 9.3 3.6 15-.7 1.5z"
}), React.createElement("path", {
  d: "M379.1 514.9v8.1l5.4.9 18.2-.1-1.1-7.4-4-4.3v-7.8l3.6-.1-1.1-4.2 2.3-1.8.2-7-3.8 1.9-5.4-2.4-6.1.1-1.9 1.4-4.8.5-1.6 1.2z"
}), React.createElement("path", {
  d: "M409.3 523.8l-3.3-15.1-.4-6.5 1.4-11.7h-.8l-1.1 7.5-.1 9.3 3.6 15-.7 1.5z"
}), React.createElement("path", {
  d: "M379.1 514.9v8.1l5.4.9 18.2-.1-1.1-7.4-4-4.3v-7.8l3.6-.1-1.1-4.2 2.3-1.8.2-7-3.8 1.9-5.4-2.4-6.1.1-1.9 1.4-4.8.5-1.6 1.2z"
}), React.createElement("path", {
  d: "M338.3 365.7l6 3.1 5.8-1.2 10.2-9.7-7.6-10.2h-14.6z"
}), React.createElement("path", {
  d: "M338.3 365.7l6 3.1 5.8-1.2 10.2-9.7-7.6-10.2h-14.6z"
}), React.createElement("path", {
  d: "M442.8 224.3l1.1 1-.3 2.3 1.5 2.5 1.8 1.2-.7 2.7 16.4.1v-25l-9.7-.2v1.5h-9.7l-.1 14z"
}), React.createElement("path", {
  d: "M442.8 224.3l1.1 1-.3 2.3 1.5 2.5 1.8 1.2-.7 2.7 16.4.1v-25l-9.7-.2v1.5h-9.7l-.1 14z"
}), React.createElement("path", {
  d: "M374.1 415.7l4.1 4.8 3.8-1.4 4.1 2.4 2 .1 8.9-7.3-7.9-9.7 6.3-5.1-5.1-5.6-20.2 17z"
}), React.createElement("path", {
  d: "M374.1 415.7l4.1 4.8 3.8-1.4 4.1 2.4 2 .1 8.9-7.3-7.9-9.7 6.3-5.1-5.1-5.6-20.2 17z"
}), React.createElement("path", {
  d: "M307.1 225.9h.8v-23l-23.3-.1-.1 22.7 22.6.1z"
}), React.createElement("path", {
  d: "M307.1 225.9h.8v-23l-23.3-.1-.1 22.7 22.6.1z"
}), React.createElement("path", {
  d: "M395.3 236.1v6l2 1.4v1.3l2.3.9.2-1.5 1.6-.6v-.4l17-4.3v-14.8l-23.2-.3z"
}), React.createElement("path", {
  d: "M395.3 236.1v6l2 1.4v1.3l2.3.9.2-1.5 1.6-.6v-.4l17-4.3v-14.8l-23.2-.3z"
}), React.createElement("path", {
  d: "M368.2 491.2l7.7.1-.1-18.5h5.2l.3-12.3 5.9-5.5-.1-2.1-2.9-.1-.7-.8-15.4-.1z"
}), React.createElement("path", {
  d: "M368.2 491.2l7.7.1-.1-18.5h5.2l.3-12.3 5.9-5.5-.1-2.1-2.9-.1-.7-.8-15.4-.1z"
}), React.createElement("path", {
  d: "M336.7 514.7l23.2.1.2-13.4-2.1.1v-4.3h-1.2v-4.6l-1.3-1.5.1-3.8-4.5-.7-7.6.1v4.3l-6.9-.1z"
}), React.createElement("path", {
  d: "M336.7 514.7l23.2.1.2-13.4-2.1.1v-4.3h-1.2v-4.6l-1.3-1.5.1-3.8-4.5-.7-7.6.1v4.3l-6.9-.1z"
}), React.createElement("path", {
  d: "M534.1 360.3l3.7.1.2 16.5 14.9-6h7.7l-4.8-5.1-.1-3.5 3.5-4.5-.1-2.1-2.6-.5-1.1-1.1-3.3-.8v-1.7l-2.7-1.1.8-1.5-1.8-2.4-4.1-1.4-1.1 1.1-1.8-.1-.7 2.6-4.7 1-2-.8z"
}), React.createElement("path", {
  d: "M534.1 360.3l3.7.1.2 16.5 14.9-6h7.7l-4.8-5.1-.1-3.5 3.5-4.5-.1-2.1-2.6-.5-1.1-1.1-3.3-.8v-1.7l-2.7-1.1.8-1.5-1.8-2.4-4.1-1.4-1.1 1.1-1.8-.1-.7 2.6-4.7 1-2-.8z"
}), React.createElement("path", {
  d: "M72.9 322.8l47.2 11h4.4l15.8-12.9-29-22.4z"
}), React.createElement("path", {
  d: "M72.9 322.8l47.2 11h4.4l15.8-12.9-29-22.4z"
}), React.createElement("path", {
  d: "M550.4 328.1l-2 4.6v1.9l1.4 2.4-1.6 3.4 1.1 1.2-.9.9 9.4-.1 1.6-35.8-2-10.8-5.6 1.2-.4 1-17.9 4.2.3 1.6 1.6-1.2 3-.7.9 1 1.4-1.2 2.6 2.7-.5 1.1 1.9 2-.6 1.5 1 1.9.5 3.4 1.3.3 1 2.3.1 3.1 1.6-.1 1.4 1.6-1.6 4z"
}), React.createElement("path", {
  d: "M550.4 328.1l-2 4.6v1.9l1.4 2.4-1.6 3.4 1.1 1.2-.9.9 9.4-.1 1.6-35.8-2-10.8-5.6 1.2-.4 1-17.9 4.2.3 1.6 1.6-1.2 3-.7.9 1 1.4-1.2 2.6 2.7-.5 1.1 1.9 2-.6 1.5 1 1.9.5 3.4 1.3.3 1 2.3.1 3.1 1.6-.1 1.4 1.6-1.6 4z"
}), React.createElement("path", {
  d: "M437.1 418.9l3.8.8 6.3-.1 1.7 1.7 2.9-.1.6-14.4-15.3-15-12.2 10 4.6 2.1 1.8 5.2 2.3 1.2 1.2 2.1.6 3.7 1.2.9z"
}), React.createElement("path", {
  d: "M437.1 418.9l3.8.8 6.3-.1 1.7 1.7 2.9-.1.6-14.4-15.3-15-12.2 10 4.6 2.1 1.8 5.2 2.3 1.2 1.2 2.1.6 3.7 1.2.9z"
}), React.createElement("path", {
  d: "M376 200.5l5.9.1.1-22.6h-2.7v-1.8H360l-.3 24.1z"
}), React.createElement("path", {
  d: "M376 200.5l5.9.1.1-22.6h-2.7v-1.8H360l-.3 24.1z"
}), React.createElement("path", {
  d: "M248.8 299.7l11.9-.2-.2-22.4-25.1-.3-.3 23.1z"
}), React.createElement("path", {
  d: "M248.8 299.7l11.9-.2-.2-22.4-25.1-.3-.3 23.1z"
}), React.createElement("path", {
  d: "M219.8 61.6l23.5-.1.1-23.2h-23.6z"
}), React.createElement("path", {
  d: "M219.8 61.6l23.5-.1.1-23.2h-23.6z"
}), React.createElement("path", {
  d: "M462.6 209.1l6.2.1-2.3-2.1 1.9-5.4h3.6l.1-22.5-19.1 3.1-.1 26.6z"
}), React.createElement("path", {
  d: "M462.6 209.1l6.2.1-2.3-2.1 1.9-5.4h3.6l.1-22.5-19.1 3.1-.1 26.6z"
}), React.createElement("path", {
  d: "M28.4 284.1l1.9 1.2 1 2.6 2.4 1.1 4.5 6.3 5.5 2.8 2.7 2.9.3 1.9 3.5 3.5 3.7 2.6.8 2.6h1.5l3.1 1.2 1.5 1.6 1.7-.6 2.4 2.8 2 .1 2.4 3.2h2.4l1.2 2.9 2.7-1.7.1-8.8h.4l-.5-59.8H28.3l.2 26.9H30l.1 2.8z"
}), React.createElement("path", {
  d: "M28.4 284.1l1.9 1.2 1 2.6 2.4 1.1 4.5 6.3 5.5 2.8 2.7 2.9.3 1.9 3.5 3.5 3.7 2.6.8 2.6h1.5l3.1 1.2 1.5 1.6 1.7-.6 2.4 2.8 2 .1 2.4 3.2h2.4l1.2 2.9 2.7-1.7.1-8.8h.4l-.5-59.8H28.3l.2 26.9H30l.1 2.8z"
}), React.createElement("path", {
  d: "M235.5 248.1h3.6l.4-22.7H217l-.3 22.7z"
}), React.createElement("path", {
  d: "M235.5 248.1h3.6l.4-22.7H217l-.3 22.7z"
}), React.createElement("path", {
  d: "M482.7 307.5l28.9-23.4-4.8-4-1.5-.2.3-1.8-2.2-1.8.2-1.2-1.6-1.1-1.4.7-2.8-1.2-16.6 2.7.2.7-4.1 1.2-.3 2.4 1.6.2.9 4 1.3.9.1 2.1-2.9 2.4v2l-1 1.1.8 2.4-1.9 1.2.4 2.3 1.8.7 2.6-.2 1.3 2.4-2.1 2.6 1.9 3.1z"
}), React.createElement("path", {
  d: "M482.7 307.5l28.9-23.4-4.8-4-1.5-.2.3-1.8-2.2-1.8.2-1.2-1.6-1.1-1.4.7-2.8-1.2-16.6 2.7.2.7-4.1 1.2-.3 2.4 1.6.2.9 4 1.3.9.1 2.1-2.9 2.4v2l-1 1.1.8 2.4-1.9 1.2.4 2.3 1.8.7 2.6-.2 1.3 2.4-2.1 2.6 1.9 3.1z"
}), React.createElement("path", {
  d: "M480.6 202.7l15.6-.1v-21.7l-1.4.9-2.6-.6-4.4 1.3-3.6-.6-4 3-3.7.3-.9 1.9-3.6 2.1v12.5h8.5z"
}), React.createElement("path", {
  d: "M480.6 202.7l15.6-.1v-21.7l-1.4.9-2.6-.6-4.4 1.3-3.6-.6-4 3-3.7.3-.9 1.9-3.6 2.1v12.5h8.5z"
}), React.createElement("path", {
  d: "M375.4 226.1l5.4 14.4 7.1-4.3 7.4-.1-.1-12.3-19.7-.2z"
}), React.createElement("path", {
  d: "M375.4 226.1l5.4 14.4 7.1-4.3 7.4-.1-.1-12.3-19.7-.2z"
}), React.createElement("path", {
  d: "M176.4 157.4l.9 23 22.7-.1-.4-22.9z"
}), React.createElement("path", {
  d: "M176.4 157.4l.9 23 22.7-.1-.4-22.9z"
}), React.createElement("path", {
  d: "M410.1 265.7l10.5-6.1 4.6 8 9.3-5.5-7.8-13.3-1.9 1.1-6.4-11-17 4.3.8 1-1.6 1.2 1 2.7-.9 1.4.2 2.2 2.8.5 1.9 1.8-2.6 2 3.4 2.2-1 1 2.3 1.5 2.3.1-2.1 2.5z"
}), React.createElement("path", {
  d: "M410.1 265.7l10.5-6.1 4.6 8 9.3-5.5-7.8-13.3-1.9 1.1-6.4-11-17 4.3.8 1-1.6 1.2 1 2.7-.9 1.4.2 2.2 2.8.5 1.9 1.8-2.6 2 3.4 2.2-1 1 2.3 1.5 2.3.1-2.1 2.5z"
}), React.createElement("path", {
  d: "M355.6 542.3l.7.6 2.6-.8.1 1.2 2.5 2.1 2.2 1 1.3 1.6 4.8 2.3 1.7.1 1-.8h2.5l.4 1.6 1.7-1.3 2.8.6 4.6-.8v-17.8l-6.3-.7 2.1-8-1.2-.2v-8.1l-14.7-.1-11.7 25.7 1.1 1.6z"
}), React.createElement("path", {
  d: "M355.6 542.3l.7.6 2.6-.8.1 1.2 2.5 2.1 2.2 1 1.3 1.6 4.8 2.3 1.7.1 1-.8h2.5l.4 1.6 1.7-1.3 2.8.6 4.6-.8v-17.8l-6.3-.7 2.1-8-1.2-.2v-8.1l-14.7-.1-11.7 25.7 1.1 1.6z"
}), React.createElement("path", {
  d: "M449.2 235.6l4.1 1.8.2 2 2.2.2 1.8 2.5 1.7-.6-.5 2.9 2.8.4-.7 2.9.6 1 1.6-.6.7 4.2 27.3-4.1-1.4-2.6-.8-.6.7-2.9-1.2-1.5 1.9-3.3-.1-3.1-43.9-.2z"
}), React.createElement("path", {
  d: "M449.2 235.6l4.1 1.8.2 2 2.2.2 1.8 2.5 1.7-.6-.5 2.9 2.8.4-.7 2.9.6 1 1.6-.6.7 4.2 27.3-4.1-1.4-2.6-.8-.6.7-2.9-1.2-1.5 1.9-3.3-.1-3.1-43.9-.2z"
}), React.createElement("path", {
  d: "M267.2 61.9h23.7V38.3l-23.7-.1z"
}), React.createElement("path", {
  d: "M267.2 61.9h23.7V38.3l-23.7-.1z"
}), React.createElement("path", {
  d: "M378.5 367.2l5.4-5.3-.8-1.3 4.4-3.1 1.4-2.1 2.2-1.9-20.3-16.8-5.4 16.1 11.7 9.6z"
}), React.createElement("path", {
  d: "M378.5 367.2l5.4-5.3-.8-1.3 4.4-3.1 1.4-2.1 2.2-1.9-20.3-16.8-5.4 16.1 11.7 9.6z"
}), React.createElement("path", {
  d: "M291.3 179.9l.1 22.9 22.6.1v-23.1z"
}), React.createElement("path", {
  d: "M291.3 179.9l.1 22.9 22.6.1v-23.1z"
}), React.createElement("path", {
  d: "M196.2 61.4V38.3h-38.4l-.1 23.4z"
}), React.createElement("path", {
  d: "M196.2 61.4V38.3h-38.4l-.1 23.4z"
}), React.createElement("path", {
  d: "M522.8 218.8v12l2.6 1.2 2.7.2 1-.7 2.9.7 2.2 1.7 2.4-.3 1.7 1.9 13.3-3.2v-15.6l-2.1.2-.4-2.6-1.9-.2-1.4 2.5-2-.5-.9-2.4h-1.5l-.9 1.4-3.8 1.6-5.4-.1-8.5-5.1z"
}), React.createElement("path", {
  d: "M522.8 218.8v12l2.6 1.2 2.7.2 1-.7 2.9.7 2.2 1.7 2.4-.3 1.7 1.9 13.3-3.2v-15.6l-2.1.2-.4-2.6-1.9-.2-1.4 2.5-2-.5-.9-2.4h-1.5l-.9 1.4-3.8 1.6-5.4-.1-8.5-5.1z"
}), React.createElement("path", {
  d: "M473.6 365.4l9.4 6.1 8.2 4.4 3.3-.3.8-.7 2.9.3.4 2 1.7-.1 2.2 2.9 2.7-.6 4.6-5.3.7-3.4-4.9-3.8 1-3.4 2.4 5.3 3.8 2.4.6-1.3-1.3-.9 1.4-2.5.3-3-2.6-1.7-1.4-3.1.8-1.8-.9-1.8h-1.3l-2.9-8.8-7.3 6.7-2.1-.1-1.7-2-2.6-.9-.7-1.1-2.1.6-1.1-2-2.2-1.4-1.8 1.7h-1.4l-2.1 1.8-7.4.9-5.3-4.1z"
}), React.createElement("path", {
  d: "M473.6 365.4l9.4 6.1 8.2 4.4 3.3-.3.8-.7 2.9.3.4 2 1.7-.1 2.2 2.9 2.7-.6 4.6-5.3.7-3.4-4.9-3.8 1-3.4 2.4 5.3 3.8 2.4.6-1.3-1.3-.9 1.4-2.5.3-3-2.6-1.7-1.4-3.1.8-1.8-.9-1.8h-1.3l-2.9-8.8-7.3 6.7-2.1-.1-1.7-2-2.6-.9-.7-1.1-2.1.6-1.1-2-2.2-1.4-1.8 1.7h-1.4l-2.1 1.8-7.4.9-5.3-4.1z"
}), React.createElement("path", {
  d: "M534 349l2 .8 4.7-1 .7-2.6 1.8.1 1.1-1.1 4.1 1.4 1-2.2-1-1.9.9-.9-1.1-1.2 1.6-3.4-1.4-2.4v-1.9l2-4.6-20.8-.1.4 1.8-8.6.1 6 19.1z"
}), React.createElement("path", {
  d: "M534 349l2 .8 4.7-1 .7-2.6 1.8.1 1.1-1.1 4.1 1.4 1-2.2-1-1.9.9-.9-1.1-1.2 1.6-3.4-1.4-2.4v-1.9l2-4.6-20.8-.1.4 1.8-8.6.1 6 19.1z"
}), React.createElement("path", {
  d: "M291 136.3l9.9 7 1.1-.5 3.2.7.9-.5 4.6 2.2.5-.9 2 .4.6-1 .1-16.5-1.9-1-2.7-.1-.9 2.3-4.1-.2-2.6-2.3-7.5-8.2-3.2.8z"
}), React.createElement("path", {
  d: "M291 136.3l9.9 7 1.1-.5 3.2.7.9-.5 4.6 2.2.5-.9 2 .4.6-1 .1-16.5-1.9-1-2.7-.1-.9 2.3-4.1-.2-2.6-2.3-7.5-8.2-3.2.8z"
}), React.createElement("path", {
  d: "M219.8 38.3h23.6V14.2h-23.6z"
}), React.createElement("path", {
  d: "M219.8 38.3h23.6V14.2h-23.6z"
}), React.createElement("path", {
  d: "M366.6 282.6l22-13.2-10.4-17.7-8.9 5.1 2.3 3.9-13.5 8.2z"
}), React.createElement("path", {
  d: "M366.6 282.6l22-13.2-10.4-17.7-8.9 5.1 2.3 3.9-13.5 8.2z"
}), React.createElement("path", {
  d: "M268.2 131.6h4.4l.1-23.1h-23.2v23.1z"
}), React.createElement("path", {
  d: "M268.2 131.6h4.4l.1-23.1h-23.2v23.1z"
}), React.createElement("path", {
  d: "M199.4 131.6l.2 25.8 22.8-.3v-25.4z"
}), React.createElement("path", {
  d: "M199.4 131.6l.2 25.8 22.8-.3v-25.4z"
}), React.createElement("path", {
  d: "M364.8 375.2l.6 1.6 1.9 1.1.9-.7 3.1 3.8 1.6-.2-.3 2 .9 3.9 1.2-.7 10.7.1 9.1-13.7-2.9-.9-3-2.6-.6-1.9-1 .1-1.7-2.3-.3-2.2-1.1-.7-9.4 8.8z"
}), React.createElement("path", {
  d: "M364.8 375.2l.6 1.6 1.9 1.1.9-.7 3.1 3.8 1.6-.2-.3 2 .9 3.9 1.2-.7 10.7.1 9.1-13.7-2.9-.9-3-2.6-.6-1.9-1 .1-1.7-2.3-.3-2.2-1.1-.7-9.4 8.8z"
}), React.createElement("path", {
  d: "M458.6 312.9l-.6 1.6.8 1.2-.6 3 .6 2.6-1.1 3.1 1.3 1.6 1.7 6.3 1.8.6-3 2.4-.3 2.7 3 2.3-.3 3 12.6-1-1.1-19.5-1.4-12z"
}), React.createElement("path", {
  d: "M458.6 312.9l-.6 1.6.8 1.2-.6 3 .6 2.6-1.1 3.1 1.3 1.6 1.7 6.3 1.8.6-3 2.4-.3 2.7 3 2.3-.3 3 12.6-1-1.1-19.5-1.4-12z"
}), React.createElement("path", {
  d: "M510.4 233.4h15.2l1.6.6.9-1.8-2.7-.2-2.6-1.2v-12l-2.5-.4-2.7 3.6-7.3 2.8z"
}), React.createElement("path", {
  d: "M510.4 233.4h15.2l1.6.6.9-1.8-2.7-.2-2.6-1.2v-12l-2.5-.4-2.7 3.6-7.3 2.8z"
}), React.createElement("path", {
  d: "M424.6 178.9l4.5.1.4.5 19.6.4.3-17.3-1.9-2.6-3.5.2-1.4-2.7-1.7.2-2.5-1.7 1.8-2.3-3.7-.9-.8 3.3-1 1-2.4.2-.5-1.6-2.3-.9-.8 1.4-1.4-1.1-.7-3.4-1.6-1.1-.4.3z"
}), React.createElement("path", {
  d: "M424.6 178.9l4.5.1.4.5 19.6.4.3-17.3-1.9-2.6-3.5.2-1.4-2.7-1.7.2-2.5-1.7 1.8-2.3-3.7-.9-.8 3.3-1 1-2.4.2-.5-1.6-2.3-.9-.8 1.4-1.4-1.1-.7-3.4-1.6-1.1-.4.3z"
}), React.createElement("path", {
  d: "M267.3 85.3l-.1-23.4h-23.9v23.4z"
}), React.createElement("path", {
  d: "M267.3 85.3l-.1-23.4h-23.9v23.4z"
}), React.createElement("path", {
  d: "M390.3 393.9l5.1 5.6 16.3-13.8 1.6-6.2v-3.6l3.2-3.2-8.2-7.1-12.3 7.7-1.5-.9-9.9 14.9z"
}), React.createElement("path", {
  d: "M390.3 393.9l5.1 5.6 16.3-13.8 1.6-6.2v-3.6l3.2-3.2-8.2-7.1-12.3 7.7-1.5-.9-9.9 14.9z"
}), React.createElement("path", {
  d: "M388.1 421.6l2 1.9 1.6 4.4 2.2 1 1-.4 2.8.8.2 2.9 2.7.8 2 1.8.7-.5 2.4 1.2 9.5-8.2-1-2.8 1-8.3-1.2-2.8-2-1.7-2.6.9-2.1-2.4-3.4-1.5z"
}), React.createElement("path", {
  d: "M388.1 421.6l2 1.9 1.6 4.4 2.2 1 1-.4 2.8.8.2 2.9 2.7.8 2 1.8.7-.5 2.4 1.2 9.5-8.2-1-2.8 1-8.3-1.2-2.8-2-1.7-2.6.9-2.1-2.4-3.4-1.5z"
}), React.createElement("path", {
  d: "M213.1 248.1l.1 22.4 22.2.1.1-22.5z"
}), React.createElement("path", {
  d: "M213.1 248.1l.1 22.4 22.2.1.1-22.5z"
}), React.createElement("path", {
  d: "M321.4 340.2l.1 7.7 31.2-.2-.2-18.3h-31.2z"
}), React.createElement("path", {
  d: "M321.4 340.2l.1 7.7 31.2-.2-.2-18.3h-31.2z"
}), React.createElement("path", {
  d: "M239.5 202.6l5.9-.4v-22.3l-22.7.1v22.7z"
}), React.createElement("path", {
  d: "M239.5 202.6l5.9-.4v-22.3l-22.7.1v22.7z"
}), React.createElement("path", {
  d: "M534.2 376.6l-2.5 3 5.6-2.4-.1-2.2h-1.5z"
}), React.createElement("path", {
  d: "M531.1 379.1l-7.6 3.3-4 3.8 2.1.2 3.1-3.3z"
}), React.createElement("path", {
  d: "M520.6 388.3l-4.8 1.9-8.5 8.3 11-7.5z"
}), React.createElement("path", {
  d: "M500.3 377.1l-.8 4.6 7.7 13.2 7.5-9.4-2.8-3.9 1.8-1.5-4.7-2.6-2.7.6-1.1 1.3-2.7.6z"
}), React.createElement("path", {
  d: "M534.2 376.6l-2.5 3 5.6-2.4-.1-2.2h-1.5z"
}), React.createElement("path", {
  d: "M531.1 379.1l-7.6 3.3-4 3.8 2.1.2 3.1-3.3z"
}), React.createElement("path", {
  d: "M520.6 388.3l-4.8 1.9-8.5 8.3 11-7.5z"
}), React.createElement("path", {
  d: "M500.3 377.1l-.8 4.5 7.7 13.3 7.5-9.4-2.8-3.9 1.8-1.5-4.7-2.6-2.7.6-1.1 1.3-2.7.6z"
}), React.createElement("path", {
  d: "M194.1 225.5h.4l-.3-22.7h-37.5v22.7z"
}), React.createElement("path", {
  d: "M194.1 225.5h.4l-.3-22.7h-37.5v22.7z"
}), React.createElement("path", {
  d: "M316.7 423l26.7-.4-.2-22.1-26.7-.1z"
}), React.createElement("path", {
  d: "M316.7 423l26.7-.4-.2-22.1-26.7-.1z"
}), React.createElement("path", {
  d: "M444.2 263.1l11.4 19.7 19.7-10.6-.3-2.1-1.2-1.4-2.6-.7.1-2.9-4.6-1.6.6-4.6-2.2.3.8-1.8-.8-2.5-1.5.3v-3.3z"
}), React.createElement("path", {
  d: "M444.2 263.1l11.4 19.7 19.7-10.6-.3-2.1-1.2-1.4-2.6-.7.1-2.9-4.6-1.6.6-4.6-2.2.3.8-1.8-.8-2.5-1.5.3v-3.3z"
}), React.createElement("path", {
  d: "M496.2 202.6l5.9.1 1-2.7 1.1-1.1v-18.6l-5.7 1.1-2.3-.5z"
}), React.createElement("path", {
  d: "M496.2 202.6l5.9.1 1-2.7 1.1-1.1v-18.6l-5.7 1.1-2.3-.5z"
}), React.createElement("path", {
  d: "M462.1 374.8l1.3.7.7 2.4-.5 1.4 1.2.9-1.4 1 2.2 2.3.7-.3 2.3 4.1-.5.8 2.6 1.3.7 2.3 1.2.1 2.2-2.2 2-.9 4.3 1.7 2.8-1.8.8-2.8 1.1-.7-.1-2.1h3.8l1.7-7.1-8.2-4.4-9.4-6.1-6.4 3h-2.7l.8 2.2-1.9.4 1.7.8-.2 2.9z"
}), React.createElement("path", {
  d: "M462.1 374.8l1.3.7.7 2.4-.5 1.4 1.2.9-1.4 1 2.2 2.2.7-.2 2.3 4.1-.5.8 2.6 1.3.7 2.3 1.2.1 2.2-2.2 2-.9 4.3 1.7 2.8-1.8.8-2.8 1.1-.7-.1-2.1h3.8l1.7-7.1-8.2-4.4-9.4-6.1-6.4 3h-2.7l.8 2.2-1.9.4 1.7.8-.2 2.9z"
}), React.createElement("path", {
  d: "M288.8 156.8h9.3l.1 1 3.3-.3.4 1.1 2.1.1.2-1.4 2.7.7 1.5 1.4 2-.6 2.7 1.7.8 1.7-.1-18.5-.6 1-2-.4-.5.9-4.6-2.2-.9.5-3.2-.7-1.1.5-9.9-7-.5-.9-1.7.6z"
}), React.createElement("path", {
  d: "M288.8 156.8h9.3l.1 1 3.3-.3.4 1.1 2.1.1.2-1.4 2.7.7 1.5 1.4 2-.6 2.7 1.7.8 1.7-.1-18.5-.6 1-2-.4-.5.9-4.6-2.2-.9.5-3.2-.7-1.1.5-9.9-7-.5-.9-1.7.6z"
}), React.createElement("path", {
  d: "M222.4 157.1l22.9-.1v-25.3h-22.9z"
}), React.createElement("path", {
  d: "M222.4 157.1l22.9-.1v-25.3h-22.9z"
}), React.createElement("path", {
  d: "M262 225.4l22.5.1.1-22.7-22.4-.2z"
}), React.createElement("path", {
  d: "M262 225.4l22.5.1.1-22.7-22.4-.2z"
}), React.createElement("path", {
  d: "M416 373.5l11.7-.3 6.9-8 6.4-8.5-2.3-4.2-1.1-5.1-5.2.3-1.2-1.1-2.3 2.2-7.5 4.3-.3-1-12.8 13.5 8.2 7.1z"
}), React.createElement("path", {
  d: "M415.9 373.5l11.8-.3 6.9-8 6.4-8.5-2.3-4.2-1.1-5.1-5.2.3-1.2-1.1-2.3 2.2-7.5 4.3-.3-1-12.8 13.5 8.2 7.1z"
}), React.createElement("path", {
  d: "M453 182.3l19.1-3.1.2-22 .5-.5-3.9-2.5-.4 1.3-4.7 1.3-2.3-.5-2.1.5-1.2 4-2.3.6-2.1-1.1-1.1 1-.7 2.8-1.9.3-.7-1.8-.3 20.2z"
}), React.createElement("path", {
  d: "M453 182.3l19.1-3.1.2-22 .5-.5-3.9-2.5-.4 1.3-4.7 1.3-2.3-.5-2.1.5-1.2 4-2.3.6-2.1-1.1-1.1 1-.7 2.8-1.9.3-.7-1.8-.3 20.2z"
}), React.createElement("path", {
  d: "M419.1 304.6l20.7-12-8.9-15.4-20.9 12.4z"
}), React.createElement("path", {
  d: "M419.1 304.6l20.7-12-8.9-15.4-20.9 12.4z"
}), React.createElement("path", {
  d: "M369.3 256.8l15-8.7-3.5-7.6-5.4-14.4-17.8-.1v11.1l-3.3 2 9.8 16.5 3.3-2z"
}), React.createElement("path", {
  d: "M369.3 256.8l15-8.7-3.5-7.6-5.4-14.4-17.8-.1v11.1l-3.3 2 9.8 16.5 3.3-2z"
}), React.createElement("path", {
  d: "M418.4 238.9l6.4 11 24.4-14.3-3-1.6.7-2.7-1.8-1.2-1.5-2.5.3-2.3-1.1-1-24.4-.2z"
}), React.createElement("path", {
  d: "M418.4 238.9l6.4 11 24.4-14.3-3-1.6.7-2.7-1.8-1.2-1.5-2.5.3-2.3-1.1-1-24.4-.2z"
}), React.createElement("path", {
  d: "M19.9 280.4l5.1 3.2 3.4.5 1.7-1.9-.1-2.8h-1.5l-.2-26.9H1.2l.3 4.2-1.5 1.1 1.8 3.7 2.5 1 2.5 3 1.7-.8 3.1 1.7 3.2 5.3 1.2 3.5 1.5 1.1 1.1 3z"
}), React.createElement("path", {
  d: "M19.9 280.4l5.1 3.2 3.4.5 1.7-1.9-.1-2.8h-1.5l-.2-26.9H1.2l.3 4.2-1.5 1.1 1.8 3.7 2.5 1 2.5 3 1.7-.8 3.1 1.7 3.2 5.3 1.2 3.5 1.5 1.1 1.1 3z"
}), React.createElement("path", {
  d: "M260.2 373.7h30.1l-.2-2.7-2-1.7 1.7-.7-.5-2.6 1-1-.9-2.4 1.4-2.7.5-6.5.8.1.2-3 2.2.5h7l.1-11-41.4.1z"
}), React.createElement("path", {
  d: "M260.2 373.7h30.1l-.2-2.7-2-1.7 1.7-.7-.5-2.6 1-1-.9-2.4 1.4-2.7.5-6.5.8.1.2-3 2.2.5h7l.1-11-41.4.1z"
}), React.createElement("path", {
  d: "M168.4 270.5h22.4v-22.4h-22.4z"
}), React.createElement("path", {
  d: "M168.4 270.5h22.4v-22.4h-22.4z"
}), React.createElement("path", {
  d: "M338 248.5l19.6-11.4V226l-28-.1-.1 22.6z"
}), React.createElement("path", {
  d: "M338 248.5l19.6-11.4V226l-28-.1-.1 22.6z"
}), React.createElement("path", {
  d: "M343.3 452l.2 34.7 7.6-.1 4.5.7-.1 3.8 12.7.1-.1-39.3z"
}), React.createElement("path", {
  d: "M343.3 452l.2 34.7 7.6-.1 4.5.7-.1 3.8 12.7.1-.1-39.3z"
}), React.createElement("path", {
  d: "M249.5 108.5h17.7l.1-23.2h-24l-.2 23.2z"
}), React.createElement("path", {
  d: "M249.5 108.5h17.7l.1-23.2h-24l-.2 23.2z"
}), React.createElement("path", {
  d: "M285.9 422.6V445l31.5-.3-.1-21.7z"
}), React.createElement("path", {
  d: "M285.9 422.6V445l31.5-.3-.1-21.8z"
}), React.createElement("path", {
  d: "M245.3 157l.1 22.9h22.8v-23z"
}), React.createElement("path", {
  d: "M245.3 157l.1 22.9h22.8v-23z"
}), React.createElement("path", {
  d: "M397 414.3l6.9-5.6 3.4 1.5 1.5 1.6 14.4-12-11.5-14.1-22.6 18.9z"
}), React.createElement("path", {
  d: "M397 414.3l6.9-5.6 3.4 1.5 1.5 1.6 14.4-12-11.5-14.1-22.6 18.9z"
}), React.createElement("path", {
  d: "M420.8 201.5l8.2-.2.5-21.8-.4-.5-23.7-.8-.7 23z"
}), React.createElement("path", {
  d: "M420.8 201.5l8.2-.2.5-21.8-.4-.5-23.7-.8-.7 23z"
}), React.createElement("path", {
  d: "M496.2 180.9l-2.8-.7-5.3-3.4-1.4.5-1.6-1.5-3.5-.6-1.7.8-3.4-1.2-2.9 1.8-1.4-.1-.2 12.7 3.6-2.1.9-1.9 3.7-.3 4-3 3.6.6 4.4-1.3 2.6.6z"
}), React.createElement("path", {
  d: "M496.2 180.9l-2.8-.7-5.3-3.4-1.4.5-1.6-1.5-3.5-.6-1.7.8-3.4-1.2-2.9 1.8-1.4-.1-.2 12.7 3.6-2.1.9-1.9 3.7-.3 4-3 3.6.6 4.4-1.3 2.6.6z"
}), React.createElement("path", {
  d: "M180.3 108.6h15.6l.1-23.3h-38.3v23.2z"
}), React.createElement("path", {
  d: "M180.3 108.6h15.6l.1-23.3h-38.3v23.2z"
}), React.createElement("path", {
  d: "M194.5 225.5l22.5-.1-.2-22.7-22.6.1z"
}), React.createElement("path", {
  d: "M194.5 225.5l22.5-.1-.2-22.7-22.6.1z"
}), React.createElement("path", {
  d: "M442.8 224.3l.3.1.2-22.8-22.5-.4-.3 23z"
}), React.createElement("path", {
  d: "M442.8 224.3l.3.1.2-22.8-22.5-.4-.3 23z"
}), React.createElement("path", {
  d: "M196.2 38.3V14.1h-38.5l.1 24.2z"
}), React.createElement("path", {
  d: "M196.2 38.3V14.1h-38.5l.1 24.2z"
}), React.createElement("path", {
  d: "M75.6 321.1l35.7-22.6 3.4-45.9-39.1-.1.5 59.8h-.4z"
}), React.createElement("path", {
  d: "M75.6 321.1l35.7-22.6 3.4-45.9-39.1-.1.5 59.8h-.4z"
}), React.createElement("path", {
  d: "M222.4 157.1l.3 22.9 22.7-.1-.1-22.9z"
}), React.createElement("path", {
  d: "M222.4 157.1l.3 22.9 22.7-.1-.1-22.9z"
}), React.createElement("path", {
  d: "M213.5 321.6h2.6l2.4 1.7-.4 1.6.7 1.9-1.5 1.5-.8 3.2-1.2-.7-.6 2.5 3.6 3.4-3.6 1.8-.8 1.6h34.9v-40.4l-62.5-.2 2.6.9 2.2 1.8 3.4.1 2.7 1.9 2.7.4 2-.6 1.8.5 5.1 3.9-.7 1.1 1.4.9 1.9 6.2.3 2.5z"
}), React.createElement("path", {
  d: "M213.5 321.6h2.6l2.4 1.7-.4 1.6.7 1.9-1.5 1.5-.8 3.2-1.2-.7-.6 2.5 3.6 3.4-3.6 1.8-.8 1.6h34.9v-40.4l-62.5-.2 2.6.9 2.2 1.8 3.4.1 2.7 1.9 2.7.4 2-.6 1.8.5 5.1 3.9-.7 1.1 1.4.9 1.9 6.2.3 2.5z"
}), React.createElement("path", {
  d: "M186.3 299.5h3.9l-.8-29h-19.6l-.1 18.4 4-1.7 4.3 2.8 2.6.5 2.8 2 1.2 1.7v3.3z"
}), React.createElement("path", {
  d: "M186.3 299.5h3.9l-.8-29h-19.6l-.1 18.4 4-1.7 4.3 2.8 2.6.5 2.8 2 1.2 1.7v3.3z"
}), React.createElement("path", {
  d: "M268.2 156.9l20.6-.1V136l1.7-.6.5.9v-4.6l-22.8-.1z"
}), React.createElement("path", {
  d: "M268.2 156.9l20.6-.1V136l1.7-.6.5.9v-4.6l-22.8-.1z"
}), React.createElement("path", {
  d: "M370.5 280.2l12 20.2 21.4-12.9-11.9-20z"
}), React.createElement("path", {
  d: "M370.5 280.2l12 20.2 21.4-12.9-11.9-20z"
}), React.createElement("path", {
  d: "M405.4 178.2l19.2.7v-28l-2.2.3.4 3-1.6 2.2-1.5-.7-1.3.9 1.7 1.2-1.8.5v3.7l-1 1-1.7-.2-1.9-2-.1-3.6 1.3-.6-.8-3.2-1.1-.8-1.6.8-.4 2-3.3-1.1-1.8 3.4-3.1-.2-.9-1 .5-2.6-1.4-1.3-.1 25.4z"
}), React.createElement("path", {
  d: "M405.4 178.2l19.2.7v-28l-2.2.3.4 3-1.6 2.2-1.5-.7-1.3.9 1.7 1.2-1.8.5v3.7l-1 1-1.7-.2-1.9-2-.1-3.6 1.3-.6-.8-3.2-1.1-.8-1.6.8-.4 2-3.3-1.1-1.8 3.4-3.1-.2-.9-1 .5-2.6-1.4-1.3-.1 25.4z"
}), React.createElement("path", {
  d: "M285.8 299.4l22.4.1.1-20.8-1.1 1.3-2.1-1.6 1-1.5-1.7-.6.8-.8-2.1-1.1-17.1-.2z"
}), React.createElement("path", {
  d: "M285.8 299.4l22.4.1.1-20.8-1.1 1.3-2.1-1.6 1-1.5-1.7-.6.8-.8-2.1-1.1-17.1-.2z"
}), React.createElement("path", {
  d: "M338 248.5l11.2 19.5 7.7-1.2 1.2 2.1 13.5-8.2-4.2-7.1-3.3 2-9.8-16.5z"
}), React.createElement("path", {
  d: "M338 248.5l11.2 19.5 7.7-1.2 1.2 2.1 13.5-8.2-4.2-7.1-3.3 2-9.8-16.5z"
}), React.createElement("path", {
  d: "M350.1 367.6l1.9.2 2.2-1 1.1 1 4.7-.1 3.6 1-1.8 1v2l1.6.5-.1 1.7 1.5 1.3 9.7-4.5 4-3.5-1.4-4.8-11.7-9.6z"
}), React.createElement("path", {
  d: "M350.1 367.6l1.9.2 2.2-1 1.1 1 4.7-.1 3.6 1-1.8 1v2l1.6.5-.1 1.7 1.5 1.3 9.7-4.5 4-3.5-1.4-4.8-11.7-9.6z"
}), React.createElement("path", {
  d: "M427.7 373.2l1.4.9.4 2 1.8-.1 10.1 12.2-4.3 3.6.8.8 12.8-8.1 1.8-5.3 5.8-6-1.1-1.2-2.4-.4-.7-2.6-1.8-2-.8-2.9-3.6-.5-5.4-4.2-1.5-2.7-6.4 8.5z"
}), React.createElement("path", {
  d: "M427.7 373.2l1.4.9.4 2 1.8-.1 10.1 12.2-4.3 3.6.8.8 12.8-8.1 1.8-5.3 5.8-6-1.1-1.2-2.4-.4-.7-2.6-1.8-2-.8-2.9-3.6-.5-5.4-4.2-1.5-2.7-6.4 8.5z"
}), React.createElement("path", {
  d: "M267.2 108.5l23.7.1V85.3h-23.6z"
}), React.createElement("path", {
  d: "M267.2 108.5l23.7.1V85.3h-23.6z"
}), React.createElement("path", {
  d: "M429 201.3l24 .3v-19.3l-3.9.5v-2.9l-19.6-.4z"
}), React.createElement("path", {
  d: "M429 201.3l24 .3v-19.3l-3.9.5v-2.9l-19.6-.4z"
}), React.createElement("path", {
  d: "M303.1 274.4l2.1 1.1-.8.8 1.7.6-1 1.5 2.1 1.6 1.1-1.3 2.8.5 1.1 3 3.3-1.1-.5-1.3 5.9 3.1 3.2-3.7 1.7.8.3-31.5-22.7-.2z"
}), React.createElement("path", {
  d: "M303.1 274.4l2.1 1.1-.8.8 1.7.6-1 1.5 2.1 1.6 1.1-1.3 2.8.5 1.1 3 3.3-1.1-.5-1.3 5.9 3.1 3.2-3.7 1.7.8.3-31.5-22.7-.2z"
}), React.createElement("path", {
  d: "M254.8 268.2l25.8.2v-20.1l-25.7-.2z"
}), React.createElement("path", {
  d: "M254.8 268.2l25.8.2v-20.1l-25.7-.2z"
}), React.createElement("path", {
  d: "M177.3 180.4l-.9-23h-18.9l-.4 23z"
}), React.createElement("path", {
  d: "M177.3 180.4l-.9-23h-18.9l-.4 23z"
}), React.createElement("path", {
  d: "M360 176.2h19.3l.1-22.2.9-1.3-.6-1.2 1-2.8-1.1-.9-1.9.7-3-.5.1-2-1.6-1.6 1.3-2.7-.5-1.3-1.7.3-1.3 1.4-2.8-1h-2.9l-2.8-1.2-1.5 1.5-1.1 2.4z"
}), React.createElement("path", {
  d: "M360 176.2h19.3l.1-22.2.9-1.3-.6-1.2 1-2.8-1.2-.9-1.8.7-3-.5.1-2-1.6-1.6 1.3-2.7-.5-1.3-1.7.3-1.3 1.4-2.8-1h-2.9l-2.8-1.2-1.5 1.5-1.1 2.4z"
}), React.createElement("path", {
  d: "M291 131.7l-.1-23.1-18.2-.1-.1 23.1z"
}), React.createElement("path", {
  d: "M291 131.7l-.1-23.1-18.2-.1-.1 23.1z"
}), React.createElement("path", {
  d: "M491 248.2l.2 3.4-1.3 3 1.4 1.8-.7 1.2-.2 3.1 1.3.4.5 3.5 2.7 1.6 2.1 2.6.8 4.7 2.8 1.2 1.4-.7 1.6 1.1-.2 1.2 2.2 1.8-.3 1.8 1.5.2 2.8 2 6-5.2-2.5-2.7-1.9-5.9v-3l1.8-.5-2.2-1 1.7-3.3h-2.1v-15.1l-20.8.2z"
}), React.createElement("path", {
  d: "M491 248.2l.2 3.4-1.3 3 1.4 1.8-.7 1.2-.2 3.1 1.3.4.5 3.5 2.7 1.6 2.1 2.6.8 4.7 2.8 1.2 1.4-.7 1.6 1.1-.2 1.2 2.2 1.8-.3 1.8 1.5.2 2.8 2 6-5.2-2.5-2.7-1.9-5.9v-3l1.8-.5-2.2-1 1.7-3.3h-2.1v-15.1l-20.8.2z"
}), React.createElement("path", {
  d: "M510.6 360.6l.6 1.2 2.6 1.7-.3 3-1.4 2.5 1.3.9-.6 1.3 2.5.1 2.6-4.4 3.3-1.6 1.9 1.7-.4 6.3-2.6 5.4 9.5-2.4 3.3.7 1.3-.4 1.5-1.6h1.5l.1 2.2.7-.3-.2-16.5z"
}), React.createElement("path", {
  d: "M510.6 360.6l.6 1.2 2.6 1.7-.3 3-1.4 2.5 1.3.9-.6 1.3 2.5.1 2.6-4.4 3.3-1.6 1.9 1.7-.4 6.3-2.6 5.4 9.5-2.4 3.3.7 1.3-.4 1.5-1.6h1.5l.1 2.2.7-.3-.2-16.5z"
}), React.createElement("path", {
  d: "M199.4 131.6h4v-23.1l-23.1.1v23z"
}), React.createElement("path", {
  d: "M199.4 131.6h4v-23.1l-23.1.1v23z"
}), React.createElement("path", {
  d: "M551.6 206.9v-20.4l-.6-1.4-3.6.2-1.2-.9-2.3.8-.5 2.5-6.5-.4-1.6-1.5-4.5.1-.5.8-3.9 1.1-1.4-1.2-.1 20.4z"
}), React.createElement("path", {
  d: "M551.6 206.9v-20.4l-.6-1.4-3.6.2-1.2-.9-2.3.8-.5 2.5-6.5-.4-1.6-1.5-4.5.1-.5.8-3.9 1.1-1.4-1.2-.1 20.4z"
}), React.createElement("path", {
  d: "M243.3 85.3V61.5l-23.5.1v23.7z"
}), React.createElement("path", {
  d: "M243.3 85.3V61.5l-23.5.1v23.7z"
}), React.createElement("path", {
  d: "M503.1 205.8l18.9-.1-2.2-1.2-2.2-2.9-1.9-1.2-3.6-3.6-4.3.2-2.6 2-1-.1-1.1 1.1z"
}), React.createElement("path", {
  d: "M503.1 205.8l18.9-.1-2.2-1.2-2.2-2.9-1.9-1.2-3.6-3.6-4.3.2-2.6 2-1-.1-1.1 1.1z"
}), React.createElement("path", {
  d: "M384.5 549.7l1.1 1.1 1.5-.7 1.6 1.6 2.6-.5 2.7.5 2.7 4.4 1.5.1 1.2 2.4 2.8.1.1 1.5 3.5.7.7-2.3-.7-1 1.1-1.2 3.2-.2 3-1.4 2.7.4-.3-3.5-4.3 3.1.6-4.9-3.3-2.8.8-3.3-2-6.9-3.4-1.9-1.3 2.2-2.7-.4-.8 1.7-14.6-2.4z"
}), React.createElement("path", {
  d: "M384.5 549.7l1.1 1.1 1.5-.7 1.6 1.6 2.6-.5 2.7.5 2.7 4.4 1.5.1 1.2 2.4 2.8.1.1 1.5 3.5.7.7-2.3-.7-1 1.1-1.2 3.2-.2 3-1.4 2.7.4-.3-3.5-4.3 3.1.6-4.9-3.3-2.8.8-3.3-2-6.9-3.4-1.9-1.3 2.2-2.7-.4-.8 1.7-14.6-2.4z"
}), React.createElement("path", {
  d: "M307 248.4l22.5.1.1-22.6h-22.5z"
}), React.createElement("path", {
  d: "M307 248.4l22.5.1.1-22.6h-22.5z"
}), React.createElement("path", {
  d: "M449.1 421.3l2.7 1.6v-1.7z"
}), React.createElement("path", {
  d: "M430.1 446.7l-1.3 4.9 7.1-6 10.8-6.6 2.3-2.9-13.8 8.9z"
}), React.createElement("path", {
  d: "M427 429.6l3.6 3.8 1-.8 3.4 2 2.5 3.7 9.5-5 .8-1.5-6.6-5.9-3.2.5 1.2-3.4-2.2-3.1-2.7 1.6-5.7 1.7-3.4 2.5 1.2 1z"
}), React.createElement("path", {
  d: "M440.9 419.7l.5 3 5.5 2.1.3-5.2z"
}), React.createElement("path", {
  d: "M449.1 421.3l2.7 1.6v-1.7z"
}), React.createElement("path", {
  d: "M430.1 446.7l-1.3 4.9 7.1-6 10.8-6.6 2.3-2.9-13.8 8.9z"
}), React.createElement("path", {
  d: "M427 429.6l3.6 3.8 1-.8 3.4 2 2.5 3.7 9.5-5 .8-1.5-6.6-5.9-3.2.5 1.2-3.4-2.2-3.1-2.7 1.6-5.7 1.7-3.4 2.5 1.2 1z"
}), React.createElement("path", {
  d: "M440.9 419.7l.5 3 5.5 2.1.3-5.2z"
}), React.createElement("path", {
  d: "M383.9 361.9l1.1.7.3 2.2 1.7 2.3 1-.1.6 1.9 3 2.6 2.9.9 1.5.9 12.4-7.8-14.6-14.2-4.9 4.1-1.4 2.1-4.4 3.1z"
}), React.createElement("path", {
  d: "M383.9 361.9l1.1.7.3 2.2 1.7 2.3 1-.1.6 1.9 3 2.6 2.9.9 1.5.9 12.4-7.8-14.6-14.2-4.9 4.1-1.4 2.1-4.4 3.1z"
}), React.createElement("path", {
  d: "M358.9 307.9l-.5 2.2 1.3.6.3 1.6h1.9l-2.4 2.6.2 1.6 2.3.3-1.7 2.3.4 1.3-1.4.1 1.6 3.9.1 1.7 2.1.3v3.7l9.8 3 1.3-2.1-.9-1.6 6.7-14.6 5.9-6.1-3.6-6.6-23.1.3-.9 1.1.6 2.9 1.4.5z"
}), React.createElement("path", {
  d: "M358.9 307.9l-.5 2.2 1.3.6.3 1.6h1.9l-2.4 2.6.2 1.6 2.3.3-1.7 2.3.4 1.3-1.4.1 1.6 3.9.1 1.7 2.1.3v3.7l9.8 3 1.3-2.1-.9-1.6 6.7-14.6 5.9-6.1-3.6-6.6-23.1.3-.9 1.1.6 2.9 1.4.5z"
}), React.createElement("path", {
  d: "M437.9 339.7l6.4-1.5 6-2.3 2.6-.4.3-3.2-2.2-1.6-.8-3.5h-2.5l-.1-2.1-4.3-2.1-3.7-.9 1.5-2.7-2.3-1.8-15 8.9 1.9.9 2.1 5.2 2.1 1 2.3 2.6 1.3 2.4 2-.1z"
}), React.createElement("path", {
  d: "M437.9 339.7l6.4-1.5 6-2.3 2.6-.4.3-3.2-2.2-1.6-.8-3.5h-2.5l-.1-2.1-4.3-2.1-3.7-.9 1.5-2.7-2.3-1.8-15 8.9 1.9.9 2.1 5.2 2.1 1 2.3 2.6 1.3 2.4 2-.1z"
}), React.createElement("path", {
  d: "M325.8 280l4.9.3 2.1-1.5 1 1.1 10.5-7.3.9-3.9 4-.7-11.2-19.5h-11.9z"
}), React.createElement("path", {
  d: "M325.8 280l4.9.3 2.1-1.5 1 1.1 10.5-7.3.9-3.9 4-.7-11.2-19.5h-11.9z"
}), React.createElement("path", {
  d: "M355.5 491.1l1.3 1.5v4.6h1.2v4.3l2.1-.1-.2 13.4 19.2.1-.1-23.6z"
}), React.createElement("path", {
  d: "M355.5 491.1l1.3 1.5v4.6h1.2v4.3l2.1-.1-.2 13.4 19.2.1-.1-23.6z"
}), React.createElement("path", {
  d: "M245.3 131.7l4.2-.1v-23.1h-23v23.2z"
}), React.createElement("path", {
  d: "M245.3 131.7l4.2-.1v-23.1h-23v23.2z"
}), React.createElement("path", {
  d: "M124.9 391.9l3.2 4 7.2 1.2 4.5 4.3.8 1.4 5.9 1.9.8 1.4 2.3-.7 3.3 1 1.6-.7.7-3.7 1.1-1.6 1.8-.6 2.6-4.1 1 .6 2.7-1.8.8-1.4-1.4-.8 1.1-5 1.7-.4.6-1.8-.2-2.4 1-3.9 1.6-1.3.1-2.3h1l.2-1.9 2.1-2.3.8-3.4 2.3.4 2.2-1 1.1.6 1.3-2 5.6.1 1.1-3.1 1.9-1.8-49-39.9-15.8 12.9z"
}), React.createElement("path", {
  d: "M124.9 391.9l3.2 4 7.2 1.2 4.5 4.3.8 1.4 5.9 1.9.8 1.4 2.3-.7 3.3 1 1.6-.7.7-3.7 1.1-1.6 1.8-.6 2.6-4.1 1 .6 2.7-1.8.8-1.4-1.4-.8 1.1-5 1.7-.4.6-1.8-.2-2.4 1-3.9 1.6-1.3.1-2.3h1l.2-1.9 2.1-2.3.8-3.4 2.3.4 2.2-1 1.1.6 1.3-2 5.6.1 1.1-3.1 1.9-1.8-49-39.9-15.8 12.9z"
}), React.createElement("path", {
  d: "M452.9 335.5l1.1 1.1 3.2-1.3 2.2.7-.2 2 .3-2.7 3-2.4-1.8-.6-1.7-6.3-1.3-1.6 1.1-3.1-.6-2.6.6-3-.8-1.2.6-1.6-2-4.5.3-1.8-1.5-1.3-4.2 2.6-2.2 3-3.1 6.1-4.8 2.4-1.5 2.7 3.7.9 4.3 2.1.1 2.1h2.5l.8 3.5 2.2 1.6z"
}), React.createElement("path", {
  d: "M452.9 335.5l1.1 1.1 3.2-1.3 2.2.7-.2 2 .3-2.7 3-2.4-1.8-.6-1.7-6.3-1.3-1.6 1.1-3.1-.6-2.6.6-3-.8-1.2.6-1.6-2-4.5.3-1.8-1.5-1.3-4.2 2.6-2.2 3-3.1 6.1-4.8 2.4-1.5 2.7 3.7.9 4.3 2.1.1 2.1h2.5l.8 3.5 2.2 1.6z"
}), React.createElement("path", {
  d: "M487.5 413.7l5.4-1.9 6.6-6.4 3.7-9.4 4-1.1-7.7-13.2.8-4.6-1.7.1-.4-2-2.9-.3-.8.7-3.3.3-1.7 7.1h-3.8l.1 2.1-1.1.7-.8 2.8-2.8 1.8-4.3-1.7-2 .9-3.3 3.9 1.3 1.3-.1 4.8 3.4 2.7-.7.7.8 3.6 3.9.2 1.4 1.3.2 1.7 2.2 1.7 1 2z"
}), React.createElement("path", {
  d: "M487.5 413.7l5.4-1.9 6.6-6.4 3.7-9.4 4-1.1-7.7-13.3.8-4.5-1.7.1-.4-2-2.9-.3-.8.7-3.3.3-1.7 7.1h-3.8l.1 2.1-1.1.7-.8 2.8-2.8 1.8-4.3-1.7-2 .9-3.3 3.9 1.3 1.3-.1 4.8 3.4 2.7-.7.7.8 3.6 3.9.2 1.4 1.3.2 1.7 2.2 1.7 1 2z"
}), React.createElement("path", {
  d: "M525 186.6l1.4 1.2 3.9-1.1.5-.8 4.5-.1 1.6 1.5 6.5.4.5-2.5 2.3-.8 1.2.9 3.6-.2.6 1.4v-14.7l-1.7-1.3-2.8.6-1.7-1.6-1.5 2.1-2.5-.1-.3-1.3-1.1 1.6-1.6-.8-.4 1.2-1.5-.1-4.3-4.8-1.5 1-.3-1.2-1.6.8.8-1.8-2 .8-1.3-2-.8 1-1.2-1.6-.8.5-2.7-1v19.7l.7 1 1.7-.2z"
}), React.createElement("path", {
  d: "M525 186.6l1.4 1.2 3.9-1.1.5-.8 4.5-.1 1.6 1.5 6.5.4.5-2.5 2.3-.8 1.2.9 3.6-.2.6 1.4v-14.7l-1.7-1.3-2.8.6-1.7-1.6-1.5 2.1-2.5-.1-.3-1.3-1.1 1.6-1.6-.8-.4 1.2-1.5-.1-4.3-4.8-1.5 1-.3-1.2-1.6.8.8-1.8-2 .8-1.3-2-.8 1-1.2-1.6-.8.5-2.7-1v19.7l.7 1 1.7-.2z"
}), React.createElement("path", {
  d: "M378.2 251.7l10.4 17.7 3.4-1.9 3.7 6.3 14.4-8.1-2.2-2.4 2.1-2.5-2.3-.1-2.3-1.5 1-1-3.4-2.2 2.6-2-1.9-1.8-2.8-.5-.2-2.2.9-1.4-1-2.7 1.6-1.2-.8-.6-1.6.6-.2 1.5-2.3-.9v-1.3l-2.7-1.6z"
}), React.createElement("path", {
  d: "M378.2 251.7l10.4 17.7 3.4-1.9 3.7 6.3 14.4-8.1-2.2-2.4 2.1-2.5-2.3-.1-2.3-1.5 1-1-3.4-2.2 2.6-2-1.9-1.8-2.8-.5-.2-2.2.9-1.4-1-2.7 1.6-1.2-.8-.6-1.6.6-.2 1.5-2.3-.9v-1.3l-2.7-1.6z"
}), React.createElement("path", {
  d: "M216.8 202.7l.2 22.7h22.5v-22.8z"
}), React.createElement("path", {
  d: "M216.8 202.7l.2 22.7h22.5v-22.8z"
}), React.createElement("path", {
  d: "M352.5 329.4l.2 18.3 7.6 10.2 5.1-5.1 5.4-16.1 2.1-3.6-12.5-3.8z"
}), React.createElement("path", {
  d: "M352.5 329.4l.2 18.3 7.6 10.2 5.1-5.1 5.4-16.1 2.1-3.6-12.5-3.8z"
}), React.createElement("path", {
  d: "M343.2 392.4l17.4 6.9 12-16.5.3-2-1.6.2-3.1-3.8-.9.7-1.9-1.1-.6-1.6-1.5-1.3.1-1.7-1.6-.5v-2l1.8-1-3.6-1-4.7.1-1.1-1-2.2 1-1.9-.2-5.8 1.2-1.2 1.5z"
}), React.createElement("path", {
  d: "M343.2 392.4l17.4 6.9 12-16.5.3-2-1.6.2-3.1-3.8-.9.7-1.9-1.1-.6-1.6-1.5-1.3.1-1.7-1.6-.5v-2l1.8-1-3.6-1-4.7.1-1.1-1-2.2 1-1.9-.2-5.8 1.2-1.2 1.5z"
}), React.createElement("path", {
  d: "M382.3 302.1l3.6 6.6 8.9 1.8 13.6 6 2.5-7 8.2-4.9-9.1-15-2.8 1.8-3.3-3.9-21.4 12.9z"
}), React.createElement("path", {
  d: "M382.3 302.1l3.6 6.6 8.9 1.8 13.6 6 2.5-7 8.2-4.9-9.1-15-2.8 1.8-3.3-3.9-21.4 12.9z"
}), React.createElement("path", {
  d: "M386.4 446l10.9 2.4 8.4-12.9-2.4-1.2-.7.5-2-1.8-2.7-.8-.2-2.9-2.8-.8-1 .4-2.2-1-1.6-4.4-2-1.9-2-.1-4.1-2.4-7.5 2.7 12.3 23.9z"
}), React.createElement("path", {
  d: "M386.4 446l10.9 2.4 8.4-12.9-2.4-1.2-.7.5-2-1.8-2.7-.8-.2-2.9-2.8-.8-1 .4-2.2-1-1.6-4.4-2-1.9-2-.1-4.1-2.4-7.5 2.7 12.3 23.9z"
}), React.createElement("path", {
  d: "M313.8 156.9l.2 22.9 22.7.1v-23z"
}), React.createElement("path", {
  d: "M313.8 156.9l.2 22.9 22.7.1v-23z"
}), React.createElement("path", {
  d: "M393.8 351.3l14.6 14.2 12.7-13.4-2.5-10.5-5.1-4-7.5-4.1-5.4 10.6z"
}), React.createElement("path", {
  d: "M393.8 351.3l14.6 14.2 12.7-13.4-2.5-10.5-5.1-4-7.5-4.1-5.4 10.6z"
}), React.createElement("path", {
  d: "M308.3 373.5l27.1.2-.1 3 2.5.1 6.5-8-17.4-8.8-4.5-.4-14.1-.2z"
}), React.createElement("path", {
  d: "M308.3 373.5l27.1.2-.1 3 2.5.1 6.5-8-17.4-8.8-4.5-.4-14.1-.2z"
}), React.createElement("path", {
  d: "M157.5 157.4h18.9v-25.8h-18.8z"
}), React.createElement("path", {
  d: "M157.5 157.4h18.9v-25.8h-18.8z"
}), React.createElement("path", {
  d: "M441 356.7l1.5 2.7 5.4 4.2 3.6.5.8 2.9 1.8 2 .7 2.6 2.4.4 1.1 1.2 2.6.5 1.2 1.1 2.8-.1.2-2.9-1.7-.8 1.9-.4-1.5-6-2.3-.3-.9-1.5 1.3-2-1.5-1-.2-1.7 1.6-1.4-1-4.5-1.2-1-.8.8-5.6-2.2-9.9 1.6h-3l-1.6 1.1z"
}), React.createElement("path", {
  d: "M441 356.7l1.5 2.7 5.4 4.2 3.6.5.8 2.9 1.8 2 .7 2.6 2.4.4 1.1 1.2 2.6.5 1.2 1.1 2.8-.1.2-2.9-1.7-.8 1.9-.4-1.5-6-2.3-.3-.9-1.5 1.3-2-1.5-1-.2-1.7 1.6-1.4-1-4.5-1.2-1-.8.8-5.6-2.2-9.9 1.6h-3l-1.6 1.1z"
}), React.createElement("path", {
  d: "M343.2 400.5l.2 22.1h20.3l.1 1.8 10.3-8.7-13.5-16.4-17.4-6.9z"
}), React.createElement("path", {
  d: "M343.2 400.5l.2 22.1h20.3l.1 1.8 10.3-8.7-13.5-16.4-17.4-6.9z"
}), React.createElement("path", {
  d: "M219.6 108.5h23.5l.2-23.2h-23.5z"
}), React.createElement("path", {
  d: "M219.6 108.5h23.5l.2-23.2h-23.5z"
}), React.createElement("path", {
  d: "M336.7 179.9l23.3.1-.1-23.2-23.2.1z"
}), React.createElement("path", {
  d: "M336.7 179.9l23.3.1-.1-23.2-23.2.1z"
}), React.createElement("path", {
  d: "M420.6 444.8l2.2 3.6 3.3-.3 4.4-4.2.9-4.9-14.6 2.3.9 2.3z"
}), React.createElement("path", {
  d: "M427.8 448.3l-4 5.4-4 8.7 9-10.8z"
}), React.createElement("path", {
  d: "M414.1 456.2l2.2 3.5 4.5-7.3.3-3.2-4.8 3.3z"
}), React.createElement("path", {
  d: "M419.7 461.5v-.1l-.1-.1z"
}), React.createElement("path", {
  d: "M418.8 459l.1.4-.2-.5z"
}), React.createElement("path", {
  d: "M418.9 459.4l.2.6v-.2z"
}), React.createElement("path", {
  d: "M410.8 451.1l3.2 5 1.6-3-4-1.4z"
}), React.createElement("path", {
  d: "M420.6 444.8l2.2 3.6 3.3-.3 4.4-4.2.9-4.9-14.6 2.3.9 2.3z"
}), React.createElement("path", {
  d: "M427.8 448.3l-4 5.4-4 8.7 9-10.8z"
}), React.createElement("path", {
  d: "M414.1 456.2l2.2 3.5 4.5-7.3.3-3.2-4.8 3.3z"
}), React.createElement("path", {
  d: "M419.7 461.5v-.1l-.1-.1z"
}), React.createElement("path", {
  d: "M418.8 459l.1.4-.2-.5z"
}), React.createElement("path", {
  d: "M418.9 459.4l.2.6v-.2z"
}), React.createElement("path", {
  d: "M410.8 451.1l3.2 5 1.6-3-4-1.4z"
}), React.createElement("path", {
  d: "M509.6 282.1l2 2-.2 1.9 2.6.9.2 3.8 1 .4 1.4 5.3 4.6 2.2 5.4 1 2.3 1.3 4.6 1.3 14.3-3.4-2.7-1.8-1.4-2.1-1.7-.2-2.8-2.3-2.5-2.5-.5-1.5-2.4-.9-2.3-4.6-1.5.6-.8-1.9-5.7-.8-5.3-2-.8.3-1.8-2.2z"
}), React.createElement("path", {
  d: "M509.6 282.1l2 2-.2 1.9 2.6.9.2 3.8 1 .4 1.4 5.3 4.6 2.2 5.4 1 2.3 1.3 4.6 1.3 14.3-3.4-2.7-1.8-1.4-2.1-1.7-.2-2.8-2.3-2.5-2.5-.5-1.5-2.4-.9-2.3-4.6-1.5.6-.8-1.9-5.7-.8-5.3-2-.8.3-1.8-2.2z"
}), React.createElement("path", {
  d: "M156.7 225.5l.1 22.6h37.3v-22.6z"
}), React.createElement("path", {
  d: "M156.7 225.5l.1 22.6h37.3v-22.6z"
}), React.createElement("path", {
  d: "M463.7 252.3l-.1 2.9 1.5-.3.8 2.5-.8 1.8 2.2-.3-.6 4.6 4.6 1.6-.1 2.9 2.6.7 1.2 1.4.3 2.1.8 1.1 1.4-2.9 1.1 1.9-.8 1.7.6 1.5-1.6.2.5 2.4 4.1-1.2-.2-.7 16.6-2.7-.8-4.7-2.1-2.6-2.7-1.6-.5-3.5-1.3-.4.2-3.1.7-1.2-1.4-1.8 1.3-3-.2-3.4z"
}), React.createElement("path", {
  d: "M463.7 252.3l-.1 2.9 1.5-.3.8 2.5-.8 1.8 2.2-.3-.6 4.6 4.6 1.6-.1 2.9 2.6.7 1.2 1.4.3 2.1.8 1.1 1.4-2.9 1.1 1.9-.8 1.7.6 1.5-1.6.2.5 2.4 4.1-1.2-.2-.7 16.6-2.7-.8-4.7-2.1-2.6-2.7-1.6-.5-3.5-1.3-.4.2-3.1.7-1.2-1.4-1.8 1.3-3-.2-3.4z"
}));

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Counties",
  stroke: "#3a4a9f",
  strokeMiterlimit: 10
}, React.createElement("path", {
  fill: "#5a67ae",
  d: "M285.9 422.6l30.8.4-.2-22.6-30.5.3z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M285.9 422.6l30.8.4-.2-22.6-30.5.3z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M314.8 491.1l1.2 4.3-.6 1.3.4 2.8-.9 1.4.2 2.1 1.4.3 1.6 2.1-.4 1.5 2.9 1.8-.3 1.3 2.6 1.9 1.1 2.6.1 2.1 1.4 1.1.4 3.3 1.3 4.2 7-5.1 2.5-5.4-.1-23.8-16.6-.2-1.6-2.2z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M314.8 491.1l1.2 4.3-.6 1.3.4 2.8-.9 1.4.2 2.1 1.4.3 1.6 2.1-.4 1.5 2.9 1.8-.3 1.3 2.6 1.9 1.1 2.7.1 2 1.4 1.1.4 3.3 1.3 4.2 7-5.1 2.5-5.4-.1-23.8-16.6-.2-1.6-2.2z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M336.7 179.9l.1 23 22.9.3.3-23.2z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M336.7 179.9l.1 23 22.9.3.3-23.2z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M156.7 202.8h20.6v-22.4h-20.2z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M156.7 202.8h20.6v-22.4h-20.2z"
}), React.createElement("path", {
  fill: "#5b68ae",
  d: "M481.9 215.3l7.7 5.9 5.7.1 4 2.3 1.4-.7 1 1.7 1.3-1.5.1-23.1-1 2.7h-21.5z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M481.9 215.2l7.7 6 5.7.1 4 2.3 1.4-.7 1 1.7 1.3-1.5.1-23.1-1 2.7h-21.5z"
}), React.createElement("path", {
  fill: "#5c69af",
  d: "M381.9 200.6l22.8.6.7-23-23.4-.2z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M381.9 200.6l22.8.6.7-23-23.4-.2z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M145.2 270.5h23.2v-22.4h-11.6l-.1 4.4-11.4.1z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M145.2 270.5h23.2v-22.4h-11.6l-.1 4.4-11.4.1z"
}), React.createElement("path", {
  fill: "#5c68ae",
  d: "M360.6 399.3l9.5 11.6 20.2-17-5.7-6.6.8-1.2-10.7-.1-1.2.7-.9-3.9z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M360.6 399.3l9.5 11.6 20.2-17-5.7-6.6.8-1.2-10.7-.1-1.2.7-.9-3.9z"
}), React.createElement("path", {
  fill: "#737eb7",
  d: "M376.2 323.1l2.6.7 1.5-.9 1.7 1.1.1 1.3 2.1 1.7.9 3.8 1.5 1.2 2.6.8.3-.9 7.5-2.6 2.1 1.3.7-.5 2.9 1.2 4.8 3 7.9-2.8-5.1-14.1-15.5-6.9-8.9-1.8-5.9 6.1z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M376.2 323.1l2.6.7 1.5-.9 1.7 1.1.1 1.3 2.1 1.7.9 3.8 1.5 1.2 2.6.8.3-.9 7.5-2.6 2.1 1.3.7-.5 2.9 1.2 4.8 3 7.9-2.8-5.1-14.1-15.5-6.9-8.9-1.8-5.9 6.1z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M380.3 523.2l-2.1 8 6.3.7v4.2l14.6 2.4.8-1.7 2.7.4 1.3-2.2-1.2-11.2-18.2.1z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M380.3 523.2l-2.1 8 6.3.7v4.2l14.6 2.4.8-1.7 2.7.4 1.3-2.2-1.2-11.2-18.2.1z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M336.7 156.9V137l-1.7-.5-2.2 1.2-2.3-.7-4.2-.2-.9-6.4-2.2-3.6-2.6-.3-2.4-2.6-.8.9-.2 3.5-1.5.3-1.8-1.4-.1 29.7z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M336.7 156.9V137l-1.7-.5-2.2 1.2-2.3-.7-4.2-.2-.9-6.4-2.2-3.6-2.6-.3-2.4-2.6-.8.9-.2 3.5-1.5.3-1.8-1.4-.1 29.7z"
}), React.createElement("path", {
  fill: "#5f6cb0",
  d: "M359.9 156.8v-13l-2.8 1.1-3.2-3.8-2.2-1.2-1.6-.4-1.9 1.6-3.3-.1-2.9-1.4-1.2.7-4.1-3.3v19.9z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M359.9 156.8v-13l-2.8 1.1-3.2-3.8-2.2-1.2-1.6-.4-1.9 1.6-3.3-.1-2.9-1.4-1.2.7-4.1-3.3v19.9z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M267.3 85.3h23.6V61.9h-23.7z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M267.3 85.3h23.6V61.9h-23.7z"
}), React.createElement("path", {
  fill: "#5b68ae",
  d: "M437.9 392.6l14.5 14.2 15.1-9.2 5.1-5.8-1.2-.1-.7-2.3-2.6-1.3.5-.8-2.3-4.1-.7.3-2.2-2.3 1.4-1-1.2-.9.5-1.4-.7-2.4-2.5-1.8-2.6-.5-5.8 6-1.8 5.3z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M437.9 392.6l14.5 14.2 15.1-9.2 5.1-5.8-1.2-.1-.7-2.3-2.6-1.3.5-.8-2.3-4.1-.7.2-2.2-2.2 1.4-1-1.2-.9.5-1.4-.7-2.4-2.5-1.8-2.6-.5-5.8 6-1.8 5.3z"
}), React.createElement("path", {
  fill: "#6671b2",
  d: "M288.4 450.3l1.6 1.2 1.3 3.7 2.6.6-.3 2 1.7 1.4-.1 2.3.9.8.4 2.7 1.7 1.6 2.7 1.5 1.9 2.6 1.6.5 2.3 2.1 2-.6.6 1.8 1-.6 2 2.5-.8 3.2 2.1.8-1 7-1.5 1.1 1.9.7-.1 1.6 1.9.3 3.6-2.6 1.6 2.2 23.5.3-.2-39-25.7 1.3-.2-8.6-35.8.3 2.3 1.5 3.2 1z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M288.4 450.3l1.6 1.2 1.3 3.7 2.6.6-.3 2 1.7 1.4-.1 2.3.9.8.4 2.7 1.7 1.6 2.7 1.5 1.9 2.6 1.6.5 2.3 2.1 2-.6.6 1.8 1-.6 2 2.5-.8 3.2 2.1.8-1 7-1.5 1.1 1.9.7-.1 1.6 1.9.3 3.6-2.6 1.6 2.2 23.5.3-.2-39-25.7 1.3-.2-8.6-35.8.3 2.3 1.5 3.2 1z"
}), React.createElement("path", {
  fill: "#5b68ae",
  d: "M431.2 346.6l1.2 1.1 5.2-.3 1.1 5.1 1.6-1.1h3l9.9-1.6 5.6 2.2.8-.8-2-3.4 1.4-.3-.2-3 3.1-1.2.3-3-3-2.3.2-2-2.2-.7-3.2 1.3-1.1-1.1-2.6.4-6 2.3-6.4 1.5-1.9 2.1-2.5 1.4v1.5z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M431.2 346.6l1.2 1.1 5.2-.3 1.1 5.1 1.6-1.1h3l9.9-1.6 5.6 2.2.8-.8-2-3.4 1.4-.3-.2-3 3.1-1.2.3-3-3-2.3.2-2-2.2-.7-3.2 1.3-1.1-1.1-2.6.4-6 2.3-6.4 1.5-1.9 2.1-2.5 1.4v1.5z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M132.8 270.5l2.1 1 1.4-.5 1.2 2.2v4.3l.7 3.1 1.8 1.6 2.3-.4 2.6.9 3.2-.6.7 1.9 2.8 1 5.1.2.6-1 5.2 1.8 4.7 4.3 2.5-1.4.1-18.4z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M132.8 270.5l2.1 1 1.4-.5 1.2 2.2v4.3l.7 3.1 1.8 1.6 2.3-.4 2.6.9 3.2-.6.7 1.9 2.8 1 5.1.2.6-1 5.2 1.8 4.7 4.3 2.5-1.4.1-18.4z"
}), React.createElement("path", {
  fill: "#5c68ae",
  d: "M459.6 351.2l1.2 1 1 4.5-1.6 1.4.2 1.7 1.5 1-1.3 2 .9 1.5 2.3.3.7 3.8h2.7l6.4-3-5.9-19 5.3 4.1 1.6-.3-.1-7.9-12.4.8-3.3 1.4.2 3-1.4.3z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M459.6 351.2l1.2 1 1 4.5-1.6 1.4.2 1.7 1.5 1-1.3 2 .9 1.5 2.3.3.7 3.8h2.7l6.4-3-5.9-19 5.3 4.1 1.6-.3-.1-7.9-12.4.8-3.3 1.4.2 3-1.4.3z"
}), React.createElement("path", {
  fill: "#5d69af",
  d: "M472 310.8l1.4 12 10.1 6.1 10.5.2 1.4-18-3 .1.7-1.2-2.4-2.9v-6.2l-8 6.6-.5 1.5h-5.6l-1.2 1.1z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M472 310.8l1.4 12 10.1 6.1 10.5.2 1.4-18-3 .1.7-1.2-2.4-2.9v-6.2l-8 6.6-.5 1.5h-5.6l-1.2 1.1z"
}), React.createElement("path", {
  fill: "#5e6aaf",
  d: "M408.8 411.8l.6.8 2.6-.9 2 1.7 1.2 2.8-1 8.3 1 2.8 2.4-.1.6 1 1.8-.7 3 2.5 2.5.5 1.5-.9-.6-2.9-1.2-1 3.4-2.5 5.7-1.7 2.7-1.6-.4-2.9-1.2-.9-.6-3.7-1.2-2.1-2.3-1.2-1.8-5.2-4.6-2.1-1.7-2z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M408.8 411.8l.6.8 2.6-.9 2 1.7 1.2 2.8-1 8.3 1 2.8 2.4-.1.6 1 1.8-.7 3 2.5 2.5.5 1.5-.9-.6-2.9-1.2-1 3.4-2.5 5.7-1.7 2.7-1.6-.4-2.9-1.2-.9-.6-3.7-1.2-2.1-2.3-1.2-1.8-5.2-4.6-2.1-1.7-2z"
}), React.createElement("path", {
  fill: "#5c69ae",
  d: "M462.6 209.1v25l27.5.1-4.6-5.1-1.8-1.4V217l-1.8-1.7-1 .4-1.9-1.6-4.1-1.7-2.5.2-3-2.3-.6-1.1z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M462.6 209.1v25l27.5.1-4.6-5.1-1.8-1.4V217l-1.8-1.8-1 .5-1.9-1.6-4.1-1.7-2.5.2-3-2.3-.6-1.1z"
}), React.createElement("path", {
  fill: "#5c68ae",
  d: "M213.8 365.7l2.2 1 5.9-.3 1.5-2.1.1 2.4 3.7-1.3.3 1.9 1.4.2 1.8 2.3.5 2.4 2.2-.3.6.9-.5 2.8.9.7 1.2-3 1 3.4-.9 1.4 3.8 1.1 1 1.9 4 .9 2.3 4.7 2.5.9 2.8 2 .4 1.4 3.6 1.9 2.1-.7.2-3.7 1.4-.5.5-4-.1-43.9h-46.3z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M213.8 365.7l2.2 1 5.9-.3 1.5-2.1.1 2.4 3.7-1.3.3 1.9 1.4.2 1.8 2.3.5 2.4 2.2-.3.6.9-.5 2.8.9.7 1.2-3 1 3.4-.9 1.4 3.8 1.1 1 1.9 4 .9 2.3 4.7 2.5.9 2.8 2 .4 1.4 3.6 1.9 2.1-.7.2-3.7 1.4-.5.5-4-.1-43.9h-46.3z"
}), React.createElement("path", {
  fill: "#5b68ae",
  d: "M286 373.7v27l30.5-.3.1-26.9z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M286 373.7v27l30.5-.3.1-26.9z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M189.4 270.5l.8 29 22.9.3.1-29.3z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M189.4 270.5l.8 29 22.9.3.1-29.3z"
}), React.createElement("path", {
  fill: "#5b68ae",
  d: "M503 223.1l.6 1 2-.4 2.3 1.3 2.9-.2 6.8-2.8 2.7-3.6 2.5.4-.2-11.8-.6-1.3-18.9.1z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M503 223.1l.6 1 2-.4 2.3 1.3 2.9-.2 6.8-2.8 2.7-3.6 2.5.4-.2-11.8-.6-1.3-18.9.1z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M528.9 300.9l-4.2 2.4 4.9 24.7 20.8.1-1-2.6 1.6-4-1.4-1.6-1.6.1-.1-3.1-1-2.3-1.3-.3-.5-3.4-1-1.9.6-1.5-1.9-2 .5-1.1-2.6-2.7-1.4 1.2-.9-1-3 .7-1.6 1.2-.3-1.6z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M528.9 300.9l-4.2 2.4 4.9 24.7 20.8.1-1-2.6 1.6-4-1.4-1.6-1.6.1-.1-3.1-1-2.3-1.3-.3-.5-3.4-1-1.9.6-1.5-1.9-2 .5-1.1-2.6-2.7-1.4 1.2-.9-1-3 .7-1.6 1.2-.3-1.6z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M495.4 311.1l.6-2 2.7-.4.9 1v2.3l1.4.9 11.4-11.1 4.2-5.4-1.4-5.3-1-.4-.2-3.8-2.6-.9.2-1.9-20.9 16.8v6.2l2.4 2.9-.7 1.2z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M495.4 311.1l.6-2 2.7-.4.9 1v2.3l1.4.9 11.4-11.1 4.2-5.4-1.4-5.3-1-.4-.2-3.8-2.6-.9.2-1.9-20.9 16.8v6.2l2.4 2.9-.7 1.2z"
}), React.createElement("path", {
  fill: "#969dc3",
  d: "M391.1 353.5l2.7-2.2 6.8-7.2 5.4-10.6-3.3-2.2-2.9-1.2-.7.5-2.1-1.3-7.5 2.6-.3.9-2.6-.8-1.5-1.2-.9-3.8-2.1-1.7-.1-1.3-1.7-1.1-1.5.9-2.6-.7-2.9 6.3.9 1.6-3.4 5.7z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M391.1 353.5l2.7-2.2 6.8-7.2 5.4-10.6-3.3-2.2-2.9-1.2-.7.5-2.1-1.3-7.5 2.6-.3.9-2.6-.8-1.5-1.2-.9-3.8-2.1-1.7-.1-1.3-1.7-1.1-1.5.9-2.6-.7-2.9 6.3.9 1.6-3.4 5.7z"
}), React.createElement("path", {
  fill: "#5f6bb0",
  d: "M235.4 276.8l25.1.3.2 22.4 25.1-.1.2-25.2-5.4-.1v-5.7l-25.8-.2-1.6-.4-.2 7.3-17.6.3z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M235.4 276.8l25.1.3.2 22.4 25.1-.1.2-25.2-5.4-.1v-5.7l-25.8-.2-1.6-.4-.2 7.3-17.6.3z"
}), React.createElement("path", {
  fill: "#5b68ae",
  d: "M504.2 198.9l1 .1 2.6-2 4.3-.2 3.6 3.6 1.9 1.2.5-19.9-3.5-1.7-1.1.6-7.9-.7-1.4.4z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M504.2 198.9l1 .1 2.6-2 4.3-.2 3.6 3.6 1.9 1.2.5-19.9-3.5-1.7-1.1.6-7.9-.7-1.4.4z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M314 202.9h22.8l-.1-23-22.7-.1z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M314 202.9h22.8l-.1-23-22.7-.1z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M177.3 202.8H200v-22.5l-22.7.1z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M177.3 202.8H200v-22.5l-22.7.1z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M189.3 360.8l5.5 2.1 3.5 2.3 2.9.3.5-.8 4.5.9 3.6-1.2 2 1.4 2-.1.1-25.6.8-1.6 3.6-1.8-3.6-3.4.6-2.5 1.2.7.8-3.2 1.5-1.5-.7-1.9.4-1.6-2.4-1.7-18.8-.2v3h-9v15.9l-9.8.1V352z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M189.3 360.8l5.5 2.1 3.5 2.3 2.9.3.5-.8 4.5.9 3.6-1.2 2 1.4 2-.1.1-25.6.8-1.6 3.6-1.8-3.6-3.4.6-2.5 1.2.7.8-3.2 1.5-1.5-.7-1.9.4-1.6-2.4-1.7-18.8-.2v3h-9v15.9l-9.8.1V352z"
}), React.createElement("path", {
  fill: "#606cb0",
  d: "M284.2 248.3l22.8.1.1-22.8-22.6-.1z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M284.2 248.3l22.8.1.1-22.8-22.6-.1z"
}), React.createElement("path", {
  fill: "#c4c6d2",
  d: "M398.1 223.8l22.4.4.3-22.7-22.4-.5z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M398.1 223.8l22.4.4.3-22.7-22.4-.5z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M203.4 108.5v23.1l23.1.1v-23.2z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M203.4 108.5v23.1l23.1.1v-23.2z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M248.8 340.1l37-.1v-21.3l-37 .2z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M248.8 340.1l37-.1v-21.3l-37 .2z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M284.6 202.8h6.8l-.1-22.9h-23.1v22.7z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M284.6 202.8h6.8l-.1-22.9h-23.1v22.7z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M254.8 268.2l.1-20.1h-19.4l-.1 27.3 17.6-.3.2-7.3z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M254.8 268.2l.1-20.1h-19.4l-.1 27.3 17.6-.3.2-7.3z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M353.2 225.9v-22.8l-22.8-.2v23z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M353.2 225.9v-22.8l-22.8-.2v23z"
}), React.createElement("path", {
  fill: "#5c69af",
  d: "M327.3 525.8l.1 1.1 1.6.5 1.6 2.4-.8 2.5.7.7 2.4-.1 1.3 1 1.6-.4 1.2 1.5.7-1.1 1.5 1.9 3-.8 1.7 1.9h1.5l3.3 4 1.1.7 2.9-1.1 11.7-25.7-27.7-.1-2.5 5.4-7 5.1z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M327.3 525.8l.1 1.1 1.6.5 1.6 2.4-.8 2.5.7.7 2.4-.1 1.3 1 1.6-.4 1.2 1.5.7-1.1 1.5 1.9 3-.8 1.7 1.9h1.5l3.3 4 1.1.7 2.9-1.1 11.7-25.7-27.7-.1-2.5 5.4-7 5.1z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M380.8 240.5l3.5 7.6 10.3-6.2.7.2v-6l-7.4.1z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M380.8 240.5l3.5 7.6 10.3-6.2.7.2v-6l-7.4.1z"
}), React.createElement("path", {
  fill: "#6470b1",
  d: "M490.1 234.2l.1 3.1-1.9 3.3 1.2 1.5-.7 2.9.8.6 20.8-.2-.1-20.6-2.4.2-2.3-1.3-2 .4-.6-1-1.3 1.5-1-1.7-1.4.7-4-2.3-5.7-.1-5.9-4.2v10.7l1.8 1.4z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M490.1 234.2l.1 3.1-1.9 3.3 1.2 1.5-.7 2.9.8.6 20.8-.2-.1-20.6-2.4.2-2.3-1.3-2 .4-.6-1-1.3 1.5-1-1.7-1.4.7-4-2.3-5.7-.1-5.9-4.2v10.7l1.8 1.4z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M196.2 38.3h23.6V14.2l-23.6-.1z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M196.2 38.3h23.6V14.2l-23.6-.1z"
}), React.createElement("path", {
  fill: "#5b68ae",
  d: "M531.1 253.9v2.6l1.4 1.1 2.4 5.3.4 4.8.7 2.7 13.5 1.7 4.7 2.6 3.8-2.1 2.7 1.3.7-1.5-.1-3 1.2-1.5-1.9-2.4.7-1.3-2.3-2.5-1-3.2-1.4-1.4-1.8-.4-2-3.1z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M531.1 253.9v2.6l1.4 1.1 2.4 5.3.4 4.8.7 2.7 13.5 1.7 4.7 2.6 3.8-2.1 2.7 1.3.7-1.5-.1-3 1.2-1.5-1.9-2.4.7-1.3-2.3-2.5-1-3.2-1.4-1.4-1.8-.4-2-3.1z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M307.9 202.9h22.6v23h-22.6z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M307.9 202.9h22.6v23h-22.6z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M262 225.4l.2-22.8-16.8-.4-5.9.4v22.7z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M262 225.4l.2-22.8-16.8-.4-5.9.4v22.7z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M248.8 318.9l37-.2v-19.3l-37 .3z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M248.8 318.9l37-.2v-19.3l-37 .3z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M336.2 307.9h22.7l1.4-1-1.4-.5-.6-2.9.9-1.1-2-1.9 1.3-2.1-2-.5-1 1.5-1.1-1.9 1.8-2.1-2.7-1.6.3-1.7-2.8-2.6 1.2-.3.6-1.8-2.5.4-.5-2.3-2.6.6.7-3.1-1.9.1-1.7 1.5.2-1.8-3.5-.1-.6-1.5-2.8.3-2.7-1.4.1-1-1.2.8-1-1.1-2.1 1.5-.1 27.6z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M336.2 307.9h22.7l1.4-1-1.4-.5-.6-2.9.9-1.1-2-1.9 1.3-2.1-2-.5-1 1.5-1.1-1.9 1.8-2.1-2.7-1.6.3-1.7-2.8-2.6 1.2-.3.6-1.8-2.5.4-.5-2.3-2.6.6.7-3.1-1.9.1-1.7 1.5.2-1.8-3.5-.1-.6-1.5-2.8.3-2.7-1.4.1-1-1.2.8-1-1.1-2.1 1.5-.1 27.6z"
}), React.createElement("path", {
  fill: "#5d69af",
  d: "M383.5 452l.7.8 2.9.1.1 2.1-.4 2.7 5.1 1.2.7 1.7 1.7.9 1.2-1.3.9 1.7 2.7.5 8.6-1.3-1 1.1 4.5-1.3 1.7 2.8 2.4-2.6.9-1.6-5.4-8.4-2.5-3.1-1.2.9-3.6.1.2-1.2-2.1-.6-.2-1.2-2 1.3-.9-.7-1.2 1.8-10.9-2.4-3.8 3.1z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M383.5 452l.7.8 2.9.1.1 2.1-.4 2.7 5.1 1.2.7 1.7 1.7.9 1.2-1.3.9 1.7 2.7.5 8.6-1.3-1 1.1 4.5-1.3 1.7 2.8 2.4-2.6.9-1.6-5.4-8.4-2.5-3.1-1.2.9-3.6.1.2-1.2-2.1-.6-.2-1.2-2 1.3-.9-.7-1.2 1.8-10.9-2.4-3.8 3.1z"
}), React.createElement("path", {
  fill: "#5b68ae",
  d: "M502.5 337.2l14.1-7.2-1.1-1.2 1.7-1.5-4.9-.9-1.1-.9-2.7-.1.9-1.4-2.1-3.8-2.2 1.1-.2-1.7-1.1-.1-.4-2.5.6-2-4.4-3v-2.3l-.9-1-2.7.4-.6 2-1.4 18 2.3 5.1 3.1 1.4 1.4 1.4-.9 1.5z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M502.5 337.2l14.1-7.2-1.1-1.2 1.7-1.5-4.9-.9-1.1-.9-2.7-.1.9-1.4-2.1-3.8-2.2 1.1-.2-1.7-1.1-.1-.4-2.5.6-2-4.4-3v-2.3l-.9-1-2.7.4-.6 2-1.4 18 2.3 5.1 3.1 1.4 1.4 1.4-.9 1.5z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M536 270.4l3.9 3.3.5 3.2-.9 4.2.6 1.2-1.1 3.2.7 2.8-1.1 2.1.6 2 2.8 2.3 1.7.2 1.4 2.1 2.7 1.8 3.6-.8.4-1-.4-.5.8-4.9-.8-2.8 1.1-3.5-.9-2.4 2.6-2.8v-5.4l-4.7-2.6z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M536 270.4l3.9 3.3.5 3.2-.9 4.2.6 1.2-1.1 3.2.7 2.8-1.1 2.1.6 2 2.8 2.3 1.7.2 1.4 2.1 2.7 1.8 3.6-.8.4-1-.4-.5.8-4.9-.8-2.8 1.1-3.5-.9-2.4 2.6-2.8v-5.4l-4.7-2.6z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M557.4 295.8l13.6-.9.1-2.8-3.9-4.1.8-2.8-.2-1.6-1.4-.7.6-1.4-2.5-1.6 1.6-2.3-3.2-.6-2.2-3.1-2.7-1.3-3.8 2.1v5.4l-2.6 2.8.9 2.4-1.1 3.5.8 2.8-.8 4.9.4.5z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M557.4 295.8l13.6-.9.1-2.8-3.9-4.1.8-2.8-.2-1.6-1.4-.7.6-1.4-2.5-1.6 1.6-2.3-3.2-.6-2.2-3.1-2.7-1.3-3.8 2.1v5.4l-2.6 2.8.9 2.4-1.1 3.5.8 2.8-.8 4.9.4.5z"
}), React.createElement("path", {
  fill: "#5c69ae",
  d: "M510.4 233.4v27.1l23.3.1-1.2-3-1.4-1.1v-2.6l-3.9.1v-5.6l.9-4.1v-2.1l2.2-3.7 1.6-4.4.1-1.9-2.9-.7-1 .7-.9 1.8-1.6-.6z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M510.4 233.4v27.1l23.3.1-1.2-3-1.4-1.1v-2.6l-3.9.1v-5.6l.9-4.1v-2.1l2.2-3.7 1.6-4.4.1-1.9-2.9-.7-1 .7-.9 1.8-1.6-.6z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M286 274.2l17.1.2.3-26.1h-22.8v25.8z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M286 274.2l17.1.2.3-26.1h-22.8v25.8z"
}), React.createElement("path", {
  fill: "#5e6aaf",
  d: "M443.2 210.4h9.7l.1-8.8h-9.7z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M443.2 210.4h9.7l.1-8.8h-9.7z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M429.7 298.5l3.6 5.8-1.1 1 .7 2.3 1.3 1.5 1.2-.5.1 2.2 2.4 2.4-.1 2 1.3 1-.3 1.4 2.3 1.8 4.8-2.4 3.1-6.1 2.2-3 4.2-2.6-.8-2.2.7-2.3-1.6-1.7-.8-4.4-1.4-3.7.5-5.4z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M429.7 298.5l3.6 5.8-1.1 1 .7 2.3 1.3 1.5 1.2-.5.1 2.2 2.4 2.4-.1 2 1.3 1-.3 1.4 2.3 1.8 4.8-2.4 3.1-6.1 2.2-3 4.2-2.6-.8-2.2.7-2.3-1.6-1.7-.8-4.4-1.4-3.7.5-5.4z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M243.3 61.5v.4h23.9V38.2h-23.8z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M243.3 61.5v.4h23.9V38.2h-23.8z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M410.8 451.1l.8.6 9-6.9-2.9-1.2-.9-2.3 14.6-2.3-3-4.9 3.3.8-.1-2.3-1 .8-3.6-3.8-1.5.9-2.5-.5-3-2.5-1.8.7-.6-1-2.4.1-9.5 8.2-7.2 11.1.9.7 2-1.3.2 1.2 2.1.6-.2 1.2 3.6-.1 1.2-.9z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M410.8 451.1l.8.6 9-6.9-2.9-1.2-.9-2.3 14.6-2.3-3-4.9 3.3.8-.1-2.3-1 .8-3.6-3.8-1.5.9-2.5-.5-3-2.5-1.8.7-.6-1-2.4.1-9.5 8.2-7.2 11.1.9.7 2-1.3.2 1.2 2.1.6-.2 1.2 3.6-.1 1.2-.9z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M134 315.8l25.1-30.9-1.8-.7-.6 1-5.1-.2-2.8-1-.7-1.9-3.2.6-2.6-.9-2.3.4-1.8-1.6-.7-3.1v-4.3l-1.2-2.2-1.4.5-2.1-1-.6-2.7-1.9-.6-1-1.6-2.7.3-1.9-1.5-.7-3.9-1.2-2.2-2 1.1-2.9-6.2-1.2-.6h-2l-3.4 45.9z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M134 315.8l25.1-30.9-1.8-.7-.6 1-5.1-.2-2.8-1-.7-1.9-3.2.6-2.6-.9-2.3.4-1.8-1.6-.7-3.1v-4.3l-1.2-2.2-1.4.5-2.1-1-.6-2.7-1.9-.6-1-1.6-2.7.3-1.9-1.5-.7-3.9-1.2-2.2-2 1.1-2.9-6.2-1.2-.6h-2l-3.4 45.9z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M496.2 180.8l2.3.6 7.1-1.5 7.9.7 1.1-.6 3.5 1.7 1.5 2.3 1.2-.5v-19.7l-1.1-3-1.3 1.5-.9-1.9-1.2 1.5-2.7-2-.5-1.6-1.3-.4-.7-2.4-3.5-.1-.5-2-1 1.1-1.5-1.3-.5-1.7h-1.2l-2.8-1.3-2.2 2.6-.5 1.9h-1.3z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M496.2 180.8l2.3.6 7.1-1.5 7.9.7 1.1-.6 3.5 1.7 1.5 2.3 1.2-.5v-19.7l-1.1-3-1.3 1.5-.9-1.9-1.2 1.5-2.7-2-.5-1.6-1.3-.4-.7-2.4-3.5-.1-.5-2-1 1.1-1.5-1.3-.5-1.7h-1.2l-2.8-1.3-2.2 2.6-.5 1.9h-1.3z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M290.3 373.7l18-.2v-14.1l-3.9-.1.1-8.3h-10l-2.2-.5-.2 3-.8-.1-.5 6.5-1.4 2.7.9 2.4-1 1 .5 2.6-1.7.7 2 1.7z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M290.3 373.7l18-.2v-14.1l-3.9-.1.1-8.3h-10l-2.2-.5-.2 3-.8-.1-.5 6.5-1.4 2.7.9 2.4-1 1 .5 2.6-1.7.7 2 1.7z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M213.1 299.8l22 .1.3-29.3-22.2-.1z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M213.1 299.8l22 .1.3-29.3-22.2-.1z"
}), React.createElement("path", {
  fill: "#606cb0",
  d: "M195.9 108.6l23.7-.1.2-23.2H196z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M195.9 108.6l23.7-.1.2-23.2H196z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M468.8 209.2l.6 1.1 3 2.3 2.5-.2 4.1 1.7 1.9 1.6 1-.4-1.4-13.6h-12.1l-1.9 5.4z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M468.8 209.2l.6 1.1 3 2.3 2.5-.2 4.1 1.7 1.9 1.6 1-.5-1.4-13.5h-12.1l-1.9 5.4z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M77.7 330.5l.5 4.4 1.9.9-.3 1.2 2.1 2.4.5 1.4 2.5 2 .8 2.9-.4 2.2.4 3.1-.8 1.2 1.4 4.7-.4 1.1 5.1 8.3 1 4.5 3.4 3.6 2.9 1.8 2.7 2.7 3.2.3 2.4 1.7-.3 1.2 2.4 3.3 2.4.9 3.8 3.1 9 1.9 1 .6-.4-58.1h-4.4l-47.2-11 .3 1 2.4.6 1.6 3.3z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M77.7 330.5l.5 4.4 1.9.9-.3 1.2 2.1 2.4.5 1.4 2.5 2 .8 2.9-.4 2.2.4 3.1-.8 1.2 1.4 4.7-.4 1.1 5.1 8.3 1 4.5 3.4 3.6 2.9 1.8 2.7 2.7 3.2.3 2.4 1.7-.3 1.2 2.4 3.3 2.4.9 3.8 3.1 9 1.9 1 .6-.4-58.1h-4.4l-47.2-11 .3 1 2.4.6 1.6 3.3z"
}), React.createElement("path", {
  fill: "#5f6bb0",
  d: "M219.8 85.3V61.8h-23.6l-.2 23.5z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M219.8 85.3V61.8h-23.6l-.2 23.5z"
}), React.createElement("path", {
  fill: "#5c68ae",
  d: "M501 312.9l3 2.1-.6 2 .4 2.5 1.1.1.2 1.7 2.2-1.1 2.1 3.8-.9 1.4 2.7.1 1.1.9 4.9.9-1.7 1.5.8.9 13.7.1-5.3-26.5 4.2-2.4-2.3-1.3-5.4-1-4.6-2.2-4.2 5.4z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M501 312.9l3 2.1-.6 2 .4 2.5 1.1.1.2 1.7 2.2-1.1 2.1 3.8-.9 1.4 2.7.1 1.1.9 4.9.9-1.7 1.5.8.9 13.7.1-5.3-26.5 4.2-2.4-2.3-1.3-5.4-1-4.6-2.2-4.2 5.4z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M134 315.8l44.5 36.2v-11.6l9.8-.1v-15.9h9v-3l16.2.2-1.8-2.5-.3-2.5-1.9-6.2-1.4-.9.7-1.1-5.1-3.9-1.8-.5-2 .6-2.7-.4-2.7-1.9-3.4-.1-2.2-1.8-2.6-.9-1.7-2v-3.3l-1.2-1.7-2.8-2-2.6-.5-4.3-2.8-6.5 3.1-4.7-4.3-3.4-1.1z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M134 315.8l44.5 36.2v-11.6l9.8-.1v-15.9h9v-3l16.2.2-1.8-2.5-.3-2.5-1.9-6.2-1.4-.9.7-1.1-5.1-3.9-1.8-.5-2 .6-2.7-.4-2.7-1.9-3.4-.1-2.2-1.8-2.6-.9-1.7-2v-3.3l-1.2-1.7-2.8-2-2.6-.5-4.3-2.8-6.5 3.1-4.7-4.3-3.4-1.1z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M157.6 131.6h22.7v-23l-22.6-.1z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M157.6 131.6h22.7v-23l-22.6-.1z"
}), React.createElement("path", {
  fill: "#5f6cb0",
  d: "M375.5 223.6l22.6.2.3-22.8-22.4-.5z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M375.5 223.6l22.6.2.3-22.8-22.4-.5z"
}), React.createElement("path", {
  fill: "#5b67ae",
  d: "M552.8 253.6l-1.2-1v-20.3l-13.3 3.2-1.7-1.9-2.4.3-2.2-1.7-.1 1.9-1.6 4.4-2.2 3.7v2.1l-.9 4.1v5.6z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M552.8 253.6l-1.2-1v-20.3l-13.3 3.2-1.7-1.9-2.4.3-2.2-1.7-.1 1.9-1.6 4.4-2.2 3.7v2.1l-.9 4.1v5.6z"
}), React.createElement("path", {
  fill: "#5b68ae",
  d: "M357.6 226l17.8.1.6-25.6-16.3-.2v2.9l-6.5-.1v22.8z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M357.6 226l17.8.1.6-25.6-16.3-.2v2.9l-6.5-.1v22.8z"
}), React.createElement("path", {
  fill: "#5d6aaf",
  d: "M548.4 342.5l1 1.9-1 2.2 1.8 2.4-.8 1.5 2.7 1.1v1.7l3.3.8 1.1 1.1 2.6.5 5.1-1.8 1.5-1.8 1-.4-1.5-1.2 1.8-2.6-1.3-3.8.6-1.7z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M548.4 342.5l1 1.9-1 2.2 1.8 2.4-.8 1.5 2.7 1.1v1.7l3.3.8 1.1 1.1 2.6.5 5.1-1.8 1.5-1.8 1-.4-1.5-1.2 1.8-2.6-1.3-3.8.6-1.7z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M157.7 85.3H196l.2-23.9-38.5.3z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M157.7 85.3H196l.2-23.9-38.5.3z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M243.4 38.2h23.5l.1-24h-23.6z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M243.4 38.2h23.5l.1-24h-23.6z"
}), React.createElement("path", {
  fill: "#6a75b4",
  d: "M411.4 475.5l1 .3 3.2-6.3 4.6-6.5-2.1 1.2-4.5 6.3z"
}), React.createElement("path", {
  fill: "#6a75b4",
  d: "M381 472.8l2.3.8 2.1 3.1 22.6-.2 3.5-6.5-5.1-2.1-1-5.1-9-.9-.9-1.7-1.2 1.3-1.7-.9-.7-1.7-5.1-1.2.4-2.7-5.9 5.5z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M411.4 475.5l1 .3 3.2-6.3 4.6-6.5-2.1 1.2-4.5 6.3z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M381 472.8l2.3.8 2.1 3.1 22.6-.2 3.5-6.5-5.1-2.1-1-5.1-9-.9-.9-1.7-1.2 1.3-1.7-.9-.7-1.7-5.1-1.2.4-2.7-5.9 5.5z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M261.8 248.2l22.4.1.3-22.8-22.5-.1z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M261.8 248.2l22.4.1.3-22.8-22.5-.1z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M557.8 342.4h8.5l.1-2.4-1.6-.5-.9-2.7.9-2.5 1.9-2.1-1.5-4.4.2-2.2 2.2-1.2-.2-2.2 2.2-1.9 1.1-1.9-.3-2 2.6-4.1-.2-4 1.4-.8-.2-1.4-1.6-.6.5-1.8 2.1-1.3-.8-2.3-1.6-1.1 1.1-1-.6-3.6-2.1.5-13.6.9 2 10.8z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M557.8 342.4h8.5l.1-2.4-1.6-.5-.9-2.7.9-2.5 1.9-2.1-1.5-4.4.2-2.2 2.2-1.2-.2-2.2 2.2-1.9 1.1-1.9-.3-2 2.6-4.1-.2-4 1.4-.8-.2-1.4-1.6-.6.5-1.8 2.1-1.3-.8-2.3-1.6-1.1 1.1-1-.6-3.6-2.1.5-13.6.9 2 10.8z"
}), React.createElement("path", {
  fill: "#5c68ae",
  d: "M434.5 262.1l9.7 1 19.4-11.2-.6-3.8-1.6.6-.6-1 .7-2.9-2.8-.4.5-2.9-1.7.6-1.8-2.5-2.2-.2-.2-2-4.1-1.8-22.5 13.2z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M434.5 262.1l9.7 1 19.4-11.2-.6-3.8-1.6.6-.6-1 .7-2.9-2.8-.4.5-2.9-1.7.6-1.8-2.5-2.2-.2-.2-2-4.1-1.8-22.5 13.2z"
}), React.createElement("path", {
  fill: "#5c69af",
  d: "M515.6 276.9l1.8 2.2.8-.3 5.3 2 5.7.8.8 1.9 1.5-.6 2.3 4.6 2.4.9.5 1.5 2.5 2.5-.6-2 1.1-2.1-.7-2.8 1.1-3.2-.6-1.2.9-4.2-.5-3.2-3.9-3.3-.7-2.7-.4-4.8-1.2-2.3-21.2-.1-1.7 3.3 2.2 1-1.8.5v3l1.9 5.9z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M515.6 276.9l1.8 2.2.8-.3 5.3 2 5.7.8.8 1.9 1.5-.6 2.3 4.6 2.4.9.5 1.5 2.5 2.5-.6-2 1.1-2.1-.7-2.8 1.1-3.2-.6-1.2.9-4.2-.5-3.2-3.9-3.3-.7-2.7-.4-4.8-1.2-2.3-21.2-.1-1.7 3.3 2.2 1-1.8.5v3l1.9 5.9z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M245.3 131.7V157l22.9-.1v-25.3z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M245.3 131.7V157l22.9-.1v-25.3z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M522 205.7l.6 1.3h2.3l.1-20.4-1.8-2.3-1.7.2-.7-1-1.2.5-1.5-2.3-.5 19.9 2.2 2.9z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M522 205.7l.6 1.3h2.3l.1-20.4-1.8-2.3-1.7.2-.7-1-1.2.5-1.5-2.3-.5 19.9 2.2 2.9z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M196.2 38.3v23.5h23.6V38.3z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M196.2 38.3v23.5h23.6V38.3z"
}), React.createElement("path", {
  fill: "#747fb8",
  d: "M474.5 342.3l.1 7.9 1.8.1 4-.7 2.1-1.8h1.4l1.8-1.7 2.2 1.4 1.1 2 2.1-.6.7 1.1 2.6.9 1.7 2 2.1.1 7.3-6.7-3-9.1-2.6 1.3.9-1.5-1.4-1.4-3.1-1.4-2.4-5.3h-10.4l-10.1-6.1z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M474.5 342.3l.1 7.9 1.8.1 4-.7 2.1-1.8h1.4l1.8-1.7 2.2 1.4 1.1 2 2.1-.6.7 1.1 2.6.9 1.7 2 2.1.1 7.3-6.7-3-9.1-2.6 1.3.9-1.5-1.4-1.4-3.1-1.4-2.4-5.3h-10.4l-10.1-6.1z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M382 178h18.9l.1-25.4-3.4.9-1.2-.2v-2.6l-3.2-2-1.1.2-2 2.6-1.3.2-3.1 4-1.7.4-4.6-2.1-.1 24z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M382 178h18.9l.1-25.4-3.4.9-1.2-.2v-2.6l-3.2-2-1.1.2-2 2.6-1.3.2-3.1 4-1.7.4-4.6-2.1-.1 24z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M254.9 248.1l6.9.1.2-22.8-22.5-.1-.4 22.8z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M254.9 248.1l6.9.1.2-22.8-22.5-.1-.4 22.8z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M335 279.1l-.1 1 2.7 1.4 2.8-.3.6 1.5 3.5.1-.2 1.8 1.7-1.5 1.9-.1-.7 3.1 2.6-.6.5 2.3 2.5-.4-.6 1.8-1.2.3 2.8 2.6 12.9-9.2-9.8-16.1-11.7 1.9-.9 3.9z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M335 279.1l-.1 1 2.7 1.4 2.8-.3.6 1.5 3.5.1-.2 1.8 1.7-1.5 1.9-.1-.7 3.1 2.6-.6.5 2.3 2.5-.4-.6 1.8-1.2.3 2.8 2.6 12.9-9.2-9.8-16.1-11.7 1.9-.9 3.9z"
}), React.createElement("path", {
  fill: "#5b67ae",
  d: "M408.4 316.5l1.9.9 5.1 14.1 23.4-13.9.3-1.4-1.3-1 .1-2-2.4-2.4-.1-2.2-1.2.5-1.3-1.5-.7-2.3 1.1-1-3.6-6.1-18.8 11.3z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M408.4 316.5l1.9.9 5.1 14.1 23.4-13.9.3-1.4-1.3-1 .1-2-2.4-2.4-.1-2.2-1.2.5-1.3-1.5-.7-2.3 1.1-1-3.6-6.1-18.8 11.3z"
}), React.createElement("path", {
  fill: "#626eb1",
  d: "M213.2 270.5l-.1-22.4h-22.3v22.4z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M213.2 270.5l-.1-22.4h-22.3v22.4z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M313.5 318.7l-.1-11.8h-5.2v-7.4l-22.4-.1v19.3z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M313.5 318.7l-.1-11.8h-5.2v-7.4l-22.4-.1v19.3z"
}), React.createElement("path", {
  fill: "#5c68ae",
  d: "M343.2 400.5l-.1-30.2-5.3 6.5-2.5-.1.1-3-18.8-.2-.1 26.9z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M343.2 400.5l-.1-30.2-5.3 6.5-2.5-.1.1-3-18.8-.2-.1 26.9z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M343.3 452l20.5-.1-.1-29.3h-20.3z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M343.3 452l20.5-.1-.1-29.3h-20.3z"
}), React.createElement("path", {
  fill: "#6570b2",
  d: "M395.7 273.8l8.2 13.7 3.3 3.9 23.7-14.2-10.3-17.6z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M395.7 273.8l8.2 13.7 3.3 3.9 23.7-14.2-10.3-17.6z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M313.4 306.9h17.2l.1-26.6-4.9-.3-1.7-.8-3.2 3.7-5.9-3.1.5 1.3-3.3 1.1-1.1-3-2.8-.5-.1 28.2z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M313.4 306.9h17.2l.1-26.6-4.9-.3-1.7-.8-3.2 3.7-5.9-3.1.5 1.3-3.3 1.1-1.1-3-2.8-.5-.1 28.2z"
}), React.createElement("path", {
  fill: "#5c69af",
  d: "M262.5 408l2.5 2.5.9 3.2 1.1.1.5 3.1 1.2 1.1.3 3.9 2.4 1.1-.1 1.5 2.1 1.2-.5 1.6 1 2 2.3.7-1.4 1 1.4 2.4-.6 1.5 2.6 4.2-.2 1.9 1.6 1.9 1.5.2.5 1.9h4.3l.1-44.3-24.3.1.9 4.9z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M262.5 408l2.5 2.5.9 3.2 1.1.1.5 3.1 1.2 1.1.3 3.9 2.4 1.1-.1 1.5 2.1 1.2-.5 1.6 1 2 2.3.7-1.4 1 1.4 2.4-.6 1.5 2.6 4.2-.2 1.9 1.6 1.9 1.5.2.5 1.9h4.3l.1-44.3-24.3.1.9 4.9z"
}), React.createElement("path", {
  fill: "#5b68ae",
  d: "M480.3 417.5h.8l6.4-3.8-2.6-.2-1-2-2.2-1.7-.2-1.7-1.4-1.3-3.9-.2-.8-3.6.7-.7-3.4-2.7.1-4.8-1.3-1.3-4 4.1-15.1 9.2-.6 16.1 5.1-2.8-1.2 2.8 3.6 1.4 5-1.9 2.1 2.5-6.8 2.9-8.3 5.2 16.4-8.8 1.6-4.3 6.1-2.3 4.7-.1-10.4 5.5 5.7-2z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M480.3 417.5h.8l6.4-3.8-2.6-.2-1-2-2.2-1.7-.2-1.7-1.4-1.3-3.9-.2-.8-3.6.7-.7-3.4-2.7.1-4.8-1.3-1.3-4 4.1-15.1 9.2-.6 16.1 5.1-2.8-1.2 2.8 3.6 1.4 5-1.9 2.1 2.5-6.8 2.9-8.3 5.2 16.4-8.8 1.6-4.3 6.1-2.3 4.7-.1-10.4 5.5 5.7-2z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M313.4 306.9v22.5l22.8.1v-21.6h-5.6v-1z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M313.4 306.9v22.5l22.8.1v-21.6h-5.6v-1z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M194.1 248.1h22.6l.3-22.7-22.9.1z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M194.1 248.1h22.6l.3-22.7-22.9.1z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M522.8 211.5l8.5 5.1 5.4.1 3.8-1.6.9-1.4h1.5l.9 2.4 2 .5 1.4-2.5 1.9.2.4 2.6 2.1-.2v-9.8l-29 .1z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M522.8 211.5l8.5 5.1 5.4.1 3.8-1.6.9-1.4h1.5l.9 2.4 2 .5 1.4-2.5 1.9.2.4 2.6 2.1-.2v-9.8l-29 .1z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M458.6 312.9l13.4-2.1 3.4-.7 1.2-1.1h5.6l.5-1.5-.9.2-1.9-3.1 2.1-2.6-1.3-2.4-2.6.2-1.8-.7-9.2.1-3.2 1.2-5.5 3.8-3 1.1 1.5 1.3-.3 1.8z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M458.6 312.9l13.4-2.1 3.4-.7 1.2-1.1h5.6l.5-1.5-.9.2-1.9-3.1 2.1-2.6-1.3-2.4-2.6.2-1.8-.7-9.2.1-3.2 1.2-5.5 3.8-3 1.1 1.5 1.3-.3 1.8z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M200 202.8l22.7-.1V180l-22.7.3z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M200 202.8l22.7-.1V180l-22.7.3z"
}), React.createElement("path", {
  fill: "#6773b3",
  d: "M200 180.3l22.7-.3-.3-22.9-22.8.3z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M200 180.3l22.7-.3-.3-22.9-22.8.3z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M132.8 270.5h12.4l.1-17.9h-28.6l1.2.6 2.9 6.2 2-1.1 1.2 2.2.7 3.9 1.9 1.5 2.7-.3 1 1.6 1.9.6z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M132.8 270.5h12.4l.1-17.9h-28.6l1.2.6 2.9 6.2 2-1.1 1.2 2.2.7 3.9 1.9 1.5 2.7-.3 1 1.6 1.9.6z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M336.2 329.5l24.2-.2 2.7.8v-3.7l-2.1-.3-.1-1.7-1.6-3.9 1.4-.1-.4-1.3 1.7-2.3-2.3-.3-.2-1.6 2.4-2.6H360l-.3-1.6-1.3-.6.5-2.2h-22.7z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M336.2 329.5l24.2-.2 2.7.8v-3.7l-2.1-.3-.1-1.7-1.6-3.9 1.4-.1-.4-1.3 1.7-2.3-2.3-.3-.2-1.6 2.4-2.6H360l-.3-1.6-1.3-.6.5-2.2h-22.7z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M363.8 451.9l19.7.1-.9-2.9 4.2-3.4-12.3-23.9 3.7-1.3-4.1-4.8-10.3 8.7z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M363.8 451.9l19.7.1-.9-2.9 4.2-3.4-12.3-23.9 3.7-1.3-4.1-4.8-10.3 8.7z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M267.2 38.2l23.7.1V14.2H267l-.1 24z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M267.2 38.2l23.7.1V14.2H267l-.1 24z"
}), React.createElement("path", {
  fill: "#5b67ae",
  d: "M430.9 277.2l8.9 15.4 12.2-7-.2-.8 3.8-2-11.4-19.7-9.7-1-9.3 5.5z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M430.9 277.2l8.9 15.4 12.2-7-.2-.8 3.8-2-11.4-19.7-9.7-1-9.3 5.5z"
}), React.createElement("path", {
  fill: "#5d6aaf",
  d: "M502.5 337.2l5.9 17.9h1.3l.9 1.8-.8 1.8.8 1.9 23.5-.3-.1-11.3h-6.6l-6-19.1-5.1-.2.3.3z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M502.5 337.2l5.9 17.9h1.3l.9 1.8-.8 1.8.8 1.9 23.5-.3-.1-11.3h-6.6l-6-19.1-5.1-.2.3.3z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M452 285.6l-.5 5.4 1.4 3.7.8 4.4 1.6 1.7-.7 2.3.8 2.2 3-1.1 5.5-3.8 3.2-1.2 9.2-.1-.4-2.3 1.9-1.2-.8-2.4 1-1.1v-2l2.9-2.4-.1-2.1-1.3-.9-.9-4-1.6-.2.3-2.4-.5-2.4 1.6-.2-.6-1.5.8-1.7-1.1-1.9-1.4 2.9-.8-1.1-23.5 12.6z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M452 285.6l-.5 5.4 1.4 3.7.8 4.4 1.6 1.7-.7 2.3.8 2.2 3-1.1 5.5-3.8 3.2-1.2 9.2-.1-.4-2.3 1.9-1.2-.8-2.4 1-1.1v-2l2.9-2.4-.1-2.1-1.3-.9-.9-4-1.6-.2.3-2.4-.5-2.4 1.6-.2-.6-1.5.8-1.7-1.1-1.9-1.4 2.9-.8-1.1-23.5 12.6z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M421.1 352.1l.3 1 7.5-4.3 4.6-4.1v-1.5l2.5-1.4 1.9-2.1-2.4-1.2-2 .1-1.3-2.4-2.3-2.6-2.1-1-2.1-5.2-1.9-.9-8.4 5-7.9 2.8 6 3.3 5.1 4z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M421.1 352.1l.3 1 7.5-4.3 4.6-4.1v-1.5l2.5-1.4 1.9-2.1-2.4-1.2-2 .1-1.3-2.4-2.3-2.6-2.1-1-2.1-5.2-1.9-.9-8.4 5-7.9 2.8 6 3.3 5.1 4z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M411.7 385.7l13.2 16.1 16.5-13.6-10.1-12.2-1.8.1-.4-2-1.4-.9-11.7.3-2.7 2.4v3.6z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M411.7 385.7l13.2 16.1 16.5-13.6-10.1-12.2-1.8.1-.4-2-1.4-.9-11.8.3-2.6 2.4v3.6z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M359.2 302.4l23.1-.3.2-1.7-12-20.2-3.9 2.4.1.3-12.9 9.2-.3 1.7 2.7 1.6-1.8 2.1 1.1 1.9 1-1.5 2 .5-1.3 2.1z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M359.2 302.4l23.1-.3.2-1.7-12-20.2-3.9 2.4.1.3-12.9 9.2-.3 1.7 2.7 1.6-1.8 2.1 1.1 1.9 1-1.5 2 .5-1.3 2.1z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M199.6 157.4l-.2-25.8h-23v25.8z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M199.6 157.4l-.2-25.8h-23v25.8z"
}), React.createElement("path", {
  fill: "#5c68ae",
  d: "M496.2 180.8l-.1-26.1-5.5.5-1-1.1-3.7.4-.6-2.6-1.7-.7-1.3 1.8-1.8.1-1.2 1.1-2.7-.3-.5 2.4-1.6-.8-1.7 1.2-.5.5-.1 19.3 1.4.1 2.9-1.8 3.4 1.2 1.7-.8 3.5.6 1.6 1.5 1.4-.5 5.3 3.4z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M496.2 180.8l-.1-26.1-5.5.5-1-1.1-3.7.4-.6-2.6-1.7-.7-1.3 1.8-1.8.1-1.2 1.1-2.7-.3-.5 2.4-1.6-.8-1.7 1.2-.5.5-.1 19.3 1.4.1 2.9-1.8 3.4 1.2 1.7-.8 3.5.6 1.6 1.5 1.4-.5 5.3 3.4z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M317.4 444.7l.2 8.6 25.7-1.3.1-29.4-26.1.4z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M317.4 444.7l.2 8.6 25.7-1.3.1-29.4-26.1.3z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M291.3 179.9l22.7-.1-.1-17.6-.8-1.7-2.7-1.7-2 .6-1.5-1.4-2.7-.7-.2 1.4-2.1-.1-.4-1.1-3.3.3-.1-1H291z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M291.3 179.9l22.7-.1-.1-17.6-.8-1.7-2.7-1.7-2 .6-1.5-1.4-2.7-.7-.2 1.4-2.1-.1-.4-1.1-3.3.3-.1-1H291z"
}), React.createElement("path", {
  fill: "#5b68ae",
  d: "M405.9 490.5h1.1l5.4-14.7-1-.3-3.7 7.2z"
}), React.createElement("path", {
  fill: "#5b68ae",
  d: "M375.9 491.3h3.1v2.6l1.6-1.2 4.8-.5 1.9-1.4 5.9-.8-3.2-6.4 4.3 5.8 4.5-2 2.7-3.1-1.2 5.5 3.8-1.5 3.9-11.8-22.6.2-2.1-3.1-2.3-.8h-5.2z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M405.9 490.5h1.1l5.4-14.7-1-.3-3.7 7.2z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M375.9 491.3h3.1v2.6l1.6-1.2 4.8-.5 1.9-1.4 5.9-.8-3.2-6.4 4.3 5.8 4.5-2 2.7-3.1-1.2 5.5 3.8-1.5 3.9-11.8-22.6.2-2.1-3.1-2.3-.8h-5.2z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M261.7 400.8l24.3-.1v-27h-25.8l.1 10.3-.5 4-1.4.5-.2 3.7-2.1.7 1.3 2.7-.5.7z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M261.7 400.8l24.3-.1v-27h-25.8l.1 10.3-.5 4-1.4.5-.2 3.7-2.1.7 1.3 2.7-.5.7z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M268.2 179.9h23.1l-.3-23.1-22.8.1z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M268.2 179.9h23.1l-.3-23.1-22.8.1z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M301.6 340l19.8.2-.1-10.8h-7.9l.1-10.7h-27.7V340z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M301.6 340l19.8.2-.1-10.8h-7.9l.1-10.7h-27.7V340z"
}), React.createElement("path", {
  fill: "#5c69ae",
  d: "M308.3 359.4l14.1.2 4.5.4 11.4 5.7-.2-18-16.6.2-.1-7.7-19.8-.2-.1 11h3l-.1 8.3z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M308.3 359.4l14.1.2 4.5.4 11.4 5.7-.2-18-16.6.2-.1-7.7-19.8-.2-.1 11h3l-.1 8.3z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M245.4 202.2l22.8.4v-22.7h-22.8z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M245.4 202.2l22.8.4v-22.7h-22.8z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M409.3 523.8l-3.3-15.1-.4-6.5 1.4-11.7h-.8l-1.1 7.5-.1 9.3 3.6 15-.7 1.5z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M379.1 514.9v8.1l5.4.9 18.2-.1-1.1-7.4-4-4.3v-7.8l3.6-.1-1.1-4.2 2.3-1.8.2-7-3.8 1.9-5.4-2.4-6.1.1-1.9 1.4-4.8.5-1.6 1.2z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M409.3 523.8l-3.3-15.1-.4-6.5 1.4-11.7h-.8l-1.1 7.5-.1 9.3 3.6 15-.7 1.5z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M379.1 514.9v8.1l5.4.9 18.2-.1-1.1-7.4-4-4.3v-7.8l3.6-.1-1.1-4.2 2.3-1.8.2-7-3.8 1.9-5.4-2.4-6.1.1-1.9 1.4-4.8.5-1.6 1.2z"
}), React.createElement("path", {
  fill: "#5b68ae",
  d: "M338.3 365.7l6 3.1 5.8-1.2 10.2-9.7-7.6-10.2h-14.6z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M338.3 365.7l6 3.1 5.8-1.2 10.2-9.7-7.6-10.2h-14.6z"
}), React.createElement("path", {
  fill: "#5f6bb0",
  d: "M442.8 224.3l1.1 1-.3 2.3 1.5 2.5 1.8 1.2-.7 2.7 16.4.1v-25l-9.7-.2v1.5h-9.7l-.1 14z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M442.8 224.3l1.1 1-.3 2.3 1.5 2.5 1.8 1.2-.7 2.7 16.4.1v-25l-9.7-.2v1.5h-9.7l-.1 14z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M374.1 415.7l4.1 4.8 3.8-1.4 4.1 2.4 2 .1 8.9-7.3-7.9-9.7 6.3-5.1-5.1-5.6-20.2 17z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M374.1 415.7l4.1 4.8 3.8-1.4 4.1 2.4 2 .1 8.9-7.3-7.9-9.7 6.3-5.1-5.1-5.6-20.2 17z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M307.1 225.9h.8v-23l-23.3-.1-.1 22.7 22.6.1z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M307.1 225.9h.8v-23l-23.3-.1-.1 22.7 22.6.1z"
}), React.createElement("path", {
  fill: "#616db0",
  d: "M395.3 236.1v6l2 1.4v1.3l2.3.9.2-1.5 1.6-.6v-.4l17-4.3v-14.8l-23.2-.3z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M395.3 236.1v6l2 1.4v1.3l2.3.9.2-1.5 1.6-.6v-.4l17-4.3v-14.8l-23.2-.3z"
}), React.createElement("path", {
  fill: "#5b68ae",
  d: "M368.2 491.2l7.7.1-.1-18.5h5.2l.3-12.3 5.9-5.5-.1-2.1-2.9-.1-.7-.8-15.4-.1z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M368.2 491.2l7.7.1-.1-18.5h5.2l.3-12.3 5.9-5.5-.1-2.1-2.9-.1-.7-.8-15.4-.1z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M336.7 514.7l23.2.1.2-13.4-2.1.1v-4.3h-1.2v-4.6l-1.3-1.5.1-3.8-4.5-.7-7.6.1v4.3l-6.9-.1z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M336.7 514.7l23.2.1.2-13.4-2.1.1v-4.3h-1.2v-4.6l-1.3-1.5.1-3.8-4.5-.7-7.6.1v4.3l-6.9-.1z"
}), React.createElement("path", {
  fill: "#6571b2",
  d: "M534.1 360.3l3.7.1.2 16.5 14.9-6h7.7l-4.8-5.1-.1-3.5 3.5-4.5-.1-2.1-2.6-.5-1.1-1.1-3.3-.8v-1.7l-2.7-1.1.8-1.5-1.8-2.4-4.1-1.4-1.1 1.1-1.8-.1-.7 2.6-4.7 1-2-.8z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M534.1 360.3l3.7.1.2 16.5 14.9-6h7.7l-4.8-5.1-.1-3.5 3.5-4.5-.1-2.1-2.6-.5-1.1-1.1-3.3-.8v-1.7l-2.7-1.1.8-1.5-1.8-2.4-4.1-1.4-1.1 1.1-1.8-.1-.7 2.6-4.7 1-2-.8z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M72.9 322.8l47.2 11h4.4l15.8-12.9-29-22.4z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M72.9 322.8l47.2 11h4.4l15.8-12.9-29-22.4z"
}), React.createElement("path", {
  fill: "#5b68ae",
  d: "M550.4 328.1l-2 4.6v1.9l1.4 2.4-1.6 3.4 1.1 1.2-.9.9 9.4-.1 1.6-35.8-2-10.8-5.6 1.2-.4 1-17.9 4.2.3 1.6 1.6-1.2 3-.7.9 1 1.4-1.2 2.6 2.7-.5 1.1 1.9 2-.6 1.5 1 1.9.5 3.4 1.3.3 1 2.3.1 3.1 1.6-.1 1.4 1.6-1.6 4z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M550.4 328.1l-2 4.6v1.9l1.4 2.4-1.6 3.4 1.1 1.2-.9.9 9.4-.1 1.6-35.8-2-10.8-5.6 1.2-.4 1-17.9 4.2.3 1.6 1.6-1.2 3-.7.9 1 1.4-1.2 2.6 2.7-.5 1.1 1.9 2-.6 1.5 1 1.9.5 3.4 1.3.3 1 2.3.1 3.1 1.6-.1 1.4 1.6-1.6 4z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M437.1 418.9l3.8.8 6.3-.1 1.7 1.7 2.9-.1.6-14.4-15.3-15-12.2 10 4.6 2.1 1.8 5.2 2.3 1.2 1.2 2.1.6 3.7 1.2.9z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M437.1 418.9l3.8.8 6.3-.1 1.7 1.7 2.9-.1.6-14.4-15.3-15-12.2 10 4.6 2.1 1.8 5.2 2.3 1.2 1.2 2.1.6 3.7 1.2.9z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M376 200.5l5.9.1.1-22.6h-2.7v-1.8H360l-.3 24.1z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M376 200.5l5.9.1.1-22.6h-2.7v-1.8H360l-.3 24.1z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M248.8 299.7l11.9-.2-.2-22.4-25.1-.3-.3 23.1z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M248.8 299.7l11.9-.2-.2-22.4-25.1-.3-.3 23.1z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M219.8 61.6l23.5-.1.1-23.2h-23.6z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M219.8 61.6l23.5-.1.1-23.2h-23.6z"
}), React.createElement("path", {
  fill: "#5e6aaf",
  d: "M462.6 209.1l6.2.1-2.3-2.1 1.9-5.4h3.6l.1-22.5-19.1 3.1-.1 26.6z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M462.6 209.1l6.2.1-2.3-2.1 1.9-5.4h3.6l.1-22.5-19.1 3.1-.1 26.6z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M28.4 284.1l1.9 1.2 1 2.6 2.4 1.1 4.5 6.3 5.5 2.8 2.7 2.9.3 1.9 3.5 3.5 3.7 2.6.8 2.6h1.5l3.1 1.2 1.5 1.6 1.7-.6 2.4 2.8 2 .1 2.4 3.2h2.4l1.2 2.9 2.7-1.7.1-8.8h.4l-.5-59.8H28.3l.2 26.9H30l.1 2.8z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M28.4 284.1l1.9 1.2 1 2.6 2.4 1.1 4.5 6.3 5.5 2.8 2.7 2.9.3 1.9 3.5 3.5 3.7 2.6.8 2.6h1.5l3.1 1.2 1.5 1.6 1.7-.6 2.4 2.8 2 .1 2.4 3.2h2.4l1.2 2.9 2.7-1.7.1-8.8h.4l-.5-59.8H28.3l.2 26.9H30l.1 2.8z"
}), React.createElement("path", {
  fill: "#5b68ae",
  d: "M235.5 248.1h3.6l.4-22.7H217l-.3 22.7z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M235.5 248.1h3.6l.4-22.7H217l-.3 22.7z"
}), React.createElement("path", {
  fill: "#5b67ae",
  d: "M482.7 307.5l28.9-23.4-4.8-4-1.5-.2.3-1.8-2.2-1.8.2-1.2-1.6-1.1-1.4.7-2.8-1.2-16.6 2.7.2.7-4.1 1.2-.3 2.4 1.6.2.9 4 1.3.9.1 2.1-2.9 2.4v2l-1 1.1.8 2.4-1.9 1.2.4 2.3 1.8.7 2.6-.2 1.3 2.4-2.1 2.6 1.9 3.1z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M482.7 307.5l28.9-23.4-4.8-4-1.5-.2.3-1.8-2.2-1.8.2-1.2-1.6-1.1-1.4.7-2.8-1.2-16.6 2.7.2.7-4.1 1.2-.3 2.4 1.6.2.9 4 1.3.9.1 2.1-2.9 2.4v2l-1 1.1.8 2.4-1.9 1.2.4 2.3 1.8.7 2.6-.2 1.3 2.4-2.1 2.6 1.9 3.1z"
}), React.createElement("path", {
  fill: "#5b68ae",
  d: "M480.6 202.7l15.6-.1v-21.7l-1.4.9-2.6-.6-4.4 1.3-3.6-.6-4 3-3.7.3-.9 1.9-3.6 2.1v12.5h8.5z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M480.6 202.7l15.6-.1v-21.7l-1.4.9-2.6-.6-4.4 1.3-3.6-.6-4 3-3.7.3-.9 1.9-3.6 2.1v12.5h8.5z"
}), React.createElement("path", {
  fill: "#5c69ae",
  d: "M375.4 226.1l5.4 14.4 7.1-4.3 7.4-.1-.1-12.3-19.7-.2z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M375.4 226.1l5.4 14.4 7.1-4.3 7.4-.1-.1-12.3-19.7-.2z"
}), React.createElement("path", {
  fill: "#5b67ae",
  d: "M176.4 157.4l.9 23 22.7-.1-.4-22.9z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M176.4 157.4l.9 23 22.7-.1-.4-22.9z"
}), React.createElement("path", {
  fill: "#5b68ae",
  d: "M410.1 265.7l10.5-6.1 4.6 8 9.3-5.5-7.8-13.3-1.9 1.1-6.4-11-17 4.3.8 1-1.6 1.2 1 2.7-.9 1.4.2 2.2 2.8.5 1.9 1.8-2.6 2 3.4 2.2-1 1 2.3 1.5 2.3.1-2.1 2.5z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M410.1 265.7l10.5-6.1 4.6 8 9.3-5.5-7.8-13.3-1.9 1.1-6.4-11-17 4.3.8 1-1.6 1.2 1 2.7-.9 1.4.2 2.2 2.8.5 1.9 1.8-2.6 2 3.4 2.2-1 1 2.3 1.5 2.3.1-2.1 2.5z"
}), React.createElement("path", {
  fill: "#818bbc",
  d: "M355.6 542.3l.7.6 2.6-.8.1 1.2 2.5 2.1 2.2 1 1.3 1.6 4.8 2.3 1.7.1 1-.8h2.5l.4 1.6 1.7-1.3 2.8.6 4.6-.8v-17.8l-6.3-.7 2.1-8-1.2-.2v-8.1l-14.7-.1-11.7 25.7 1.1 1.6z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M355.6 542.3l.7.6 2.6-.8.1 1.2 2.5 2.1 2.2 1 1.3 1.6 4.8 2.3 1.7.1 1-.8h2.5l.4 1.6 1.7-1.3 2.8.6 4.6-.8v-17.8l-6.3-.7 2.1-8-1.2-.2v-8.1l-14.7-.1-11.7 25.7 1.1 1.6z"
}), React.createElement("path", {
  fill: "#5d6aaf",
  d: "M449.2 235.6l4.1 1.8.2 2 2.2.2 1.8 2.5 1.7-.6-.5 2.9 2.8.4-.7 2.9.6 1 1.6-.6.7 4.2 27.3-4.1-1.4-2.6-.8-.6.7-2.9-1.2-1.5 1.9-3.3-.1-3.1-43.9-.2z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M449.2 235.6l4.1 1.8.2 2 2.2.2 1.8 2.5 1.7-.6-.5 2.9 2.8.4-.7 2.9.6 1 1.6-.6.7 4.2 27.3-4.1-1.4-2.6-.8-.6.7-2.9-1.2-1.5 1.9-3.3-.1-3.1-43.9-.2z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M267.2 61.9h23.7V38.3l-23.7-.1z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M267.2 61.9h23.7V38.3l-23.7-.1z"
}), React.createElement("path", {
  fill: "#636fb1",
  d: "M378.5 367.2l5.4-5.3-.8-1.3 4.4-3.1 1.4-2.1 2.2-1.9-20.3-16.8-5.4 16.1 11.7 9.6z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M378.5 367.2l5.4-5.3-.8-1.3 4.4-3.1 1.4-2.1 2.2-1.9-20.3-16.8-5.4 16.1 11.7 9.6z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M291.3 179.9l.1 22.9 22.6.1v-23.1z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M291.3 179.9l.1 22.9 22.6.1v-23.1z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M196.2 61.4V38.3h-38.4l-.1 23.4z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M196.2 61.4V38.3h-38.4l-.1 23.4z"
}), React.createElement("path", {
  fill: "#5d69af",
  d: "M522.8 218.8v12l2.6 1.2 2.7.2 1-.7 2.9.7 2.2 1.7 2.4-.3 1.7 1.9 13.3-3.2v-15.6l-2.1.2-.4-2.6-1.9-.2-1.4 2.5-2-.5-.9-2.4h-1.5l-.9 1.4-3.8 1.6-5.4-.1-8.5-5.1z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M522.8 218.8v12l2.6 1.2 2.7.2 1-.7 2.9.7 2.2 1.7 2.4-.3 1.7 1.9 13.3-3.2v-15.6l-2.1.2-.4-2.6-1.9-.2-1.4 2.5-2-.5-.9-2.4h-1.5l-.9 1.4-3.8 1.6-5.4-.1-8.5-5.1z"
}), React.createElement("path", {
  fill: "#fff",
  d: "M473.6 365.4l9.4 6.1 8.2 4.4 3.3-.3.8-.7 2.9.3.4 2 1.7-.1 2.2 2.9 2.7-.6 4.6-5.3.7-3.4-4.9-3.8 1-3.4 2.4 5.3 3.8 2.4.6-1.3-1.3-.9 1.4-2.5.3-3-2.6-1.7-1.4-3.1.8-1.8-.9-1.8h-1.3l-2.9-8.8-7.3 6.7-2.1-.1-1.7-2-2.6-.9-.7-1.1-2.1.6-1.1-2-2.2-1.4-1.8 1.7h-1.4l-2.1 1.8-7.4.9-5.3-4.1z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M473.6 365.4l9.4 6.1 8.2 4.4 3.3-.3.8-.7 2.9.3.4 2 1.7-.1 2.2 2.9 2.7-.6 4.6-5.3.7-3.4-4.9-3.8 1-3.4 2.4 5.3 3.8 2.4.6-1.3-1.3-.9 1.4-2.5.3-3-2.6-1.7-1.4-3.1.8-1.8-.9-1.8h-1.3l-2.9-8.8-7.3 6.7-2.1-.1-1.7-2-2.6-.9-.7-1.1-2.1.6-1.1-2-2.2-1.4-1.8 1.7h-1.4l-2.1 1.8-7.4.9-5.3-4.1z"
}), React.createElement("path", {
  fill: "#5c69ae",
  d: "M534 349l2 .8 4.7-1 .7-2.6 1.8.1 1.1-1.1 4.1 1.4 1-2.2-1-1.9.9-.9-1.1-1.2 1.6-3.4-1.4-2.4v-1.9l2-4.6-20.8-.1.4 1.8-8.6.1 6 19.1z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M534 349l2 .8 4.7-1 .7-2.6 1.8.1 1.1-1.1 4.1 1.4 1-2.2-1-1.9.9-.9-1.1-1.2 1.6-3.4-1.4-2.4v-1.9l2-4.6-20.8-.1.4 1.8-8.6.1 6 19.1z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M291 136.3l9.9 7 1.1-.5 3.2.7.9-.5 4.6 2.2.5-.9 2 .4.6-1 .1-16.5-1.9-1-2.7-.1-.9 2.3-4.1-.2-2.6-2.3-7.5-8.2-3.2.8z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M291 136.3l9.9 7 1.1-.5 3.2.7.9-.5 4.6 2.2.5-.9 2 .4.6-1 .1-16.5-1.9-1-2.7-.1-.9 2.3-4.1-.2-2.6-2.3-7.5-8.2-3.2.8z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M219.8 38.3h23.6V14.2h-23.6z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M219.8 38.3h23.6V14.2h-23.6z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M366.6 282.6l22-13.2-10.4-17.7-8.9 5.1 2.3 3.9-13.5 8.2z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M366.6 282.6l22-13.2-10.4-17.7-8.9 5.1 2.3 3.9-13.5 8.2z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M268.2 131.6h4.4l.1-23.1h-23.2v23.1z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M268.2 131.6h4.4l.1-23.1h-23.2v23.1z"
}), React.createElement("path", {
  fill: "#5b68ae",
  d: "M199.4 131.6l.2 25.8 22.8-.3v-25.4z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M199.4 131.6l.2 25.8 22.8-.3v-25.4z"
}), React.createElement("path", {
  fill: "#616db0",
  d: "M364.8 375.2l.6 1.6 1.9 1.1.9-.7 3.1 3.8 1.6-.2-.3 2 .9 3.9 1.2-.7 10.7.1 9.1-13.7-2.9-.9-3-2.6-.6-1.9-1 .1-1.7-2.3-.3-2.2-1.1-.7-9.4 8.8z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M364.8 375.2l.6 1.6 1.9 1.1.9-.7 3.1 3.8 1.6-.2-.3 2 .9 3.9 1.2-.7 10.7.1 9.1-13.7-2.9-.9-3-2.6-.6-1.9-1 .1-1.7-2.3-.3-2.2-1.1-.7-9.4 8.8z"
}), React.createElement("path", {
  fill: "#5b68ae",
  d: "M458.6 312.9l-.6 1.6.8 1.2-.6 3 .6 2.6-1.1 3.1 1.3 1.6 1.7 6.3 1.8.6-3 2.4-.3 2.7 3 2.3-.3 3 12.6-1-1.1-19.5-1.4-12z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M458.6 312.9l-.6 1.6.8 1.2-.6 3 .6 2.6-1.1 3.1 1.3 1.6 1.7 6.3 1.8.6-3 2.4-.3 2.7 3 2.3-.3 3 12.6-1-1.1-19.5-1.4-12z"
}), React.createElement("path", {
  fill: "#5f6bb0",
  d: "M510.4 233.4h15.2l1.6.6.9-1.8-2.7-.2-2.6-1.2v-12l-2.5-.4-2.7 3.6-7.3 2.8z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M510.4 233.4h15.2l1.6.6.9-1.8-2.7-.2-2.6-1.2v-12l-2.5-.4-2.7 3.6-7.3 2.8z"
}), React.createElement("path", {
  fill: "#5f6cb0",
  d: "M424.6 178.9l4.5.1.4.5 19.6.4.3-17.3-1.9-2.6-3.5.2-1.4-2.7-1.7.2-2.5-1.7 1.8-2.3-3.7-.9-.8 3.3-1 1-2.4.2-.5-1.6-2.3-.9-.8 1.4-1.4-1.1-.7-3.4-1.6-1.1-.4.3z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M424.6 178.9l4.5.1.4.5 19.6.4.3-17.3-1.9-2.6-3.5.2-1.4-2.7-1.7.2-2.5-1.7 1.8-2.3-3.7-.9-.8 3.3-1 1-2.4.2-.5-1.6-2.3-.9-.8 1.4-1.4-1.1-.7-3.4-1.6-1.1-.4.3z"
}), React.createElement("path", {
  fill: "#5b67ae",
  d: "M267.3 85.3l-.1-23.4h-23.9v23.4z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M267.3 85.3l-.1-23.4h-23.9v23.4z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M390.3 393.9l5.1 5.6 16.3-13.8 1.6-6.2v-3.6l3.2-3.2-8.2-7.1-12.3 7.7-1.5-.9-9.9 14.9z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M390.3 393.9l5.1 5.6 16.3-13.8 1.6-6.2v-3.6l3.2-3.2-8.2-7.1-12.3 7.7-1.5-.9-9.9 14.9z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M388.1 421.6l2 1.9 1.6 4.4 2.2 1 1-.4 2.8.8.2 2.9 2.7.8 2 1.8.7-.5 2.4 1.2 9.5-8.2-1-2.8 1-8.3-1.2-2.8-2-1.7-2.6.9-2.1-2.4-3.4-1.5z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M388.1 421.6l2 1.9 1.6 4.4 2.2 1 1-.4 2.8.8.2 2.9 2.7.8 2 1.8.7-.5 2.4 1.2 9.5-8.2-1-2.8 1-8.3-1.2-2.8-2-1.7-2.6.9-2.1-2.4-3.4-1.5z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M213.1 248.1l.1 22.4 22.2.1.1-22.5z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M213.1 248.1l.1 22.4 22.2.1.1-22.5z"
}), React.createElement("path", {
  fill: "#5b68ae",
  d: "M321.4 340.2l.1 7.7 31.2-.2-.2-18.3h-31.2z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M321.4 340.2l.1 7.7 31.2-.2-.2-18.3h-31.2z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M239.5 202.6l5.9-.4v-22.3l-22.7.1v22.7z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M239.5 202.6l5.9-.4v-22.3l-22.7.1v22.7z"
}), React.createElement("path", {
  fill: "#6974b3",
  d: "M534.2 376.6l-2.5 3 5.6-2.4-.1-2.2h-1.5z"
}), React.createElement("path", {
  fill: "#6974b3",
  d: "M531.1 379.1l-7.6 3.3-4 3.8 2.1.2 3.1-3.3z"
}), React.createElement("path", {
  fill: "#6974b3",
  d: "M520.6 388.3l-4.8 1.9-8.5 8.3 11-7.5z"
}), React.createElement("path", {
  fill: "#6974b3",
  d: "M500.3 377.1l-.8 4.6 7.7 13.2 7.5-9.4-2.8-3.9 1.8-1.5-4.7-2.6-2.7.6-1.1 1.3-2.7.6z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M534.2 376.6l-2.5 3 5.6-2.4-.1-2.2h-1.5z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M531.1 379.1l-7.6 3.3-4 3.8 2.1.2 3.1-3.3z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M520.6 388.3l-4.8 1.9-8.5 8.3 11-7.5z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M500.3 377.1l-.8 4.5 7.7 13.3 7.5-9.4-2.8-3.9 1.8-1.5-4.7-2.6-2.7.6-1.1 1.3-2.7.6z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M194.1 225.5h.4l-.3-22.7h-37.5v22.7z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M194.1 225.5h.4l-.3-22.7h-37.5v22.7z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M316.7 423l26.7-.4-.2-22.1-26.7-.1z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M316.7 423l26.7-.4-.2-22.1-26.7-.1z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M444.2 263.1l11.4 19.7 19.7-10.6-.3-2.1-1.2-1.4-2.6-.7.1-2.9-4.6-1.6.6-4.6-2.2.3.8-1.8-.8-2.5-1.5.3v-3.3z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M444.2 263.1l11.4 19.7 19.7-10.6-.3-2.1-1.2-1.4-2.6-.7.1-2.9-4.6-1.6.6-4.6-2.2.3.8-1.8-.8-2.5-1.5.3v-3.3z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M496.2 202.6l5.9.1 1-2.7 1.1-1.1v-18.6l-5.7 1.1-2.3-.5z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M496.2 202.6l5.9.1 1-2.7 1.1-1.1v-18.6l-5.7 1.1-2.3-.5z"
}), React.createElement("path", {
  fill: "#7e88bb",
  d: "M462.1 374.8l1.3.7.7 2.4-.5 1.4 1.2.9-1.4 1 2.2 2.3.7-.3 2.3 4.1-.5.8 2.6 1.3.7 2.3 1.2.1 2.2-2.2 2-.9 4.3 1.7 2.8-1.8.8-2.8 1.1-.7-.1-2.1h3.8l1.7-7.1-8.2-4.4-9.4-6.1-6.4 3h-2.7l.8 2.2-1.9.4 1.7.8-.2 2.9z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M462.1 374.8l1.3.7.7 2.4-.5 1.4 1.2.9-1.4 1 2.2 2.2.7-.2 2.3 4.1-.5.8 2.6 1.3.7 2.3 1.2.1 2.2-2.2 2-.9 4.3 1.7 2.8-1.8.8-2.8 1.1-.7-.1-2.1h3.8l1.7-7.1-8.2-4.4-9.4-6.1-6.4 3h-2.7l.8 2.2-1.9.4 1.7.8-.2 2.9z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M288.8 156.8h9.3l.1 1 3.3-.3.4 1.1 2.1.1.2-1.4 2.7.7 1.5 1.4 2-.6 2.7 1.7.8 1.7-.1-18.5-.6 1-2-.4-.5.9-4.6-2.2-.9.5-3.2-.7-1.1.5-9.9-7-.5-.9-1.7.6z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M288.8 156.8h9.3l.1 1 3.3-.3.4 1.1 2.1.1.2-1.4 2.7.7 1.5 1.4 2-.6 2.7 1.7.8 1.7-.1-18.5-.6 1-2-.4-.5.9-4.6-2.2-.9.5-3.2-.7-1.1.5-9.9-7-.5-.9-1.7.6z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M222.4 157.1l22.9-.1v-25.3h-22.9z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M222.4 157.1l22.9-.1v-25.3h-22.9z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M262 225.4l22.5.1.1-22.7-22.4-.2z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M262 225.4l22.5.1.1-22.7-22.4-.2z"
}), React.createElement("path", {
  fill: "#5b68ae",
  d: "M416 373.5l11.7-.3 6.9-8 6.4-8.5-2.3-4.2-1.1-5.1-5.2.3-1.2-1.1-2.3 2.2-7.5 4.3-.3-1-12.8 13.5 8.2 7.1z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M415.9 373.5l11.8-.3 6.9-8 6.4-8.5-2.3-4.2-1.1-5.1-5.2.3-1.2-1.1-2.3 2.2-7.5 4.3-.3-1-12.8 13.5 8.2 7.1z"
}), React.createElement("path", {
  fill: "#5b68ae",
  d: "M453 182.3l19.1-3.1.2-22 .5-.5-3.9-2.5-.4 1.3-4.7 1.3-2.3-.5-2.1.5-1.2 4-2.3.6-2.1-1.1-1.1 1-.7 2.8-1.9.3-.7-1.8-.3 20.2z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M453 182.3l19.1-3.1.2-22 .5-.5-3.9-2.5-.4 1.3-4.7 1.3-2.3-.5-2.1.5-1.2 4-2.3.6-2.1-1.1-1.1 1-.7 2.8-1.9.3-.7-1.8-.3 20.2z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M419.1 304.6l20.7-12-8.9-15.4-20.9 12.4z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M419.1 304.6l20.7-12-8.9-15.4-20.9 12.4z"
}), React.createElement("path", {
  fill: "#5b68ae",
  d: "M369.3 256.8l15-8.7-3.5-7.6-5.4-14.4-17.8-.1v11.1l-3.3 2 9.8 16.5 3.3-2z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M369.3 256.8l15-8.7-3.5-7.6-5.4-14.4-17.8-.1v11.1l-3.3 2 9.8 16.5 3.3-2z"
}), React.createElement("path", {
  fill: "#616db1",
  d: "M418.4 238.9l6.4 11 24.4-14.3-3-1.6.7-2.7-1.8-1.2-1.5-2.5.3-2.3-1.1-1-24.4-.2z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M418.4 238.9l6.4 11 24.4-14.3-3-1.6.7-2.7-1.8-1.2-1.5-2.5.3-2.3-1.1-1-24.4-.2z"
}), React.createElement("path", {
  fill: "#818bbc",
  d: "M19.9 280.4l5.1 3.2 3.4.5 1.7-1.9-.1-2.8h-1.5l-.2-26.9H1.2l.3 4.2-1.5 1.1 1.8 3.7 2.5 1 2.5 3 1.7-.8 3.1 1.7 3.2 5.3 1.2 3.5 1.5 1.1 1.1 3z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M19.9 280.4l5.1 3.2 3.4.5 1.7-1.9-.1-2.8h-1.5l-.2-26.9H1.2l.3 4.2-1.5 1.1 1.8 3.7 2.5 1 2.5 3 1.7-.8 3.1 1.7 3.2 5.3 1.2 3.5 1.5 1.1 1.1 3z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M260.2 373.7h30.1l-.2-2.7-2-1.7 1.7-.7-.5-2.6 1-1-.9-2.4 1.4-2.7.5-6.5.8.1.2-3 2.2.5h7l.1-11-41.4.1z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M260.2 373.7h30.1l-.2-2.7-2-1.7 1.7-.7-.5-2.6 1-1-.9-2.4 1.4-2.7.5-6.5.8.1.2-3 2.2.5h7l.1-11-41.4.1z"
}), React.createElement("path", {
  fill: "#616eb1",
  d: "M168.4 270.5h22.4v-22.4h-22.4z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M168.4 270.5h22.4v-22.4h-22.4z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M338 248.5l19.6-11.4V226l-28-.1-.1 22.6z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M338 248.5l19.6-11.4V226l-28-.1-.1 22.6z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M343.3 452l.2 34.7 7.6-.1 4.5.7-.1 3.8 12.7.1-.1-39.3z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M343.3 452l.2 34.7 7.6-.1 4.5.7-.1 3.8 12.7.1-.1-39.3z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M249.5 108.5h17.7l.1-23.2h-24l-.2 23.2z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M249.5 108.5h17.7l.1-23.2h-24l-.2 23.2z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M285.9 422.6V445l31.5-.3-.1-21.7z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M285.9 422.6V445l31.5-.3-.1-21.8z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M245.3 157l.1 22.9h22.8v-23z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M245.3 157l.1 22.9h22.8v-23z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M397 414.3l6.9-5.6 3.4 1.5 1.5 1.6 14.4-12-11.5-14.1-22.6 18.9z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M397 414.3l6.9-5.6 3.4 1.5 1.5 1.6 14.4-12-11.5-14.1-22.6 18.9z"
}), React.createElement("path", {
  fill: "#818bbc",
  d: "M420.8 201.5l8.2-.2.5-21.8-.4-.5-23.7-.8-.7 23z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M420.8 201.5l8.2-.2.5-21.8-.4-.5-23.7-.8-.7 23z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M496.2 180.9l-2.8-.7-5.3-3.4-1.4.5-1.6-1.5-3.5-.6-1.7.8-3.4-1.2-2.9 1.8-1.4-.1-.2 12.7 3.6-2.1.9-1.9 3.7-.3 4-3 3.6.6 4.4-1.3 2.6.6z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M496.2 180.9l-2.8-.7-5.3-3.4-1.4.5-1.6-1.5-3.5-.6-1.7.8-3.4-1.2-2.9 1.8-1.4-.1-.2 12.7 3.6-2.1.9-1.9 3.7-.3 4-3 3.6.6 4.4-1.3 2.6.6z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M180.3 108.6h15.6l.1-23.3h-38.3v23.2z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M180.3 108.6h15.6l.1-23.3h-38.3v23.2z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M194.5 225.5l22.5-.1-.2-22.7-22.6.1z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M194.5 225.5l22.5-.1-.2-22.7-22.6.1z"
}), React.createElement("path", {
  fill: "#dcdcdc",
  d: "M442.8 224.3l.3.1.2-22.8-22.5-.4-.3 23z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M442.8 224.3l.3.1.2-22.8-22.5-.4-.3 23z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M196.2 38.3V14.1h-38.5l.1 24.2z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M196.2 38.3V14.1h-38.5l.1 24.2z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M75.6 321.1l35.7-22.6 3.4-45.9-39.1-.1.5 59.8h-.4z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M75.6 321.1l35.7-22.6 3.4-45.9-39.1-.1.5 59.8h-.4z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M222.4 157.1l.3 22.9 22.7-.1-.1-22.9z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M222.4 157.1l.3 22.9 22.7-.1-.1-22.9z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M213.5 321.6h2.6l2.4 1.7-.4 1.6.7 1.9-1.5 1.5-.8 3.2-1.2-.7-.6 2.5 3.6 3.4-3.6 1.8-.8 1.6h34.9v-40.4l-62.5-.2 2.6.9 2.2 1.8 3.4.1 2.7 1.9 2.7.4 2-.6 1.8.5 5.1 3.9-.7 1.1 1.4.9 1.9 6.2.3 2.5z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M213.5 321.6h2.6l2.4 1.7-.4 1.6.7 1.9-1.5 1.5-.8 3.2-1.2-.7-.6 2.5 3.6 3.4-3.6 1.8-.8 1.6h34.9v-40.4l-62.5-.2 2.6.9 2.2 1.8 3.4.1 2.7 1.9 2.7.4 2-.6 1.8.5 5.1 3.9-.7 1.1 1.4.9 1.9 6.2.3 2.5z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M186.3 299.5h3.9l-.8-29h-19.6l-.1 18.4 4-1.7 4.3 2.8 2.6.5 2.8 2 1.2 1.7v3.3z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M186.3 299.5h3.9l-.8-29h-19.6l-.1 18.4 4-1.7 4.3 2.8 2.6.5 2.8 2 1.2 1.7v3.3z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M268.2 156.9l20.6-.1V136l1.7-.6.5.9v-4.6l-22.8-.1z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M268.2 156.9l20.6-.1V136l1.7-.6.5.9v-4.6l-22.8-.1z"
}), React.createElement("path", {
  fill: "#5d6aaf",
  d: "M370.5 280.2l12 20.2 21.4-12.9-11.9-20z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M370.5 280.2l12 20.2 21.4-12.9-11.9-20z"
}), React.createElement("path", {
  fill: "#5b68ae",
  d: "M405.4 178.2l19.2.7v-28l-2.2.3.4 3-1.6 2.2-1.5-.7-1.3.9 1.7 1.2-1.8.5v3.7l-1 1-1.7-.2-1.9-2-.1-3.6 1.3-.6-.8-3.2-1.1-.8-1.6.8-.4 2-3.3-1.1-1.8 3.4-3.1-.2-.9-1 .5-2.6-1.4-1.3-.1 25.4z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M405.4 178.2l19.2.7v-28l-2.2.3.4 3-1.6 2.2-1.5-.7-1.3.9 1.7 1.2-1.8.5v3.7l-1 1-1.7-.2-1.9-2-.1-3.6 1.3-.6-.8-3.2-1.1-.8-1.6.8-.4 2-3.3-1.1-1.8 3.4-3.1-.2-.9-1 .5-2.6-1.4-1.3-.1 25.4z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M285.8 299.4l22.4.1.1-20.8-1.1 1.3-2.1-1.6 1-1.5-1.7-.6.8-.8-2.1-1.1-17.1-.2z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M285.8 299.4l22.4.1.1-20.8-1.1 1.3-2.1-1.6 1-1.5-1.7-.6.8-.8-2.1-1.1-17.1-.2z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M338 248.5l11.2 19.5 7.7-1.2 1.2 2.1 13.5-8.2-4.2-7.1-3.3 2-9.8-16.5z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M338 248.5l11.2 19.5 7.7-1.2 1.2 2.1 13.5-8.2-4.2-7.1-3.3 2-9.8-16.5z"
}), React.createElement("path", {
  fill: "#606cb0",
  d: "M350.1 367.6l1.9.2 2.2-1 1.1 1 4.7-.1 3.6 1-1.8 1v2l1.6.5-.1 1.7 1.5 1.3 9.7-4.5 4-3.5-1.4-4.8-11.7-9.6z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M350.1 367.6l1.9.2 2.2-1 1.1 1 4.7-.1 3.6 1-1.8 1v2l1.6.5-.1 1.7 1.5 1.3 9.7-4.5 4-3.5-1.4-4.8-11.7-9.6z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M427.7 373.2l1.4.9.4 2 1.8-.1 10.1 12.2-4.3 3.6.8.8 12.8-8.1 1.8-5.3 5.8-6-1.1-1.2-2.4-.4-.7-2.6-1.8-2-.8-2.9-3.6-.5-5.4-4.2-1.5-2.7-6.4 8.5z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M427.7 373.2l1.4.9.4 2 1.8-.1 10.1 12.2-4.3 3.6.8.8 12.8-8.1 1.8-5.3 5.8-6-1.1-1.2-2.4-.4-.7-2.6-1.8-2-.8-2.9-3.6-.5-5.4-4.2-1.5-2.7-6.4 8.5z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M267.2 108.5l23.7.1V85.3h-23.6z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M267.2 108.5l23.7.1V85.3h-23.6z"
}), React.createElement("path", {
  fill: "#8991bf",
  d: "M429 201.3l24 .3v-19.3l-3.9.5v-2.9l-19.6-.4z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M429 201.3l24 .3v-19.3l-3.9.5v-2.9l-19.6-.4z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M303.1 274.4l2.1 1.1-.8.8 1.7.6-1 1.5 2.1 1.6 1.1-1.3 2.8.5 1.1 3 3.3-1.1-.5-1.3 5.9 3.1 3.2-3.7 1.7.8.3-31.5-22.7-.2z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M303.1 274.4l2.1 1.1-.8.8 1.7.6-1 1.5 2.1 1.6 1.1-1.3 2.8.5 1.1 3 3.3-1.1-.5-1.3 5.9 3.1 3.2-3.7 1.7.8.3-31.5-22.7-.2z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M254.8 268.2l25.8.2v-20.1l-25.7-.2z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M254.8 268.2l25.8.2v-20.1l-25.7-.2z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M177.3 180.4l-.9-23h-18.9l-.4 23z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M177.3 180.4l-.9-23h-18.9l-.4 23z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M360 176.2h19.3l.1-22.2.9-1.3-.6-1.2 1-2.8-1.1-.9-1.9.7-3-.5.1-2-1.6-1.6 1.3-2.7-.5-1.3-1.7.3-1.3 1.4-2.8-1h-2.9l-2.8-1.2-1.5 1.5-1.1 2.4z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M360 176.2h19.3l.1-22.2.9-1.3-.6-1.2 1-2.8-1.2-.9-1.8.7-3-.5.1-2-1.6-1.6 1.3-2.7-.5-1.3-1.7.3-1.3 1.4-2.8-1h-2.9l-2.8-1.2-1.5 1.5-1.1 2.4z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M291 131.7l-.1-23.1-18.2-.1-.1 23.1z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M291 131.7l-.1-23.1-18.2-.1-.1 23.1z"
}), React.createElement("path", {
  fill: "#5c69ae",
  d: "M491 248.2l.2 3.4-1.3 3 1.4 1.8-.7 1.2-.2 3.1 1.3.4.5 3.5 2.7 1.6 2.1 2.6.8 4.7 2.8 1.2 1.4-.7 1.6 1.1-.2 1.2 2.2 1.8-.3 1.8 1.5.2 2.8 2 6-5.2-2.5-2.7-1.9-5.9v-3l1.8-.5-2.2-1 1.7-3.3h-2.1v-15.1l-20.8.2z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M491 248.2l.2 3.4-1.3 3 1.4 1.8-.7 1.2-.2 3.1 1.3.4.5 3.5 2.7 1.6 2.1 2.6.8 4.7 2.8 1.2 1.4-.7 1.6 1.1-.2 1.2 2.2 1.8-.3 1.8 1.5.2 2.8 2 6-5.2-2.5-2.7-1.9-5.9v-3l1.8-.5-2.2-1 1.7-3.3h-2.1v-15.1l-20.8.2z"
}), React.createElement("path", {
  fill: "#5b68ae",
  d: "M510.6 360.6l.6 1.2 2.6 1.7-.3 3-1.4 2.5 1.3.9-.6 1.3 2.5.1 2.6-4.4 3.3-1.6 1.9 1.7-.4 6.3-2.6 5.4 9.5-2.4 3.3.7 1.3-.4 1.5-1.6h1.5l.1 2.2.7-.3-.2-16.5z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M510.6 360.6l.6 1.2 2.6 1.7-.3 3-1.4 2.5 1.3.9-.6 1.3 2.5.1 2.6-4.4 3.3-1.6 1.9 1.7-.4 6.3-2.6 5.4 9.5-2.4 3.3.7 1.3-.4 1.5-1.6h1.5l.1 2.2.7-.3-.2-16.5z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M199.4 131.6h4v-23.1l-23.1.1v23z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M199.4 131.6h4v-23.1l-23.1.1v23z"
}), React.createElement("path", {
  fill: "#5b68ae",
  d: "M551.6 206.9v-20.4l-.6-1.4-3.6.2-1.2-.9-2.3.8-.5 2.5-6.5-.4-1.6-1.5-4.5.1-.5.8-3.9 1.1-1.4-1.2-.1 20.4z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M551.6 206.9v-20.4l-.6-1.4-3.6.2-1.2-.9-2.3.8-.5 2.5-6.5-.4-1.6-1.5-4.5.1-.5.8-3.9 1.1-1.4-1.2-.1 20.4z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M243.3 85.3V61.5l-23.5.1v23.7z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M243.3 85.3V61.5l-23.5.1v23.7z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M503.1 205.8l18.9-.1-2.2-1.2-2.2-2.9-1.9-1.2-3.6-3.6-4.3.2-2.6 2-1-.1-1.1 1.1z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M503.1 205.8l18.9-.1-2.2-1.2-2.2-2.9-1.9-1.2-3.6-3.6-4.3.2-2.6 2-1-.1-1.1 1.1z"
}), React.createElement("path", {
  fill: "#6c77b5",
  d: "M384.5 549.7l1.1 1.1 1.5-.7 1.6 1.6 2.6-.5 2.7.5 2.7 4.4 1.5.1 1.2 2.4 2.8.1.1 1.5 3.5.7.7-2.3-.7-1 1.1-1.2 3.2-.2 3-1.4 2.7.4-.3-3.5-4.3 3.1.6-4.9-3.3-2.8.8-3.3-2-6.9-3.4-1.9-1.3 2.2-2.7-.4-.8 1.7-14.6-2.4z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M384.5 549.7l1.1 1.1 1.5-.7 1.6 1.6 2.6-.5 2.7.5 2.7 4.4 1.5.1 1.2 2.4 2.8.1.1 1.5 3.5.7.7-2.3-.7-1 1.1-1.2 3.2-.2 3-1.4 2.7.4-.3-3.5-4.3 3.1.6-4.9-3.3-2.8.8-3.3-2-6.9-3.4-1.9-1.3 2.2-2.7-.4-.8 1.7-14.6-2.4z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M307 248.4l22.5.1.1-22.6h-22.5z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M307 248.4l22.5.1.1-22.6h-22.5z"
}), React.createElement("path", {
  fill: "#5b67ae",
  d: "M449.1 421.3l2.7 1.6v-1.7z"
}), React.createElement("path", {
  fill: "#5b67ae",
  d: "M430.1 446.7l-1.3 4.9 7.1-6 10.8-6.6 2.3-2.9-13.8 8.9z"
}), React.createElement("path", {
  fill: "#5b67ae",
  d: "M427 429.6l3.6 3.8 1-.8 3.4 2 2.5 3.7 9.5-5 .8-1.5-6.6-5.9-3.2.5 1.2-3.4-2.2-3.1-2.7 1.6-5.7 1.7-3.4 2.5 1.2 1z"
}), React.createElement("path", {
  fill: "#5b67ae",
  d: "M440.9 419.7l.5 3 5.5 2.1.3-5.2z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M449.1 421.3l2.7 1.6v-1.7z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M430.1 446.7l-1.3 4.9 7.1-6 10.8-6.6 2.3-2.9-13.8 8.9z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M427 429.6l3.6 3.8 1-.8 3.4 2 2.5 3.7 9.5-5 .8-1.5-6.6-5.9-3.2.5 1.2-3.4-2.2-3.1-2.7 1.6-5.7 1.7-3.4 2.5 1.2 1z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M440.9 419.7l.5 3 5.5 2.1.3-5.2z"
}), React.createElement("path", {
  fill: "#5b68ae",
  d: "M383.9 361.9l1.1.7.3 2.2 1.7 2.3 1-.1.6 1.9 3 2.6 2.9.9 1.5.9 12.4-7.8-14.6-14.2-4.9 4.1-1.4 2.1-4.4 3.1z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M383.9 361.9l1.1.7.3 2.2 1.7 2.3 1-.1.6 1.9 3 2.6 2.9.9 1.5.9 12.4-7.8-14.6-14.2-4.9 4.1-1.4 2.1-4.4 3.1z"
}), React.createElement("path", {
  fill: "#5c68ae",
  d: "M358.9 307.9l-.5 2.2 1.3.6.3 1.6h1.9l-2.4 2.6.2 1.6 2.3.3-1.7 2.3.4 1.3-1.4.1 1.6 3.9.1 1.7 2.1.3v3.7l9.8 3 1.3-2.1-.9-1.6 6.7-14.6 5.9-6.1-3.6-6.6-23.1.3-.9 1.1.6 2.9 1.4.5z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M358.9 307.9l-.5 2.2 1.3.6.3 1.6h1.9l-2.4 2.6.2 1.6 2.3.3-1.7 2.3.4 1.3-1.4.1 1.6 3.9.1 1.7 2.1.3v3.7l9.8 3 1.3-2.1-.9-1.6 6.7-14.6 5.9-6.1-3.6-6.6-23.1.3-.9 1.1.6 2.9 1.4.5z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M437.9 339.7l6.4-1.5 6-2.3 2.6-.4.3-3.2-2.2-1.6-.8-3.5h-2.5l-.1-2.1-4.3-2.1-3.7-.9 1.5-2.7-2.3-1.8-15 8.9 1.9.9 2.1 5.2 2.1 1 2.3 2.6 1.3 2.4 2-.1z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M437.9 339.7l6.4-1.5 6-2.3 2.6-.4.3-3.2-2.2-1.6-.8-3.5h-2.5l-.1-2.1-4.3-2.1-3.7-.9 1.5-2.7-2.3-1.8-15 8.9 1.9.9 2.1 5.2 2.1 1 2.3 2.6 1.3 2.4 2-.1z"
}), React.createElement("path", {
  fill: "#5b68ae",
  d: "M325.8 280l4.9.3 2.1-1.5 1 1.1 10.5-7.3.9-3.9 4-.7-11.2-19.5h-11.9z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M325.8 280l4.9.3 2.1-1.5 1 1.1 10.5-7.3.9-3.9 4-.7-11.2-19.5h-11.9z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M355.5 491.1l1.3 1.5v4.6h1.2v4.3l2.1-.1-.2 13.4 19.2.1-.1-23.6z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M355.5 491.1l1.3 1.5v4.6h1.2v4.3l2.1-.1-.2 13.4 19.2.1-.1-23.6z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M245.3 131.7l4.2-.1v-23.1h-23v23.2z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M245.3 131.7l4.2-.1v-23.1h-23v23.2z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M124.9 391.9l3.2 4 7.2 1.2 4.5 4.3.8 1.4 5.9 1.9.8 1.4 2.3-.7 3.3 1 1.6-.7.7-3.7 1.1-1.6 1.8-.6 2.6-4.1 1 .6 2.7-1.8.8-1.4-1.4-.8 1.1-5 1.7-.4.6-1.8-.2-2.4 1-3.9 1.6-1.3.1-2.3h1l.2-1.9 2.1-2.3.8-3.4 2.3.4 2.2-1 1.1.6 1.3-2 5.6.1 1.1-3.1 1.9-1.8-49-39.9-15.8 12.9z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M124.9 391.9l3.2 4 7.2 1.2 4.5 4.3.8 1.4 5.9 1.9.8 1.4 2.3-.7 3.3 1 1.6-.7.7-3.7 1.1-1.6 1.8-.6 2.6-4.1 1 .6 2.7-1.8.8-1.4-1.4-.8 1.1-5 1.7-.4.6-1.8-.2-2.4 1-3.9 1.6-1.3.1-2.3h1l.2-1.9 2.1-2.3.8-3.4 2.3.4 2.2-1 1.1.6 1.3-2 5.6.1 1.1-3.1 1.9-1.8-49-39.9-15.8 12.9z"
}), React.createElement("path", {
  fill: "#636fb1",
  d: "M452.9 335.5l1.1 1.1 3.2-1.3 2.2.7-.2 2 .3-2.7 3-2.4-1.8-.6-1.7-6.3-1.3-1.6 1.1-3.1-.6-2.6.6-3-.8-1.2.6-1.6-2-4.5.3-1.8-1.5-1.3-4.2 2.6-2.2 3-3.1 6.1-4.8 2.4-1.5 2.7 3.7.9 4.3 2.1.1 2.1h2.5l.8 3.5 2.2 1.6z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M452.9 335.5l1.1 1.1 3.2-1.3 2.2.7-.2 2 .3-2.7 3-2.4-1.8-.6-1.7-6.3-1.3-1.6 1.1-3.1-.6-2.6.6-3-.8-1.2.6-1.6-2-4.5.3-1.8-1.5-1.3-4.2 2.6-2.2 3-3.1 6.1-4.8 2.4-1.5 2.7 3.7.9 4.3 2.1.1 2.1h2.5l.8 3.5 2.2 1.6z"
}), React.createElement("path", {
  fill: "#6a75b4",
  d: "M487.5 413.7l5.4-1.9 6.6-6.4 3.7-9.4 4-1.1-7.7-13.2.8-4.6-1.7.1-.4-2-2.9-.3-.8.7-3.3.3-1.7 7.1h-3.8l.1 2.1-1.1.7-.8 2.8-2.8 1.8-4.3-1.7-2 .9-3.3 3.9 1.3 1.3-.1 4.8 3.4 2.7-.7.7.8 3.6 3.9.2 1.4 1.3.2 1.7 2.2 1.7 1 2z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M487.5 413.7l5.4-1.9 6.6-6.4 3.7-9.4 4-1.1-7.7-13.3.8-4.5-1.7.1-.4-2-2.9-.3-.8.7-3.3.3-1.7 7.1h-3.8l.1 2.1-1.1.7-.8 2.8-2.8 1.8-4.3-1.7-2 .9-3.3 3.9 1.3 1.3-.1 4.8 3.4 2.7-.7.7.8 3.6 3.9.2 1.4 1.3.2 1.7 2.2 1.7 1 2z"
}), React.createElement("path", {
  fill: "#5e6aaf",
  d: "M525 186.6l1.4 1.2 3.9-1.1.5-.8 4.5-.1 1.6 1.5 6.5.4.5-2.5 2.3-.8 1.2.9 3.6-.2.6 1.4v-14.7l-1.7-1.3-2.8.6-1.7-1.6-1.5 2.1-2.5-.1-.3-1.3-1.1 1.6-1.6-.8-.4 1.2-1.5-.1-4.3-4.8-1.5 1-.3-1.2-1.6.8.8-1.8-2 .8-1.3-2-.8 1-1.2-1.6-.8.5-2.7-1v19.7l.7 1 1.7-.2z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M525 186.6l1.4 1.2 3.9-1.1.5-.8 4.5-.1 1.6 1.5 6.5.4.5-2.5 2.3-.8 1.2.9 3.6-.2.6 1.4v-14.7l-1.7-1.3-2.8.6-1.7-1.6-1.5 2.1-2.5-.1-.3-1.3-1.1 1.6-1.6-.8-.4 1.2-1.5-.1-4.3-4.8-1.5 1-.3-1.2-1.6.8.8-1.8-2 .8-1.3-2-.8 1-1.2-1.6-.8.5-2.7-1v19.7l.7 1 1.7-.2z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M378.2 251.7l10.4 17.7 3.4-1.9 3.7 6.3 14.4-8.1-2.2-2.4 2.1-2.5-2.3-.1-2.3-1.5 1-1-3.4-2.2 2.6-2-1.9-1.8-2.8-.5-.2-2.2.9-1.4-1-2.7 1.6-1.2-.8-.6-1.6.6-.2 1.5-2.3-.9v-1.3l-2.7-1.6z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M378.2 251.7l10.4 17.7 3.4-1.9 3.7 6.3 14.4-8.1-2.2-2.4 2.1-2.5-2.3-.1-2.3-1.5 1-1-3.4-2.2 2.6-2-1.9-1.8-2.8-.5-.2-2.2.9-1.4-1-2.7 1.6-1.2-.8-.6-1.6.6-.2 1.5-2.3-.9v-1.3l-2.7-1.6z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M216.8 202.7l.2 22.7h22.5v-22.8z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M216.8 202.7l.2 22.7h22.5v-22.8z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M352.5 329.4l.2 18.3 7.6 10.2 5.1-5.1 5.4-16.1 2.1-3.6-12.5-3.8z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M352.5 329.4l.2 18.3 7.6 10.2 5.1-5.1 5.4-16.1 2.1-3.6-12.5-3.8z"
}), React.createElement("path", {
  fill: "#c1c3d1",
  d: "M343.2 392.4l17.4 6.9 12-16.5.3-2-1.6.2-3.1-3.8-.9.7-1.9-1.1-.6-1.6-1.5-1.3.1-1.7-1.6-.5v-2l1.8-1-3.6-1-4.7.1-1.1-1-2.2 1-1.9-.2-5.8 1.2-1.2 1.5z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M343.2 392.4l17.4 6.9 12-16.5.3-2-1.6.2-3.1-3.8-.9.7-1.9-1.1-.6-1.6-1.5-1.3.1-1.7-1.6-.5v-2l1.8-1-3.6-1-4.7.1-1.1-1-2.2 1-1.9-.2-5.8 1.2-1.2 1.5z"
}), React.createElement("path", {
  fill: "#6974b4",
  d: "M382.3 302.1l3.6 6.6 8.9 1.8 13.6 6 2.5-7 8.2-4.9-9.1-15-2.8 1.8-3.3-3.9-21.4 12.9z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M382.3 302.1l3.6 6.6 8.9 1.8 13.6 6 2.5-7 8.2-4.9-9.1-15-2.8 1.8-3.3-3.9-21.4 12.9z"
}), React.createElement("path", {
  fill: "#5b68ae",
  d: "M386.4 446l10.9 2.4 8.4-12.9-2.4-1.2-.7.5-2-1.8-2.7-.8-.2-2.9-2.8-.8-1 .4-2.2-1-1.6-4.4-2-1.9-2-.1-4.1-2.4-7.5 2.7 12.3 23.9z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M386.4 446l10.9 2.4 8.4-12.9-2.4-1.2-.7.5-2-1.8-2.7-.8-.2-2.9-2.8-.8-1 .4-2.2-1-1.6-4.4-2-1.9-2-.1-4.1-2.4-7.5 2.7 12.3 23.9z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M313.8 156.9l.2 22.9 22.7.1v-23z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M313.8 156.9l.2 22.9 22.7.1v-23z"
}), React.createElement("path", {
  fill: "#5d6aaf",
  d: "M393.8 351.3l14.6 14.2 12.7-13.4-2.5-10.5-5.1-4-7.5-4.1-5.4 10.6z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M393.8 351.3l14.6 14.2 12.7-13.4-2.5-10.5-5.1-4-7.5-4.1-5.4 10.6z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M308.3 373.5l27.1.2-.1 3 2.5.1 6.5-8-17.4-8.8-4.5-.4-14.1-.2z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M308.3 373.5l27.1.2-.1 3 2.5.1 6.5-8-17.4-8.8-4.5-.4-14.1-.2z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M157.5 157.4h18.9v-25.8h-18.8z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M157.5 157.4h18.9v-25.8h-18.8z"
}), React.createElement("path", {
  fill: "#5b68ae",
  d: "M441 356.7l1.5 2.7 5.4 4.2 3.6.5.8 2.9 1.8 2 .7 2.6 2.4.4 1.1 1.2 2.6.5 1.2 1.1 2.8-.1.2-2.9-1.7-.8 1.9-.4-1.5-6-2.3-.3-.9-1.5 1.3-2-1.5-1-.2-1.7 1.6-1.4-1-4.5-1.2-1-.8.8-5.6-2.2-9.9 1.6h-3l-1.6 1.1z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M441 356.7l1.5 2.7 5.4 4.2 3.6.5.8 2.9 1.8 2 .7 2.6 2.4.4 1.1 1.2 2.6.5 1.2 1.1 2.8-.1.2-2.9-1.7-.8 1.9-.4-1.5-6-2.3-.3-.9-1.5 1.3-2-1.5-1-.2-1.7 1.6-1.4-1-4.5-1.2-1-.8.8-5.6-2.2-9.9 1.6h-3l-1.6 1.1z"
}), React.createElement("path", {
  fill: "#5c69ae",
  d: "M343.2 400.5l.2 22.1h20.3l.1 1.8 10.3-8.7-13.5-16.4-17.4-6.9z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M343.2 400.5l.2 22.1h20.3l.1 1.8 10.3-8.7-13.5-16.4-17.4-6.9z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M219.6 108.5h23.5l.2-23.2h-23.5z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M219.6 108.5h23.5l.2-23.2h-23.5z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M336.7 179.9l23.3.1-.1-23.2-23.2.1z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M336.7 179.9l23.3.1-.1-23.2-23.2.1z"
}), React.createElement("path", {
  fill: "#5b68ae",
  d: "M420.6 444.8l2.2 3.6 3.3-.3 4.4-4.2.9-4.9-14.6 2.3.9 2.3z"
}), React.createElement("path", {
  fill: "#5b68ae",
  d: "M427.8 448.3l-4 5.4-4 8.7 9-10.8z"
}), React.createElement("path", {
  fill: "#5b68ae",
  d: "M414.1 456.2l2.2 3.5 4.5-7.3.3-3.2-4.8 3.3z"
}), React.createElement("path", {
  fill: "#5b68ae",
  d: "M419.7 461.5v-.1l-.1-.1z"
}), React.createElement("path", {
  fill: "#5b68ae",
  d: "M418.8 459l.1.4-.2-.5z"
}), React.createElement("path", {
  fill: "#5b68ae",
  d: "M418.9 459.4l.2.6v-.2z"
}), React.createElement("path", {
  fill: "#5b68ae",
  d: "M410.8 451.1l3.2 5 1.6-3-4-1.4z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M420.6 444.8l2.2 3.6 3.3-.3 4.4-4.2.9-4.9-14.6 2.3.9 2.3z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M427.8 448.3l-4 5.4-4 8.7 9-10.8z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M414.1 456.2l2.2 3.5 4.5-7.3.3-3.2-4.8 3.3z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M419.7 461.5v-.1l-.1-.1z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M418.8 459l.1.4-.2-.5z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M418.9 459.4l.2.6v-.2z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M410.8 451.1l3.2 5 1.6-3-4-1.4z"
}), React.createElement("path", {
  fill: "#5d6aaf",
  d: "M509.6 282.1l2 2-.2 1.9 2.6.9.2 3.8 1 .4 1.4 5.3 4.6 2.2 5.4 1 2.3 1.3 4.6 1.3 14.3-3.4-2.7-1.8-1.4-2.1-1.7-.2-2.8-2.3-2.5-2.5-.5-1.5-2.4-.9-2.3-4.6-1.5.6-.8-1.9-5.7-.8-5.3-2-.8.3-1.8-2.2z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M509.6 282.1l2 2-.2 1.9 2.6.9.2 3.8 1 .4 1.4 5.3 4.6 2.2 5.4 1 2.3 1.3 4.6 1.3 14.3-3.4-2.7-1.8-1.4-2.1-1.7-.2-2.8-2.3-2.5-2.5-.5-1.5-2.4-.9-2.3-4.6-1.5.6-.8-1.9-5.7-.8-5.3-2-.8.3-1.8-2.2z"
}), React.createElement("path", {
  fill: "#5a67ae",
  d: "M156.7 225.5l.1 22.6h37.3v-22.6z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M156.7 225.5l.1 22.6h37.3v-22.6z"
}), React.createElement("path", {
  fill: "#5c69af",
  d: "M463.7 252.3l-.1 2.9 1.5-.3.8 2.5-.8 1.8 2.2-.3-.6 4.6 4.6 1.6-.1 2.9 2.6.7 1.2 1.4.3 2.1.8 1.1 1.4-2.9 1.1 1.9-.8 1.7.6 1.5-1.6.2.5 2.4 4.1-1.2-.2-.7 16.6-2.7-.8-4.7-2.1-2.6-2.7-1.6-.5-3.5-1.3-.4.2-3.1.7-1.2-1.4-1.8 1.3-3-.2-3.4z"
}), React.createElement("path", {
  fill: "none",
  strokeLinejoin: "bevel",
  strokeWidth: 0.75,
  d: "M463.7 252.3l-.1 2.9 1.5-.3.8 2.5-.8 1.8 2.2-.3-.6 4.6 4.6 1.6-.1 2.9 2.6.7 1.2 1.4.3 2.1.8 1.1 1.4-2.9 1.1 1.9-.8 1.7.6 1.5-1.6.2.5 2.4 4.1-1.2-.2-.7 16.6-2.7-.8-4.7-2.1-2.6-2.7-1.6-.5-3.5-1.3-.4.2-3.1.7-1.2-1.4-1.8 1.3-3-.2-3.4z"
}));

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  id: "Triangle"
}, React.createElement("path", {
  fill: "none",
  stroke: "#fb7d74",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 4,
  d: "M429 212.8l-74.2 169.7L490.1 361z"
}), React.createElement("g", {
  fill: "#fb7d74",
  fontSize: 13
}, React.createElement("text", {
  fontFamily: "Montserrat-Bold",
  transform: "translate(373.2 74.4)"
}, "Texas Triangle"), React.createElement("text", {
  fontFamily: "Montserrat-Bold",
  transform: "translate(373.2 90)"
}, "85% of population"), React.createElement("text", {
  fontFamily: "Montserrat-Regular",
  transform: "translate(373.2 110)"
}, "Houston, Dallas-Fort Worth,"), React.createElement("text", {
  fontFamily: "Montserrat-Regular",
  transform: "translate(373.2 125.6)"
}, "San Antonio, and Austin")));

var SvgS2Colors = function SvgS2Colors(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    id: "Map",
    x: 0,
    y: 0,
    viewBox: "0 0 575 575",
    xmlSpace: "preserve"
  }, props), React.createElement("title", null, title), _ref2, _ref3, _ref4, _ref5);
};

export default __webpack_public_path__ + "s2.colors.3592804b.svg";
export { SvgS2Colors as ReactComponent };